export const address = [
    {
        areaCode: '0101',
        areaName: '黑龙江省',
        areaLevel: '2',
        parentCode: '01',
        children: [
            {
                areaCode: '010101',
                areaName: '大庆市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010101',
                        areaName: '大同区',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010102',
                        areaName: '杜尔伯特蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010103',
                        areaName: '红岗区',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010104',
                        areaName: '林甸县',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010105',
                        areaName: '龙凤区',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010106',
                        areaName: '让胡路区',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010107',
                        areaName: '萨尔图区',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010108',
                        areaName: '肇源县',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                    {
                        areaCode: '01010109',
                        areaName: '肇州县',
                        areaLevel: '4',
                        parentCode: '010101',
                    },
                ],
            },
            {
                areaCode: '010102',
                areaName: '大兴安岭地区',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010201',
                        areaName: '呼玛县',
                        areaLevel: '4',
                        parentCode: '010102',
                    },
                    {
                        areaCode: '01010202',
                        areaName: '漠河县',
                        areaLevel: '4',
                        parentCode: '010102',
                    },
                    {
                        areaCode: '01010203',
                        areaName: '塔河县',
                        areaLevel: '4',
                        parentCode: '010102',
                    },
                ],
            },
            {
                areaCode: '010103',
                areaName: '哈尔滨市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010301',
                        areaName: '阿城区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010302',
                        areaName: '巴彦县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010303',
                        areaName: '宾县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010304',
                        areaName: '道里区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010305',
                        areaName: '道外区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010306',
                        areaName: '方正县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010307',
                        areaName: '呼兰区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010308',
                        areaName: '木兰县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010309',
                        areaName: '南岗区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010310',
                        areaName: '平房区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010311',
                        areaName: '尚志市',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010312',
                        areaName: '双城区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010313',
                        areaName: '松北区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010314',
                        areaName: '通河县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010315',
                        areaName: '五常市',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010316',
                        areaName: '香坊区',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010317',
                        areaName: '延寿县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                    {
                        areaCode: '01010318',
                        areaName: '依兰县',
                        areaLevel: '4',
                        parentCode: '010103',
                    },
                ],
            },
            {
                areaCode: '010104',
                areaName: '鹤岗市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010401',
                        areaName: '东山区',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010402',
                        areaName: '工农区',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010403',
                        areaName: '萝北县',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010404',
                        areaName: '南山区',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010405',
                        areaName: '绥滨县',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010406',
                        areaName: '向阳区',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010407',
                        areaName: '兴安区',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                    {
                        areaCode: '01010408',
                        areaName: '兴山区',
                        areaLevel: '4',
                        parentCode: '010104',
                    },
                ],
            },
            {
                areaCode: '010105',
                areaName: '黑河市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010501',
                        areaName: '爱辉区',
                        areaLevel: '4',
                        parentCode: '010105',
                    },
                    {
                        areaCode: '01010502',
                        areaName: '北安市',
                        areaLevel: '4',
                        parentCode: '010105',
                    },
                    {
                        areaCode: '01010503',
                        areaName: '嫩江县',
                        areaLevel: '4',
                        parentCode: '010105',
                    },
                    {
                        areaCode: '01010504',
                        areaName: '孙吴县',
                        areaLevel: '4',
                        parentCode: '010105',
                    },
                    {
                        areaCode: '01010505',
                        areaName: '五大连池市',
                        areaLevel: '4',
                        parentCode: '010105',
                    },
                    {
                        areaCode: '01010506',
                        areaName: '逊克县',
                        areaLevel: '4',
                        parentCode: '010105',
                    },
                ],
            },
            {
                areaCode: '010106',
                areaName: '佳木斯市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010601',
                        areaName: '东风区',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010602',
                        areaName: '富锦市',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010603',
                        areaName: '抚远县',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010604',
                        areaName: '桦川县',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010605',
                        areaName: '桦南县',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010606',
                        areaName: '郊区',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010607',
                        areaName: '前进区',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010608',
                        areaName: '汤原县',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010609',
                        areaName: '同江市',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                    {
                        areaCode: '01010610',
                        areaName: '向阳区',
                        areaLevel: '4',
                        parentCode: '010106',
                    },
                ],
            },
            {
                areaCode: '010107',
                areaName: '鸡西市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010701',
                        areaName: '城子河区',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010702',
                        areaName: '滴道区',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010703',
                        areaName: '恒山区',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010704',
                        areaName: '虎林市',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010705',
                        areaName: '鸡东县',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010706',
                        areaName: '鸡冠区',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010707',
                        areaName: '梨树区',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010708',
                        areaName: '麻山区',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                    {
                        areaCode: '01010709',
                        areaName: '密山市',
                        areaLevel: '4',
                        parentCode: '010107',
                    },
                ],
            },
            {
                areaCode: '010108',
                areaName: '牡丹江市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010801',
                        areaName: '爱民区',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010802',
                        areaName: '东安区',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010803',
                        areaName: '东宁县',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010804',
                        areaName: '海林市',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010805',
                        areaName: '林口县',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010806',
                        areaName: '穆棱市',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010807',
                        areaName: '宁安市',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010808',
                        areaName: '绥芬河市',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010809',
                        areaName: '西安区',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                    {
                        areaCode: '01010810',
                        areaName: '阳明区',
                        areaLevel: '4',
                        parentCode: '010108',
                    },
                ],
            },
            {
                areaCode: '010109',
                areaName: '齐齐哈尔市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01010901',
                        areaName: '昂昂溪区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010902',
                        areaName: '拜泉县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010903',
                        areaName: '富拉尔基区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010904',
                        areaName: '富裕县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010905',
                        areaName: '甘南县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010906',
                        areaName: '建华区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010907',
                        areaName: '克东县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010908',
                        areaName: '克山县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010909',
                        areaName: '龙江县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010910',
                        areaName: '龙沙区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010911',
                        areaName: '梅里斯达斡尔族区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010912',
                        areaName: '讷河市',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010913',
                        areaName: '碾子山区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010914',
                        areaName: '泰来县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010915',
                        areaName: '铁锋区',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                    {
                        areaCode: '01010916',
                        areaName: '依安县',
                        areaLevel: '4',
                        parentCode: '010109',
                    },
                ],
            },
            {
                areaCode: '010110',
                areaName: '七台河市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01011001',
                        areaName: '勃利县',
                        areaLevel: '4',
                        parentCode: '010110',
                    },
                    {
                        areaCode: '01011002',
                        areaName: '茄子河区',
                        areaLevel: '4',
                        parentCode: '010110',
                    },
                    {
                        areaCode: '01011003',
                        areaName: '桃山区',
                        areaLevel: '4',
                        parentCode: '010110',
                    },
                    {
                        areaCode: '01011004',
                        areaName: '新兴区',
                        areaLevel: '4',
                        parentCode: '010110',
                    },
                ],
            },
            {
                areaCode: '010111',
                areaName: '双鸭山市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01011101',
                        areaName: '宝清县',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011102',
                        areaName: '宝山区',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011103',
                        areaName: '尖山区',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011104',
                        areaName: '集贤县',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011105',
                        areaName: '岭东区',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011106',
                        areaName: '饶河县',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011107',
                        areaName: '四方台区',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                    {
                        areaCode: '01011108',
                        areaName: '友谊县',
                        areaLevel: '4',
                        parentCode: '010111',
                    },
                ],
            },
            {
                areaCode: '010112',
                areaName: '绥化市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01011201',
                        areaName: '安达市',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011202',
                        areaName: '北林区',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011203',
                        areaName: '海伦市',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011204',
                        areaName: '兰西县',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011205',
                        areaName: '明水县',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011206',
                        areaName: '庆安县',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011207',
                        areaName: '青冈县',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011208',
                        areaName: '绥棱县',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011209',
                        areaName: '望奎县',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                    {
                        areaCode: '01011210',
                        areaName: '肇东市',
                        areaLevel: '4',
                        parentCode: '010112',
                    },
                ],
            },
            {
                areaCode: '010113',
                areaName: '伊春市',
                areaLevel: '3',
                parentCode: '0101',
                children: [
                    {
                        areaCode: '01011301',
                        areaName: '翠峦区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011302',
                        areaName: '带岭区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011303',
                        areaName: '红星区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011304',
                        areaName: '嘉荫县',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011305',
                        areaName: '金山屯区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011306',
                        areaName: '美溪区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011307',
                        areaName: '南岔区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011308',
                        areaName: '上甘岭区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011309',
                        areaName: '汤旺河区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011310',
                        areaName: '铁力市',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011311',
                        areaName: '乌马河区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011312',
                        areaName: '乌伊岭区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011313',
                        areaName: '五营区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011314',
                        areaName: '西林区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011315',
                        areaName: '新青区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011316',
                        areaName: '伊春区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                    {
                        areaCode: '01011317',
                        areaName: '友好区',
                        areaLevel: '4',
                        parentCode: '010113',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0102',
        areaName: '吉林省',
        areaLevel: '2',
        parentCode: '01',
        children: [
            {
                areaCode: '010201',
                areaName: '白城市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020101',
                        areaName: '大安市',
                        areaLevel: '4',
                        parentCode: '010201',
                    },
                    {
                        areaCode: '01020102',
                        areaName: '洮北区',
                        areaLevel: '4',
                        parentCode: '010201',
                    },
                    {
                        areaCode: '01020103',
                        areaName: '洮南市',
                        areaLevel: '4',
                        parentCode: '010201',
                    },
                    {
                        areaCode: '01020104',
                        areaName: '通榆县',
                        areaLevel: '4',
                        parentCode: '010201',
                    },
                    {
                        areaCode: '01020105',
                        areaName: '镇赉县',
                        areaLevel: '4',
                        parentCode: '010201',
                    },
                ],
            },
            {
                areaCode: '010202',
                areaName: '白山市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020201',
                        areaName: '长白朝鲜族自治县',
                        areaLevel: '4',
                        parentCode: '010202',
                    },
                    {
                        areaCode: '01020202',
                        areaName: '抚松县',
                        areaLevel: '4',
                        parentCode: '010202',
                    },
                    {
                        areaCode: '01020203',
                        areaName: '浑江区',
                        areaLevel: '4',
                        parentCode: '010202',
                    },
                    {
                        areaCode: '01020204',
                        areaName: '江源区',
                        areaLevel: '4',
                        parentCode: '010202',
                    },
                    {
                        areaCode: '01020205',
                        areaName: '靖宇县',
                        areaLevel: '4',
                        parentCode: '010202',
                    },
                    {
                        areaCode: '01020206',
                        areaName: '临江市',
                        areaLevel: '4',
                        parentCode: '010202',
                    },
                ],
            },
            {
                areaCode: '010203',
                areaName: '长春市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020301',
                        areaName: '朝阳区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020302',
                        areaName: '德惠市',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020303',
                        areaName: '二道区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020304',
                        areaName: '九台区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020305',
                        areaName: '宽城区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020306',
                        areaName: '绿园区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020307',
                        areaName: '南关区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020308',
                        areaName: '农安县',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020309',
                        areaName: '双阳区',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                    {
                        areaCode: '01020310',
                        areaName: '榆树市',
                        areaLevel: '4',
                        parentCode: '010203',
                    },
                ],
            },
            {
                areaCode: '010204',
                areaName: '吉林市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020401',
                        areaName: '昌邑区',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020402',
                        areaName: '船营区',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020403',
                        areaName: '丰满区',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020404',
                        areaName: '桦甸市',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020405',
                        areaName: '蛟河市',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020406',
                        areaName: '龙潭区',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020407',
                        areaName: '磐石市',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020408',
                        areaName: '舒兰市',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                    {
                        areaCode: '01020409',
                        areaName: '永吉县',
                        areaLevel: '4',
                        parentCode: '010204',
                    },
                ],
            },
            {
                areaCode: '010205',
                areaName: '辽源市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020501',
                        areaName: '东丰县',
                        areaLevel: '4',
                        parentCode: '010205',
                    },
                    {
                        areaCode: '01020502',
                        areaName: '东辽县',
                        areaLevel: '4',
                        parentCode: '010205',
                    },
                    {
                        areaCode: '01020503',
                        areaName: '龙山区',
                        areaLevel: '4',
                        parentCode: '010205',
                    },
                    {
                        areaCode: '01020504',
                        areaName: '西安区',
                        areaLevel: '4',
                        parentCode: '010205',
                    },
                ],
            },
            {
                areaCode: '010206',
                areaName: '四平市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020601',
                        areaName: '公主岭市',
                        areaLevel: '4',
                        parentCode: '010206',
                    },
                    {
                        areaCode: '01020602',
                        areaName: '梨树县',
                        areaLevel: '4',
                        parentCode: '010206',
                    },
                    {
                        areaCode: '01020603',
                        areaName: '双辽市',
                        areaLevel: '4',
                        parentCode: '010206',
                    },
                    {
                        areaCode: '01020604',
                        areaName: '铁东区',
                        areaLevel: '4',
                        parentCode: '010206',
                    },
                    {
                        areaCode: '01020605',
                        areaName: '铁西区',
                        areaLevel: '4',
                        parentCode: '010206',
                    },
                    {
                        areaCode: '01020606',
                        areaName: '伊通满族自治县',
                        areaLevel: '4',
                        parentCode: '010206',
                    },
                ],
            },
            {
                areaCode: '010207',
                areaName: '松原市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020701',
                        areaName: '长岭县',
                        areaLevel: '4',
                        parentCode: '010207',
                    },
                    {
                        areaCode: '01020702',
                        areaName: '扶余市',
                        areaLevel: '4',
                        parentCode: '010207',
                    },
                    {
                        areaCode: '01020703',
                        areaName: '宁江区',
                        areaLevel: '4',
                        parentCode: '010207',
                    },
                    {
                        areaCode: '01020704',
                        areaName: '乾安县',
                        areaLevel: '4',
                        parentCode: '010207',
                    },
                    {
                        areaCode: '01020705',
                        areaName: '前郭尔罗斯蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '010207',
                    },
                ],
            },
            {
                areaCode: '010208',
                areaName: '通化市',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020801',
                        areaName: '东昌区',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                    {
                        areaCode: '01020802',
                        areaName: '二道江区',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                    {
                        areaCode: '01020803',
                        areaName: '辉南县',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                    {
                        areaCode: '01020804',
                        areaName: '集安市',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                    {
                        areaCode: '01020805',
                        areaName: '柳河县',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                    {
                        areaCode: '01020806',
                        areaName: '梅河口市',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                    {
                        areaCode: '01020807',
                        areaName: '通化县',
                        areaLevel: '4',
                        parentCode: '010208',
                    },
                ],
            },
            {
                areaCode: '010209',
                areaName: '延边朝鲜族自治州',
                areaLevel: '3',
                parentCode: '0102',
                children: [
                    {
                        areaCode: '01020901',
                        areaName: '安图县',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020902',
                        areaName: '敦化市',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020903',
                        areaName: '和龙市',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020904',
                        areaName: '珲春市',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020905',
                        areaName: '龙井市',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020906',
                        areaName: '图们市',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020907',
                        areaName: '汪清县',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                    {
                        areaCode: '01020908',
                        areaName: '延吉市',
                        areaLevel: '4',
                        parentCode: '010209',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0103',
        areaName: '辽宁省',
        areaLevel: '2',
        parentCode: '01',
        children: [
            {
                areaCode: '010301',
                areaName: '鞍山市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030101',
                        areaName: '海城市',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                    {
                        areaCode: '01030102',
                        areaName: '立山区',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                    {
                        areaCode: '01030103',
                        areaName: '千山区',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                    {
                        areaCode: '01030104',
                        areaName: '台安县',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                    {
                        areaCode: '01030105',
                        areaName: '铁东区',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                    {
                        areaCode: '01030106',
                        areaName: '铁西区',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                    {
                        areaCode: '01030107',
                        areaName: '岫岩满族自治县',
                        areaLevel: '4',
                        parentCode: '010301',
                    },
                ],
            },
            {
                areaCode: '010302',
                areaName: '本溪市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030201',
                        areaName: '本溪满族自治县',
                        areaLevel: '4',
                        parentCode: '010302',
                    },
                    {
                        areaCode: '01030202',
                        areaName: '桓仁满族自治县',
                        areaLevel: '4',
                        parentCode: '010302',
                    },
                    {
                        areaCode: '01030203',
                        areaName: '明山区',
                        areaLevel: '4',
                        parentCode: '010302',
                    },
                    {
                        areaCode: '01030204',
                        areaName: '南芬区',
                        areaLevel: '4',
                        parentCode: '010302',
                    },
                    {
                        areaCode: '01030205',
                        areaName: '平山区',
                        areaLevel: '4',
                        parentCode: '010302',
                    },
                    {
                        areaCode: '01030206',
                        areaName: '溪湖区',
                        areaLevel: '4',
                        parentCode: '010302',
                    },
                ],
            },
            {
                areaCode: '010303',
                areaName: '朝阳市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030301',
                        areaName: '北票市',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                    {
                        areaCode: '01030302',
                        areaName: '朝阳县',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                    {
                        areaCode: '01030303',
                        areaName: '建平县',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                    {
                        areaCode: '01030304',
                        areaName: '喀喇沁左翼蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                    {
                        areaCode: '01030305',
                        areaName: '凌源市',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                    {
                        areaCode: '01030306',
                        areaName: '龙城区',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                    {
                        areaCode: '01030307',
                        areaName: '双塔区',
                        areaLevel: '4',
                        parentCode: '010303',
                    },
                ],
            },
            {
                areaCode: '010304',
                areaName: '大连市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030401',
                        areaName: '长海县',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030402',
                        areaName: '甘井子区',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030403',
                        areaName: '金州区',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030404',
                        areaName: '旅顺口区',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030405',
                        areaName: '普兰店市',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030406',
                        areaName: '沙河口区',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030407',
                        areaName: '瓦房店市',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030408',
                        areaName: '西岗区',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030409',
                        areaName: '中山区',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                    {
                        areaCode: '01030410',
                        areaName: '庄河市',
                        areaLevel: '4',
                        parentCode: '010304',
                    },
                ],
            },
            {
                areaCode: '010305',
                areaName: '丹东市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030501',
                        areaName: '东港市',
                        areaLevel: '4',
                        parentCode: '010305',
                    },
                    {
                        areaCode: '01030502',
                        areaName: '凤城市',
                        areaLevel: '4',
                        parentCode: '010305',
                    },
                    {
                        areaCode: '01030503',
                        areaName: '宽甸满族自治县',
                        areaLevel: '4',
                        parentCode: '010305',
                    },
                    {
                        areaCode: '01030504',
                        areaName: '元宝区',
                        areaLevel: '4',
                        parentCode: '010305',
                    },
                    {
                        areaCode: '01030505',
                        areaName: '振安区',
                        areaLevel: '4',
                        parentCode: '010305',
                    },
                    {
                        areaCode: '01030506',
                        areaName: '振兴区',
                        areaLevel: '4',
                        parentCode: '010305',
                    },
                ],
            },
            {
                areaCode: '010306',
                areaName: '抚顺市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030601',
                        areaName: '东洲区',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                    {
                        areaCode: '01030602',
                        areaName: '抚顺县',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                    {
                        areaCode: '01030603',
                        areaName: '清原满族自治县',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                    {
                        areaCode: '01030604',
                        areaName: '顺城区',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                    {
                        areaCode: '01030605',
                        areaName: '望花区',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                    {
                        areaCode: '01030606',
                        areaName: '新宾满族自治县',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                    {
                        areaCode: '01030607',
                        areaName: '新抚区',
                        areaLevel: '4',
                        parentCode: '010306',
                    },
                ],
            },
            {
                areaCode: '010307',
                areaName: '阜新市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030701',
                        areaName: '阜新蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                    {
                        areaCode: '01030702',
                        areaName: '海州区',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                    {
                        areaCode: '01030703',
                        areaName: '清河门区',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                    {
                        areaCode: '01030704',
                        areaName: '太平区',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                    {
                        areaCode: '01030705',
                        areaName: '细河区',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                    {
                        areaCode: '01030706',
                        areaName: '新邱区',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                    {
                        areaCode: '01030707',
                        areaName: '彰武县',
                        areaLevel: '4',
                        parentCode: '010307',
                    },
                ],
            },
            {
                areaCode: '010308',
                areaName: '葫芦岛市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030801',
                        areaName: '建昌县',
                        areaLevel: '4',
                        parentCode: '010308',
                    },
                    {
                        areaCode: '01030802',
                        areaName: '连山区',
                        areaLevel: '4',
                        parentCode: '010308',
                    },
                    {
                        areaCode: '01030803',
                        areaName: '龙港区',
                        areaLevel: '4',
                        parentCode: '010308',
                    },
                    {
                        areaCode: '01030804',
                        areaName: '南票区',
                        areaLevel: '4',
                        parentCode: '010308',
                    },
                    {
                        areaCode: '01030805',
                        areaName: '绥中县',
                        areaLevel: '4',
                        parentCode: '010308',
                    },
                    {
                        areaCode: '01030806',
                        areaName: '兴城市',
                        areaLevel: '4',
                        parentCode: '010308',
                    },
                ],
            },
            {
                areaCode: '010309',
                areaName: '锦州市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01030901',
                        areaName: '北镇市',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                    {
                        areaCode: '01030902',
                        areaName: '古塔区',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                    {
                        areaCode: '01030903',
                        areaName: '黑山县',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                    {
                        areaCode: '01030904',
                        areaName: '凌海市',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                    {
                        areaCode: '01030905',
                        areaName: '凌河区',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                    {
                        areaCode: '01030906',
                        areaName: '太和区',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                    {
                        areaCode: '01030907',
                        areaName: '义县',
                        areaLevel: '4',
                        parentCode: '010309',
                    },
                ],
            },
            {
                areaCode: '010310',
                areaName: '辽阳市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01031001',
                        areaName: '白塔区',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                    {
                        areaCode: '01031002',
                        areaName: '灯塔市',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                    {
                        areaCode: '01031003',
                        areaName: '弓长岭区',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                    {
                        areaCode: '01031004',
                        areaName: '宏伟区',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                    {
                        areaCode: '01031005',
                        areaName: '辽阳县',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                    {
                        areaCode: '01031006',
                        areaName: '太子河区',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                    {
                        areaCode: '01031007',
                        areaName: '文圣区',
                        areaLevel: '4',
                        parentCode: '010310',
                    },
                ],
            },
            {
                areaCode: '010311',
                areaName: '盘锦市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01031101',
                        areaName: '大洼县',
                        areaLevel: '4',
                        parentCode: '010311',
                    },
                    {
                        areaCode: '01031102',
                        areaName: '盘山县',
                        areaLevel: '4',
                        parentCode: '010311',
                    },
                    {
                        areaCode: '01031103',
                        areaName: '双台子区',
                        areaLevel: '4',
                        parentCode: '010311',
                    },
                    {
                        areaCode: '01031104',
                        areaName: '兴隆台区',
                        areaLevel: '4',
                        parentCode: '010311',
                    },
                ],
            },
            {
                areaCode: '010312',
                areaName: '沈阳市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01031201',
                        areaName: '大东区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031202',
                        areaName: '法库县',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031203',
                        areaName: '和平区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031204',
                        areaName: '皇姑区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031205',
                        areaName: '浑南区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031206',
                        areaName: '康平县',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031207',
                        areaName: '辽中县',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031208',
                        areaName: '沈北新区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031209',
                        areaName: '沈河区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031210',
                        areaName: '苏家屯区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031211',
                        areaName: '铁西区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031212',
                        areaName: '新民市',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                    {
                        areaCode: '01031213',
                        areaName: '于洪区',
                        areaLevel: '4',
                        parentCode: '010312',
                    },
                ],
            },
            {
                areaCode: '010313',
                areaName: '铁岭市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01031301',
                        areaName: '昌图县',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                    {
                        areaCode: '01031302',
                        areaName: '调兵山市',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                    {
                        areaCode: '01031303',
                        areaName: '开原市',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                    {
                        areaCode: '01031304',
                        areaName: '清河区',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                    {
                        areaCode: '01031305',
                        areaName: '铁岭县',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                    {
                        areaCode: '01031306',
                        areaName: '西丰县',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                    {
                        areaCode: '01031307',
                        areaName: '银州区',
                        areaLevel: '4',
                        parentCode: '010313',
                    },
                ],
            },
            {
                areaCode: '010314',
                areaName: '营口市',
                areaLevel: '3',
                parentCode: '0103',
                children: [
                    {
                        areaCode: '01031401',
                        areaName: '鲅鱼圈区',
                        areaLevel: '4',
                        parentCode: '010314',
                    },
                    {
                        areaCode: '01031402',
                        areaName: '大石桥市',
                        areaLevel: '4',
                        parentCode: '010314',
                    },
                    {
                        areaCode: '01031403',
                        areaName: '盖州市',
                        areaLevel: '4',
                        parentCode: '010314',
                    },
                    {
                        areaCode: '01031404',
                        areaName: '老边区',
                        areaLevel: '4',
                        parentCode: '010314',
                    },
                    {
                        areaCode: '01031405',
                        areaName: '西市区',
                        areaLevel: '4',
                        parentCode: '010314',
                    },
                    {
                        areaCode: '01031406',
                        areaName: '站前区',
                        areaLevel: '4',
                        parentCode: '010314',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0201',
        areaName: '上海市',
        areaLevel: '2',
        parentCode: '02',
        children: [
            {
                areaCode: '020101',
                areaName: '上海市',
                areaLevel: '3',
                parentCode: '0201',
                children: [
                    {
                        areaCode: '02010101',
                        areaName: '宝山区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010102',
                        areaName: '长宁区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010103',
                        areaName: '奉贤区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010104',
                        areaName: '虹口区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010105',
                        areaName: '黄浦区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010106',
                        areaName: '嘉定区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010107',
                        areaName: '静安区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010108',
                        areaName: '金山区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010109',
                        areaName: '闵行区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010110',
                        areaName: '浦东新区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010111',
                        areaName: '普陀区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010112',
                        areaName: '青浦区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010113',
                        areaName: '松江区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010114',
                        areaName: '徐汇区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010115',
                        areaName: '杨浦区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010116',
                        areaName: '闸北区',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                    {
                        areaCode: '02010117',
                        areaName: '崇明县',
                        areaLevel: '4',
                        parentCode: '020101',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0202',
        areaName: '江苏省',
        areaLevel: '2',
        parentCode: '02',
        children: [
            {
                areaCode: '020201',
                areaName: '常州市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020101',
                        areaName: '金坛区',
                        areaLevel: '4',
                        parentCode: '020201',
                    },
                    {
                        areaCode: '02020102',
                        areaName: '溧阳市',
                        areaLevel: '4',
                        parentCode: '020201',
                    },
                    {
                        areaCode: '02020103',
                        areaName: '天宁区',
                        areaLevel: '4',
                        parentCode: '020201',
                    },
                    {
                        areaCode: '02020104',
                        areaName: '武进区',
                        areaLevel: '4',
                        parentCode: '020201',
                    },
                    {
                        areaCode: '02020105',
                        areaName: '新北区',
                        areaLevel: '4',
                        parentCode: '020201',
                    },
                    {
                        areaCode: '02020106',
                        areaName: '钟楼区',
                        areaLevel: '4',
                        parentCode: '020201',
                    },
                ],
            },
            {
                areaCode: '020202',
                areaName: '淮安市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020201',
                        areaName: '洪泽县',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020202',
                        areaName: '淮安区',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020203',
                        areaName: '淮阴区',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020204',
                        areaName: '金湖县',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020205',
                        areaName: '涟水县',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020206',
                        areaName: '清河区',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020207',
                        areaName: '清江浦区',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                    {
                        areaCode: '02020208',
                        areaName: '盱眙县',
                        areaLevel: '4',
                        parentCode: '020202',
                    },
                ],
            },
            {
                areaCode: '020203',
                areaName: '连云港市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020301',
                        areaName: '东海县',
                        areaLevel: '4',
                        parentCode: '020203',
                    },
                    {
                        areaCode: '02020302',
                        areaName: '赣榆区',
                        areaLevel: '4',
                        parentCode: '020203',
                    },
                    {
                        areaCode: '02020303',
                        areaName: '灌南县',
                        areaLevel: '4',
                        parentCode: '020203',
                    },
                    {
                        areaCode: '02020304',
                        areaName: '灌云县',
                        areaLevel: '4',
                        parentCode: '020203',
                    },
                    {
                        areaCode: '02020305',
                        areaName: '海州区',
                        areaLevel: '4',
                        parentCode: '020203',
                    },
                    {
                        areaCode: '02020306',
                        areaName: '连云区',
                        areaLevel: '4',
                        parentCode: '020203',
                    },
                ],
            },
            {
                areaCode: '020204',
                areaName: '南京市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020401',
                        areaName: '高淳区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020402',
                        areaName: '鼓楼区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020403',
                        areaName: '江宁区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020404',
                        areaName: '建邺区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020405',
                        areaName: '溧水区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020406',
                        areaName: '六合区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020407',
                        areaName: '浦口区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020408',
                        areaName: '秦淮区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020409',
                        areaName: '栖霞区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020410',
                        areaName: '玄武区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                    {
                        areaCode: '02020411',
                        areaName: '雨花台区',
                        areaLevel: '4',
                        parentCode: '020204',
                    },
                ],
            },
            {
                areaCode: '020205',
                areaName: '南通市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020501',
                        areaName: '崇川区',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020502',
                        areaName: '港闸区',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020503',
                        areaName: '海安县',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020504',
                        areaName: '海门市',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020505',
                        areaName: '启东市',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020506',
                        areaName: '如东县',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020507',
                        areaName: '如皋市',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                    {
                        areaCode: '02020508',
                        areaName: '通州区',
                        areaLevel: '4',
                        parentCode: '020205',
                    },
                ],
            },
            {
                areaCode: '020206',
                areaName: '宿迁市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020601',
                        areaName: '沭阳县',
                        areaLevel: '4',
                        parentCode: '020206',
                    },
                    {
                        areaCode: '02020602',
                        areaName: '泗洪县',
                        areaLevel: '4',
                        parentCode: '020206',
                    },
                    {
                        areaCode: '02020603',
                        areaName: '泗阳县',
                        areaLevel: '4',
                        parentCode: '020206',
                    },
                    {
                        areaCode: '02020604',
                        areaName: '宿城区',
                        areaLevel: '4',
                        parentCode: '020206',
                    },
                    {
                        areaCode: '02020605',
                        areaName: '宿豫区',
                        areaLevel: '4',
                        parentCode: '020206',
                    },
                ],
            },
            {
                areaCode: '020207',
                areaName: '苏州市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020701',
                        areaName: '常熟市',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020702',
                        areaName: '姑苏区',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020703',
                        areaName: '虎丘区',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020704',
                        areaName: '昆山市',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020705',
                        areaName: '太仓市',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020706',
                        areaName: '吴江区',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020707',
                        areaName: '吴中区',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020708',
                        areaName: '相城区',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020709',
                        areaName: '张家港市',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                    {
                        areaCode: '02020710',
                        areaName: '苏州工业园区',
                        areaLevel: '4',
                        parentCode: '020207',
                    },
                ],
            },
            {
                areaCode: '020208',
                areaName: '泰州市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020801',
                        areaName: '高港区',
                        areaLevel: '4',
                        parentCode: '020208',
                    },
                    {
                        areaCode: '02020802',
                        areaName: '海陵区',
                        areaLevel: '4',
                        parentCode: '020208',
                    },
                    {
                        areaCode: '02020803',
                        areaName: '姜堰区',
                        areaLevel: '4',
                        parentCode: '020208',
                    },
                    {
                        areaCode: '02020804',
                        areaName: '靖江市',
                        areaLevel: '4',
                        parentCode: '020208',
                    },
                    {
                        areaCode: '02020805',
                        areaName: '泰兴市',
                        areaLevel: '4',
                        parentCode: '020208',
                    },
                    {
                        areaCode: '02020806',
                        areaName: '兴化市',
                        areaLevel: '4',
                        parentCode: '020208',
                    },
                ],
            },
            {
                areaCode: '020209',
                areaName: '无锡市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02020901',
                        areaName: '梁溪区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020902',
                        areaName: '滨湖区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020903',
                        areaName: '崇安区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020904',
                        areaName: '惠山区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020905',
                        areaName: '江阴市',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020906',
                        areaName: '南长区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020907',
                        areaName: '锡山区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020908',
                        areaName: '宜兴市',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                    {
                        areaCode: '02020909',
                        areaName: '新吴区',
                        areaLevel: '4',
                        parentCode: '020209',
                    },
                ],
            },
            {
                areaCode: '020210',
                areaName: '徐州市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02021001',
                        areaName: '丰县',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021002',
                        areaName: '鼓楼区',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021003',
                        areaName: '贾汪区',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021004',
                        areaName: '沛县',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021005',
                        areaName: '邳州市',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021006',
                        areaName: '泉山区',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021007',
                        areaName: '睢宁县',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021008',
                        areaName: '铜山区',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021009',
                        areaName: '新沂市',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                    {
                        areaCode: '02021010',
                        areaName: '云龙区',
                        areaLevel: '4',
                        parentCode: '020210',
                    },
                ],
            },
            {
                areaCode: '020211',
                areaName: '盐城市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02021101',
                        areaName: '滨海县',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021102',
                        areaName: '大丰区',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021103',
                        areaName: '东台市',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021104',
                        areaName: '阜宁县',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021105',
                        areaName: '建湖县',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021106',
                        areaName: '射阳县',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021107',
                        areaName: '亭湖区',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021108',
                        areaName: '响水县',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                    {
                        areaCode: '02021109',
                        areaName: '盐都区',
                        areaLevel: '4',
                        parentCode: '020211',
                    },
                ],
            },
            {
                areaCode: '020212',
                areaName: '扬州市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02021201',
                        areaName: '宝应县',
                        areaLevel: '4',
                        parentCode: '020212',
                    },
                    {
                        areaCode: '02021202',
                        areaName: '高邮市',
                        areaLevel: '4',
                        parentCode: '020212',
                    },
                    {
                        areaCode: '02021203',
                        areaName: '广陵区',
                        areaLevel: '4',
                        parentCode: '020212',
                    },
                    {
                        areaCode: '02021204',
                        areaName: '邗江区',
                        areaLevel: '4',
                        parentCode: '020212',
                    },
                    {
                        areaCode: '02021205',
                        areaName: '江都区',
                        areaLevel: '4',
                        parentCode: '020212',
                    },
                    {
                        areaCode: '02021206',
                        areaName: '仪征市',
                        areaLevel: '4',
                        parentCode: '020212',
                    },
                ],
            },
            {
                areaCode: '020213',
                areaName: '镇江市',
                areaLevel: '3',
                parentCode: '0202',
                children: [
                    {
                        areaCode: '02021301',
                        areaName: '丹徒区',
                        areaLevel: '4',
                        parentCode: '020213',
                    },
                    {
                        areaCode: '02021302',
                        areaName: '丹阳市',
                        areaLevel: '4',
                        parentCode: '020213',
                    },
                    {
                        areaCode: '02021303',
                        areaName: '京口区',
                        areaLevel: '4',
                        parentCode: '020213',
                    },
                    {
                        areaCode: '02021304',
                        areaName: '句容市',
                        areaLevel: '4',
                        parentCode: '020213',
                    },
                    {
                        areaCode: '02021305',
                        areaName: '润州区',
                        areaLevel: '4',
                        parentCode: '020213',
                    },
                    {
                        areaCode: '02021306',
                        areaName: '扬中市',
                        areaLevel: '4',
                        parentCode: '020213',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0203',
        areaName: '浙江省',
        areaLevel: '2',
        parentCode: '02',
        children: [
            {
                areaCode: '020301',
                areaName: '杭州市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030101',
                        areaName: '滨江区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030102',
                        areaName: '淳安县',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030103',
                        areaName: '富阳区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030104',
                        areaName: '拱墅区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030105',
                        areaName: '建德市',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030106',
                        areaName: '江干区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030107',
                        areaName: '临安市',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030108',
                        areaName: '上城区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030109',
                        areaName: '桐庐县',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030110',
                        areaName: '下城区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030111',
                        areaName: '萧山区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030112',
                        areaName: '西湖区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030113',
                        areaName: '余杭区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                    {
                        areaCode: '02030114',
                        areaName: '钱塘区',
                        areaLevel: '4',
                        parentCode: '020301',
                    },
                ],
            },
            {
                areaCode: '020302',
                areaName: '湖州市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030201',
                        areaName: '安吉县',
                        areaLevel: '4',
                        parentCode: '020302',
                    },
                    {
                        areaCode: '02030202',
                        areaName: '长兴县',
                        areaLevel: '4',
                        parentCode: '020302',
                    },
                    {
                        areaCode: '02030203',
                        areaName: '德清县',
                        areaLevel: '4',
                        parentCode: '020302',
                    },
                    {
                        areaCode: '02030204',
                        areaName: '南浔区',
                        areaLevel: '4',
                        parentCode: '020302',
                    },
                    {
                        areaCode: '02030205',
                        areaName: '吴兴区',
                        areaLevel: '4',
                        parentCode: '020302',
                    },
                ],
            },
            {
                areaCode: '020303',
                areaName: '嘉兴市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030301',
                        areaName: '海宁市',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                    {
                        areaCode: '02030302',
                        areaName: '海盐县',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                    {
                        areaCode: '02030303',
                        areaName: '嘉善县',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                    {
                        areaCode: '02030304',
                        areaName: '南湖区',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                    {
                        areaCode: '02030305',
                        areaName: '平湖市',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                    {
                        areaCode: '02030306',
                        areaName: '桐乡市',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                    {
                        areaCode: '02030307',
                        areaName: '秀洲区',
                        areaLevel: '4',
                        parentCode: '020303',
                    },
                ],
            },
            {
                areaCode: '020304',
                areaName: '金华市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030401',
                        areaName: '东阳市',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030402',
                        areaName: '金东区',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030403',
                        areaName: '兰溪市',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030404',
                        areaName: '磐安县',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030405',
                        areaName: '浦江县',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030406',
                        areaName: '婺城区',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030407',
                        areaName: '武义县',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030408',
                        areaName: '义乌市',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                    {
                        areaCode: '02030409',
                        areaName: '永康市',
                        areaLevel: '4',
                        parentCode: '020304',
                    },
                ],
            },
            {
                areaCode: '020305',
                areaName: '丽水市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030501',
                        areaName: '景宁畲族自治县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030502',
                        areaName: '缙云县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030503',
                        areaName: '莲都区',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030504',
                        areaName: '龙泉市',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030505',
                        areaName: '青田县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030506',
                        areaName: '庆元县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030507',
                        areaName: '松阳县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030508',
                        areaName: '遂昌县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                    {
                        areaCode: '02030509',
                        areaName: '云和县',
                        areaLevel: '4',
                        parentCode: '020305',
                    },
                ],
            },
            {
                areaCode: '020306',
                areaName: '宁波市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030601',
                        areaName: '北仑区',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030602',
                        areaName: '慈溪市',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030603',
                        areaName: '奉化市',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030604',
                        areaName: '海曙区',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030605',
                        areaName: '江北区',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030606',
                        areaName: '江东区',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030607',
                        areaName: '宁海县',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030608',
                        areaName: '象山县',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030609',
                        areaName: '鄞州区',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030610',
                        areaName: '余姚市',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                    {
                        areaCode: '02030611',
                        areaName: '镇海区',
                        areaLevel: '4',
                        parentCode: '020306',
                    },
                ],
            },
            {
                areaCode: '020307',
                areaName: '衢州市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030701',
                        areaName: '常山县',
                        areaLevel: '4',
                        parentCode: '020307',
                    },
                    {
                        areaCode: '02030702',
                        areaName: '江山市',
                        areaLevel: '4',
                        parentCode: '020307',
                    },
                    {
                        areaCode: '02030703',
                        areaName: '开化县',
                        areaLevel: '4',
                        parentCode: '020307',
                    },
                    {
                        areaCode: '02030704',
                        areaName: '柯城区',
                        areaLevel: '4',
                        parentCode: '020307',
                    },
                    {
                        areaCode: '02030705',
                        areaName: '龙游县',
                        areaLevel: '4',
                        parentCode: '020307',
                    },
                    {
                        areaCode: '02030706',
                        areaName: '衢江区',
                        areaLevel: '4',
                        parentCode: '020307',
                    },
                ],
            },
            {
                areaCode: '020308',
                areaName: '绍兴市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030801',
                        areaName: '柯桥区',
                        areaLevel: '4',
                        parentCode: '020308',
                    },
                    {
                        areaCode: '02030802',
                        areaName: '上虞区',
                        areaLevel: '4',
                        parentCode: '020308',
                    },
                    {
                        areaCode: '02030803',
                        areaName: '嵊州市',
                        areaLevel: '4',
                        parentCode: '020308',
                    },
                    {
                        areaCode: '02030804',
                        areaName: '新昌县',
                        areaLevel: '4',
                        parentCode: '020308',
                    },
                    {
                        areaCode: '02030805',
                        areaName: '越城区',
                        areaLevel: '4',
                        parentCode: '020308',
                    },
                    {
                        areaCode: '02030806',
                        areaName: '诸暨市',
                        areaLevel: '4',
                        parentCode: '020308',
                    },
                ],
            },
            {
                areaCode: '020309',
                areaName: '台州市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02030901',
                        areaName: '黄岩区',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030902',
                        areaName: '椒江区',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030903',
                        areaName: '临海市',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030904',
                        areaName: '路桥区',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030905',
                        areaName: '三门县',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030906',
                        areaName: '天台县',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030907',
                        areaName: '温岭市',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030908',
                        areaName: '仙居县',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                    {
                        areaCode: '02030909',
                        areaName: '玉环县',
                        areaLevel: '4',
                        parentCode: '020309',
                    },
                ],
            },
            {
                areaCode: '020310',
                areaName: '温州市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02031001',
                        areaName: '苍南县',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031002',
                        areaName: '洞头区',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031003',
                        areaName: '乐清市',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031004',
                        areaName: '龙湾区',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031005',
                        areaName: '鹿城区',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031006',
                        areaName: '瓯海区',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031007',
                        areaName: '平阳县',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031008',
                        areaName: '瑞安市',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031009',
                        areaName: '泰顺县',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031010',
                        areaName: '文成县',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                    {
                        areaCode: '02031011',
                        areaName: '永嘉县',
                        areaLevel: '4',
                        parentCode: '020310',
                    },
                ],
            },
            {
                areaCode: '020311',
                areaName: '舟山市',
                areaLevel: '3',
                parentCode: '0203',
                children: [
                    {
                        areaCode: '02031101',
                        areaName: '岱山县',
                        areaLevel: '4',
                        parentCode: '020311',
                    },
                    {
                        areaCode: '02031102',
                        areaName: '定海区',
                        areaLevel: '4',
                        parentCode: '020311',
                    },
                    {
                        areaCode: '02031103',
                        areaName: '普陀区',
                        areaLevel: '4',
                        parentCode: '020311',
                    },
                    {
                        areaCode: '02031104',
                        areaName: '嵊泗县',
                        areaLevel: '4',
                        parentCode: '020311',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0204',
        areaName: '安徽省',
        areaLevel: '2',
        parentCode: '02',
        children: [
            {
                areaCode: '020401',
                areaName: '安庆市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040101',
                        areaName: '大观区',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040102',
                        areaName: '怀宁县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040103',
                        areaName: '潜山县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040104',
                        areaName: '宿松县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040105',
                        areaName: '太湖县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040106',
                        areaName: '桐城市',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040107',
                        areaName: '望江县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040108',
                        areaName: '迎江区',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040109',
                        areaName: '宜秀区',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040110',
                        areaName: '岳西县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                    {
                        areaCode: '02040111',
                        areaName: '枞阳县',
                        areaLevel: '4',
                        parentCode: '020401',
                    },
                ],
            },
            {
                areaCode: '020402',
                areaName: '蚌埠市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040201',
                        areaName: '蚌山区',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                    {
                        areaCode: '02040202',
                        areaName: '固镇县',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                    {
                        areaCode: '02040203',
                        areaName: '淮上区',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                    {
                        areaCode: '02040204',
                        areaName: '怀远县',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                    {
                        areaCode: '02040205',
                        areaName: '龙子湖区',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                    {
                        areaCode: '02040206',
                        areaName: '五河县',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                    {
                        areaCode: '02040207',
                        areaName: '禹会区',
                        areaLevel: '4',
                        parentCode: '020402',
                    },
                ],
            },
            {
                areaCode: '020403',
                areaName: '亳州市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040301',
                        areaName: '利辛县',
                        areaLevel: '4',
                        parentCode: '020403',
                    },
                    {
                        areaCode: '02040302',
                        areaName: '蒙城县',
                        areaLevel: '4',
                        parentCode: '020403',
                    },
                    {
                        areaCode: '02040303',
                        areaName: '谯城区',
                        areaLevel: '4',
                        parentCode: '020403',
                    },
                    {
                        areaCode: '02040304',
                        areaName: '涡阳县',
                        areaLevel: '4',
                        parentCode: '020403',
                    },
                ],
            },
            {
                areaCode: '020404',
                areaName: '池州市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040401',
                        areaName: '东至县',
                        areaLevel: '4',
                        parentCode: '020404',
                    },
                    {
                        areaCode: '02040402',
                        areaName: '贵池区',
                        areaLevel: '4',
                        parentCode: '020404',
                    },
                    {
                        areaCode: '02040403',
                        areaName: '青阳县',
                        areaLevel: '4',
                        parentCode: '020404',
                    },
                    {
                        areaCode: '02040404',
                        areaName: '石台县',
                        areaLevel: '4',
                        parentCode: '020404',
                    },
                ],
            },
            {
                areaCode: '020405',
                areaName: '滁州市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040501',
                        areaName: '定远县',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040502',
                        areaName: '凤阳县',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040503',
                        areaName: '来安县',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040504',
                        areaName: '琅琊区',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040505',
                        areaName: '明光市',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040506',
                        areaName: '南谯区',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040507',
                        areaName: '全椒县',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                    {
                        areaCode: '02040508',
                        areaName: '天长市',
                        areaLevel: '4',
                        parentCode: '020405',
                    },
                ],
            },
            {
                areaCode: '020406',
                areaName: '阜阳市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040601',
                        areaName: '阜南县',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040602',
                        areaName: '界首市',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040603',
                        areaName: '临泉县',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040604',
                        areaName: '太和县',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040605',
                        areaName: '颍东区',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040606',
                        areaName: '颍泉区',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040607',
                        areaName: '颍上县',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                    {
                        areaCode: '02040608',
                        areaName: '颍州区',
                        areaLevel: '4',
                        parentCode: '020406',
                    },
                ],
            },
            {
                areaCode: '020407',
                areaName: '合肥市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040701',
                        areaName: '包河区',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040702',
                        areaName: '长丰县',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040703',
                        areaName: '巢湖市',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040704',
                        areaName: '肥东县',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040705',
                        areaName: '肥西县',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040706',
                        areaName: '庐江县',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040707',
                        areaName: '庐阳区',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040708',
                        areaName: '蜀山区',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                    {
                        areaCode: '02040709',
                        areaName: '瑶海区',
                        areaLevel: '4',
                        parentCode: '020407',
                    },
                ],
            },
            {
                areaCode: '020408',
                areaName: '淮北市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040801',
                        areaName: '杜集区',
                        areaLevel: '4',
                        parentCode: '020408',
                    },
                    {
                        areaCode: '02040802',
                        areaName: '烈山区',
                        areaLevel: '4',
                        parentCode: '020408',
                    },
                    {
                        areaCode: '02040803',
                        areaName: '濉溪县',
                        areaLevel: '4',
                        parentCode: '020408',
                    },
                    {
                        areaCode: '02040804',
                        areaName: '相山区',
                        areaLevel: '4',
                        parentCode: '020408',
                    },
                ],
            },
            {
                areaCode: '020409',
                areaName: '淮南市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02040901',
                        areaName: '八公山区',
                        areaLevel: '4',
                        parentCode: '020409',
                    },
                    {
                        areaCode: '02040902',
                        areaName: '大通区',
                        areaLevel: '4',
                        parentCode: '020409',
                    },
                    {
                        areaCode: '02040903',
                        areaName: '凤台县',
                        areaLevel: '4',
                        parentCode: '020409',
                    },
                    {
                        areaCode: '02040904',
                        areaName: '潘集区',
                        areaLevel: '4',
                        parentCode: '020409',
                    },
                    {
                        areaCode: '02040905',
                        areaName: '田家庵区',
                        areaLevel: '4',
                        parentCode: '020409',
                    },
                    {
                        areaCode: '02040906',
                        areaName: '谢家集区',
                        areaLevel: '4',
                        parentCode: '020409',
                    },
                ],
            },
            {
                areaCode: '020410',
                areaName: '黄山市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041001',
                        areaName: '黄山区',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                    {
                        areaCode: '02041002',
                        areaName: '徽州区',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                    {
                        areaCode: '02041003',
                        areaName: '祁门县',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                    {
                        areaCode: '02041004',
                        areaName: '歙县',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                    {
                        areaCode: '02041005',
                        areaName: '屯溪区',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                    {
                        areaCode: '02041006',
                        areaName: '休宁县',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                    {
                        areaCode: '02041007',
                        areaName: '黟县',
                        areaLevel: '4',
                        parentCode: '020410',
                    },
                ],
            },
            {
                areaCode: '020411',
                areaName: '六安市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041101',
                        areaName: '霍邱县',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                    {
                        areaCode: '02041102',
                        areaName: '霍山县',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                    {
                        areaCode: '02041103',
                        areaName: '金安区',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                    {
                        areaCode: '02041104',
                        areaName: '金寨县',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                    {
                        areaCode: '02041105',
                        areaName: '寿县',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                    {
                        areaCode: '02041106',
                        areaName: '舒城县',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                    {
                        areaCode: '02041107',
                        areaName: '裕安区',
                        areaLevel: '4',
                        parentCode: '020411',
                    },
                ],
            },
            {
                areaCode: '020412',
                areaName: '马鞍山市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041201',
                        areaName: '博望区',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                    {
                        areaCode: '02041202',
                        areaName: '当涂县',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                    {
                        areaCode: '02041203',
                        areaName: '含山县',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                    {
                        areaCode: '02041204',
                        areaName: '和县',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                    {
                        areaCode: '02041205',
                        areaName: '花山区',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                    {
                        areaCode: '02041206',
                        areaName: '雨山区',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                    {
                        areaCode: '02041207',
                        areaName: '郑蒲港新区',
                        areaLevel: '4',
                        parentCode: '020412',
                    },
                ],
            },
            {
                areaCode: '020413',
                areaName: '宿州市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041301',
                        areaName: '砀山县',
                        areaLevel: '4',
                        parentCode: '020413',
                    },
                    {
                        areaCode: '02041302',
                        areaName: '灵璧县',
                        areaLevel: '4',
                        parentCode: '020413',
                    },
                    {
                        areaCode: '02041303',
                        areaName: '泗县',
                        areaLevel: '4',
                        parentCode: '020413',
                    },
                    {
                        areaCode: '02041304',
                        areaName: '萧县',
                        areaLevel: '4',
                        parentCode: '020413',
                    },
                    {
                        areaCode: '02041305',
                        areaName: '埇桥区',
                        areaLevel: '4',
                        parentCode: '020413',
                    },
                ],
            },
            {
                areaCode: '020414',
                areaName: '铜陵市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041401',
                        areaName: '郊区',
                        areaLevel: '4',
                        parentCode: '020414',
                    },
                    {
                        areaCode: '02041402',
                        areaName: '狮子山区',
                        areaLevel: '4',
                        parentCode: '020414',
                    },
                    {
                        areaCode: '02041403',
                        areaName: '铜官山区',
                        areaLevel: '4',
                        parentCode: '020414',
                    },
                    {
                        areaCode: '02041404',
                        areaName: '铜陵县',
                        areaLevel: '4',
                        parentCode: '020414',
                    },
                ],
            },
            {
                areaCode: '020415',
                areaName: '芜湖市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041501',
                        areaName: '繁昌县',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041502',
                        areaName: '镜湖区',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041503',
                        areaName: '鸠江区',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041504',
                        areaName: '南陵县',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041505',
                        areaName: '三山区',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041506',
                        areaName: '芜湖县',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041507',
                        areaName: '无为县',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                    {
                        areaCode: '02041508',
                        areaName: '弋江区',
                        areaLevel: '4',
                        parentCode: '020415',
                    },
                ],
            },
            {
                areaCode: '020416',
                areaName: '宣城市',
                areaLevel: '3',
                parentCode: '0204',
                children: [
                    {
                        areaCode: '02041601',
                        areaName: '广德县',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                    {
                        areaCode: '02041602',
                        areaName: '旌德县',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                    {
                        areaCode: '02041603',
                        areaName: '泾县',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                    {
                        areaCode: '02041604',
                        areaName: '绩溪县',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                    {
                        areaCode: '02041605',
                        areaName: '郎溪县',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                    {
                        areaCode: '02041606',
                        areaName: '宁国市',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                    {
                        areaCode: '02041607',
                        areaName: '宣州区',
                        areaLevel: '4',
                        parentCode: '020416',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0301',
        areaName: '北京市',
        areaLevel: '2',
        parentCode: '03',
        children: [
            {
                areaCode: '030101',
                areaName: '北京市',
                areaLevel: '3',
                parentCode: '0301',
                children: [
                    {
                        areaCode: '03010101',
                        areaName: '昌平区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010102',
                        areaName: '朝阳区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010103',
                        areaName: '大兴区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010104',
                        areaName: '东城区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010105',
                        areaName: '房山区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010106',
                        areaName: '丰台区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010107',
                        areaName: '海淀区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010108',
                        areaName: '怀柔区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010109',
                        areaName: '门头沟区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010110',
                        areaName: '平谷区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010111',
                        areaName: '石景山区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010112',
                        areaName: '顺义区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010113',
                        areaName: '通州区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010114',
                        areaName: '西城区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010115',
                        areaName: '密云区',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                    {
                        areaCode: '03010116',
                        areaName: '延庆县',
                        areaLevel: '4',
                        parentCode: '030101',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0302',
        areaName: '天津市',
        areaLevel: '2',
        parentCode: '03',
        children: [
            {
                areaCode: '030201',
                areaName: '天津市',
                areaLevel: '3',
                parentCode: '0302',
                children: [
                    {
                        areaCode: '03020101',
                        areaName: '宝坻区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020102',
                        areaName: '北辰区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020103',
                        areaName: '滨海新区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020104',
                        areaName: '东丽区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020105',
                        areaName: '河北区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020106',
                        areaName: '河东区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020107',
                        areaName: '和平区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020108',
                        areaName: '河西区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020109',
                        areaName: '红桥区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020110',
                        areaName: '静海区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020111',
                        areaName: '津南区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020112',
                        areaName: '南开区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020113',
                        areaName: '宁河区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020114',
                        areaName: '武清区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020115',
                        areaName: '西青区',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                    {
                        areaCode: '03020116',
                        areaName: '蓟县',
                        areaLevel: '4',
                        parentCode: '030201',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0303',
        areaName: '山东省',
        areaLevel: '2',
        parentCode: '03',
        children: [
            {
                areaCode: '030301',
                areaName: '滨州市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030101',
                        areaName: '滨城区',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                    {
                        areaCode: '03030102',
                        areaName: '博兴县',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                    {
                        areaCode: '03030103',
                        areaName: '惠民县',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                    {
                        areaCode: '03030104',
                        areaName: '无棣县',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                    {
                        areaCode: '03030105',
                        areaName: '阳信县',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                    {
                        areaCode: '03030106',
                        areaName: '沾化区',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                    {
                        areaCode: '03030107',
                        areaName: '邹平县',
                        areaLevel: '4',
                        parentCode: '030301',
                    },
                ],
            },
            {
                areaCode: '030302',
                areaName: '德州市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030201',
                        areaName: '德城区',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030202',
                        areaName: '乐陵市',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030203',
                        areaName: '陵城区',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030204',
                        areaName: '临邑县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030205',
                        areaName: '宁津县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030206',
                        areaName: '平原县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030207',
                        areaName: '齐河县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030208',
                        areaName: '庆云县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030209',
                        areaName: '武城县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030210',
                        areaName: '夏津县',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                    {
                        areaCode: '03030211',
                        areaName: '禹城市',
                        areaLevel: '4',
                        parentCode: '030302',
                    },
                ],
            },
            {
                areaCode: '030303',
                areaName: '东营市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030301',
                        areaName: '东营区',
                        areaLevel: '4',
                        parentCode: '030303',
                    },
                    {
                        areaCode: '03030302',
                        areaName: '广饶县',
                        areaLevel: '4',
                        parentCode: '030303',
                    },
                    {
                        areaCode: '03030303',
                        areaName: '河口区',
                        areaLevel: '4',
                        parentCode: '030303',
                    },
                    {
                        areaCode: '03030304',
                        areaName: '垦利县',
                        areaLevel: '4',
                        parentCode: '030303',
                    },
                    {
                        areaCode: '03030305',
                        areaName: '利津县',
                        areaLevel: '4',
                        parentCode: '030303',
                    },
                ],
            },
            {
                areaCode: '030304',
                areaName: '菏泽市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030401',
                        areaName: '曹县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030402',
                        areaName: '成武县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030403',
                        areaName: '单县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030404',
                        areaName: '定陶县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030405',
                        areaName: '东明县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030406',
                        areaName: '鄄城县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030407',
                        areaName: '巨野县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030408',
                        areaName: '牡丹区',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                    {
                        areaCode: '03030409',
                        areaName: '郓城县',
                        areaLevel: '4',
                        parentCode: '030304',
                    },
                ],
            },
            {
                areaCode: '030305',
                areaName: '济南市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030501',
                        areaName: '长清区',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030502',
                        areaName: '槐荫区',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030503',
                        areaName: '济阳县',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030504',
                        areaName: '历城区',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030505',
                        areaName: '历下区',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030506',
                        areaName: '平阴县',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030507',
                        areaName: '商河县',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030508',
                        areaName: '市中区',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030509',
                        areaName: '天桥区',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                    {
                        areaCode: '03030510',
                        areaName: '章丘市',
                        areaLevel: '4',
                        parentCode: '030305',
                    },
                ],
            },
            {
                areaCode: '030306',
                areaName: '济宁市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030601',
                        areaName: '嘉祥县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030602',
                        areaName: '金乡县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030603',
                        areaName: '梁山县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030604',
                        areaName: '曲阜市',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030605',
                        areaName: '任城区',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030606',
                        areaName: '泗水县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030607',
                        areaName: '微山县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030608',
                        areaName: '汶上县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030609',
                        areaName: '兖州区',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030610',
                        areaName: '鱼台县',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030611',
                        areaName: '邹城市',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                    {
                        areaCode: '03030612',
                        areaName: '太白湖新区',
                        areaLevel: '4',
                        parentCode: '030306',
                    },
                ],
            },
            {
                areaCode: '030307',
                areaName: '莱芜市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030701',
                        areaName: '钢城区',
                        areaLevel: '4',
                        parentCode: '030307',
                    },
                    {
                        areaCode: '03030702',
                        areaName: '莱城区',
                        areaLevel: '4',
                        parentCode: '030307',
                    },
                ],
            },
            {
                areaCode: '030308',
                areaName: '聊城市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030801',
                        areaName: '茌平县',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030802',
                        areaName: '东阿县',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030803',
                        areaName: '东昌府区',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030804',
                        areaName: '高唐县',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030805',
                        areaName: '冠县',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030806',
                        areaName: '临清市',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030807',
                        areaName: '莘县',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                    {
                        areaCode: '03030808',
                        areaName: '阳谷县',
                        areaLevel: '4',
                        parentCode: '030308',
                    },
                ],
            },
            {
                areaCode: '030309',
                areaName: '临沂市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03030901',
                        areaName: '费县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030902',
                        areaName: '河东区',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030903',
                        areaName: '莒南县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030904',
                        areaName: '兰陵县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030905',
                        areaName: '兰山区',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030906',
                        areaName: '临沭县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030907',
                        areaName: '罗庄区',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030908',
                        areaName: '蒙阴县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030909',
                        areaName: '平邑县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030910',
                        areaName: '郯城县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030911',
                        areaName: '沂南县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                    {
                        areaCode: '03030912',
                        areaName: '沂水县',
                        areaLevel: '4',
                        parentCode: '030309',
                    },
                ],
            },
            {
                areaCode: '030310',
                areaName: '青岛市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031001',
                        areaName: '城阳区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031002',
                        areaName: '黄岛区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031003',
                        areaName: '胶州市',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031004',
                        areaName: '即墨区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031005',
                        areaName: '莱西市',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031006',
                        areaName: '崂山区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031007',
                        areaName: '李沧区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031008',
                        areaName: '平度市',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031009',
                        areaName: '市北区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                    {
                        areaCode: '03031010',
                        areaName: '市南区',
                        areaLevel: '4',
                        parentCode: '030310',
                    },
                ],
            },
            {
                areaCode: '030311',
                areaName: '日照市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031101',
                        areaName: '东港区',
                        areaLevel: '4',
                        parentCode: '030311',
                    },
                    {
                        areaCode: '03031102',
                        areaName: '莒县',
                        areaLevel: '4',
                        parentCode: '030311',
                    },
                    {
                        areaCode: '03031103',
                        areaName: '岚山区',
                        areaLevel: '4',
                        parentCode: '030311',
                    },
                    {
                        areaCode: '03031104',
                        areaName: '五莲县',
                        areaLevel: '4',
                        parentCode: '030311',
                    },
                ],
            },
            {
                areaCode: '030312',
                areaName: '泰安市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031201',
                        areaName: '岱岳区',
                        areaLevel: '4',
                        parentCode: '030312',
                    },
                    {
                        areaCode: '03031202',
                        areaName: '东平县',
                        areaLevel: '4',
                        parentCode: '030312',
                    },
                    {
                        areaCode: '03031203',
                        areaName: '肥城市',
                        areaLevel: '4',
                        parentCode: '030312',
                    },
                    {
                        areaCode: '03031204',
                        areaName: '宁阳县',
                        areaLevel: '4',
                        parentCode: '030312',
                    },
                    {
                        areaCode: '03031205',
                        areaName: '泰山区',
                        areaLevel: '4',
                        parentCode: '030312',
                    },
                    {
                        areaCode: '03031206',
                        areaName: '新泰市',
                        areaLevel: '4',
                        parentCode: '030312',
                    },
                ],
            },
            {
                areaCode: '030313',
                areaName: '潍坊市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031301',
                        areaName: '安丘市',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031302',
                        areaName: '昌乐县',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031303',
                        areaName: '昌邑市',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031304',
                        areaName: '坊子区',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031305',
                        areaName: '高密市',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031306',
                        areaName: '寒亭区',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031307',
                        areaName: '奎文区',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031308',
                        areaName: '临朐县',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031309',
                        areaName: '青州市',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031310',
                        areaName: '寿光市',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031311',
                        areaName: '潍城区',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031312',
                        areaName: '诸城市',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                    {
                        areaCode: '03031313',
                        areaName: '滨海经济开发区',
                        areaLevel: '4',
                        parentCode: '030313',
                    },
                ],
            },
            {
                areaCode: '030314',
                areaName: '威海市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031401',
                        areaName: '环翠区',
                        areaLevel: '4',
                        parentCode: '030314',
                    },
                    {
                        areaCode: '03031402',
                        areaName: '荣成市',
                        areaLevel: '4',
                        parentCode: '030314',
                    },
                    {
                        areaCode: '03031403',
                        areaName: '乳山市',
                        areaLevel: '4',
                        parentCode: '030314',
                    },
                    {
                        areaCode: '03031404',
                        areaName: '文登区',
                        areaLevel: '4',
                        parentCode: '030314',
                    },
                ],
            },
            {
                areaCode: '030315',
                areaName: '烟台市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031501',
                        areaName: '长岛县',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031502',
                        areaName: '福山区',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031503',
                        areaName: '海阳市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031504',
                        areaName: '莱山区',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031505',
                        areaName: '莱阳市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031506',
                        areaName: '莱州市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031507',
                        areaName: '龙口市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031508',
                        areaName: '牟平区',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031509',
                        areaName: '蓬莱市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031510',
                        areaName: '栖霞市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031511',
                        areaName: '招远市',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                    {
                        areaCode: '03031512',
                        areaName: '芝罘区',
                        areaLevel: '4',
                        parentCode: '030315',
                    },
                ],
            },
            {
                areaCode: '030316',
                areaName: '枣庄市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031601',
                        areaName: '山亭区',
                        areaLevel: '4',
                        parentCode: '030316',
                    },
                    {
                        areaCode: '03031602',
                        areaName: '市中区',
                        areaLevel: '4',
                        parentCode: '030316',
                    },
                    {
                        areaCode: '03031603',
                        areaName: '台儿庄区',
                        areaLevel: '4',
                        parentCode: '030316',
                    },
                    {
                        areaCode: '03031604',
                        areaName: '滕州市',
                        areaLevel: '4',
                        parentCode: '030316',
                    },
                    {
                        areaCode: '03031605',
                        areaName: '薛城区',
                        areaLevel: '4',
                        parentCode: '030316',
                    },
                    {
                        areaCode: '03031606',
                        areaName: '峄城区',
                        areaLevel: '4',
                        parentCode: '030316',
                    },
                ],
            },
            {
                areaCode: '030317',
                areaName: '淄博市',
                areaLevel: '3',
                parentCode: '0303',
                children: [
                    {
                        areaCode: '03031701',
                        areaName: '博山区',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031702',
                        areaName: '高青县',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031703',
                        areaName: '桓台县',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031704',
                        areaName: '临淄区',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031705',
                        areaName: '沂源县',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031706',
                        areaName: '张店区',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031707',
                        areaName: '周村区',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                    {
                        areaCode: '03031708',
                        areaName: '淄川区',
                        areaLevel: '4',
                        parentCode: '030317',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0304',
        areaName: '山西省',
        areaLevel: '2',
        parentCode: '03',
        children: [
            {
                areaCode: '030401',
                areaName: '长治市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040101',
                        areaName: '长治县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040102',
                        areaName: '长子县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040103',
                        areaName: '城区',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040104',
                        areaName: '壶关县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040105',
                        areaName: '郊区',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040106',
                        areaName: '黎城县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040107',
                        areaName: '潞城市',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040108',
                        areaName: '平顺县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040109',
                        areaName: '沁县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040110',
                        areaName: '沁源县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040111',
                        areaName: '屯留县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040112',
                        areaName: '武乡县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                    {
                        areaCode: '03040113',
                        areaName: '襄垣县',
                        areaLevel: '4',
                        parentCode: '030401',
                    },
                ],
            },
            {
                areaCode: '030402',
                areaName: '大同市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040201',
                        areaName: '城区',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040202',
                        areaName: '大同县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040203',
                        areaName: '广灵县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040204',
                        areaName: '浑源县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040205',
                        areaName: '矿区',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040206',
                        areaName: '灵丘县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040207',
                        areaName: '南郊区',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040208',
                        areaName: '天镇县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040209',
                        areaName: '新荣区',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040210',
                        areaName: '阳高县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                    {
                        areaCode: '03040211',
                        areaName: '左云县',
                        areaLevel: '4',
                        parentCode: '030402',
                    },
                ],
            },
            {
                areaCode: '030403',
                areaName: '晋城市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040301',
                        areaName: '城区',
                        areaLevel: '4',
                        parentCode: '030403',
                    },
                    {
                        areaCode: '03040302',
                        areaName: '高平市',
                        areaLevel: '4',
                        parentCode: '030403',
                    },
                    {
                        areaCode: '03040303',
                        areaName: '陵川县',
                        areaLevel: '4',
                        parentCode: '030403',
                    },
                    {
                        areaCode: '03040304',
                        areaName: '沁水县',
                        areaLevel: '4',
                        parentCode: '030403',
                    },
                    {
                        areaCode: '03040305',
                        areaName: '阳城县',
                        areaLevel: '4',
                        parentCode: '030403',
                    },
                    {
                        areaCode: '03040306',
                        areaName: '泽州县',
                        areaLevel: '4',
                        parentCode: '030403',
                    },
                ],
            },
            {
                areaCode: '030404',
                areaName: '晋中市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040401',
                        areaName: '和顺县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040402',
                        areaName: '介休市',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040403',
                        areaName: '灵石县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040404',
                        areaName: '平遥县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040405',
                        areaName: '祁县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040406',
                        areaName: '寿阳县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040407',
                        areaName: '太谷县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040408',
                        areaName: '昔阳县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040409',
                        areaName: '榆次区',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040410',
                        areaName: '榆社县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                    {
                        areaCode: '03040411',
                        areaName: '左权县',
                        areaLevel: '4',
                        parentCode: '030404',
                    },
                ],
            },
            {
                areaCode: '030405',
                areaName: '临汾市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040501',
                        areaName: '安泽县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040502',
                        areaName: '大宁县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040503',
                        areaName: '汾西县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040504',
                        areaName: '浮山县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040505',
                        areaName: '古县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040506',
                        areaName: '洪洞县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040507',
                        areaName: '侯马市',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040508',
                        areaName: '霍州市',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040509',
                        areaName: '吉县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040510',
                        areaName: '蒲县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040511',
                        areaName: '曲沃县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040512',
                        areaName: '襄汾县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040513',
                        areaName: '乡宁县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040514',
                        areaName: '隰县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040515',
                        areaName: '尧都区',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040516',
                        areaName: '翼城县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                    {
                        areaCode: '03040517',
                        areaName: '永和县',
                        areaLevel: '4',
                        parentCode: '030405',
                    },
                ],
            },
            {
                areaCode: '030406',
                areaName: '吕梁市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040601',
                        areaName: '方山县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040602',
                        areaName: '汾阳市',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040603',
                        areaName: '交城县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040604',
                        areaName: '交口县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040605',
                        areaName: '岚县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040606',
                        areaName: '临县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040607',
                        areaName: '离石区',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040608',
                        areaName: '柳林县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040609',
                        areaName: '石楼县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040610',
                        areaName: '文水县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040611',
                        areaName: '孝义市',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040612',
                        areaName: '兴县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                    {
                        areaCode: '03040613',
                        areaName: '中阳县',
                        areaLevel: '4',
                        parentCode: '030406',
                    },
                ],
            },
            {
                areaCode: '030407',
                areaName: '朔州市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040701',
                        areaName: '怀仁县',
                        areaLevel: '4',
                        parentCode: '030407',
                    },
                    {
                        areaCode: '03040702',
                        areaName: '平鲁区',
                        areaLevel: '4',
                        parentCode: '030407',
                    },
                    {
                        areaCode: '03040703',
                        areaName: '山阴县',
                        areaLevel: '4',
                        parentCode: '030407',
                    },
                    {
                        areaCode: '03040704',
                        areaName: '朔城区',
                        areaLevel: '4',
                        parentCode: '030407',
                    },
                    {
                        areaCode: '03040705',
                        areaName: '应县',
                        areaLevel: '4',
                        parentCode: '030407',
                    },
                    {
                        areaCode: '03040706',
                        areaName: '右玉县',
                        areaLevel: '4',
                        parentCode: '030407',
                    },
                ],
            },
            {
                areaCode: '030408',
                areaName: '太原市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040801',
                        areaName: '古交市',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040802',
                        areaName: '尖草坪区',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040803',
                        areaName: '晋源区',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040804',
                        areaName: '娄烦县',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040805',
                        areaName: '清徐县',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040806',
                        areaName: '万柏林区',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040807',
                        areaName: '小店区',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040808',
                        areaName: '杏花岭区',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040809',
                        areaName: '阳曲县',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                    {
                        areaCode: '03040810',
                        areaName: '迎泽区',
                        areaLevel: '4',
                        parentCode: '030408',
                    },
                ],
            },
            {
                areaCode: '030409',
                areaName: '忻州市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03040901',
                        areaName: '保德县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040902',
                        areaName: '代县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040903',
                        areaName: '定襄县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040904',
                        areaName: '繁峙县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040905',
                        areaName: '河曲县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040906',
                        areaName: '静乐县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040907',
                        areaName: '岢岚县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040908',
                        areaName: '宁武县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040909',
                        areaName: '偏关县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040910',
                        areaName: '神池县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040911',
                        areaName: '五台县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040912',
                        areaName: '五寨县',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040913',
                        areaName: '忻府区',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                    {
                        areaCode: '03040914',
                        areaName: '原平市',
                        areaLevel: '4',
                        parentCode: '030409',
                    },
                ],
            },
            {
                areaCode: '030410',
                areaName: '阳泉市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03041001',
                        areaName: '城区',
                        areaLevel: '4',
                        parentCode: '030410',
                    },
                    {
                        areaCode: '03041002',
                        areaName: '郊区',
                        areaLevel: '4',
                        parentCode: '030410',
                    },
                    {
                        areaCode: '03041003',
                        areaName: '矿区',
                        areaLevel: '4',
                        parentCode: '030410',
                    },
                    {
                        areaCode: '03041004',
                        areaName: '平定县',
                        areaLevel: '4',
                        parentCode: '030410',
                    },
                    {
                        areaCode: '03041005',
                        areaName: '盂县',
                        areaLevel: '4',
                        parentCode: '030410',
                    },
                ],
            },
            {
                areaCode: '030411',
                areaName: '运城市',
                areaLevel: '3',
                parentCode: '0304',
                children: [
                    {
                        areaCode: '03041101',
                        areaName: '河津市',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041102',
                        areaName: '绛县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041103',
                        areaName: '稷山县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041104',
                        areaName: '临猗县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041105',
                        areaName: '平陆县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041106',
                        areaName: '芮城县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041107',
                        areaName: '万荣县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041108',
                        areaName: '闻喜县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041109',
                        areaName: '夏县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041110',
                        areaName: '新绛县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041111',
                        areaName: '盐湖区',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041112',
                        areaName: '永济市',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                    {
                        areaCode: '03041113',
                        areaName: '垣曲县',
                        areaLevel: '4',
                        parentCode: '030411',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0305',
        areaName: '河北省',
        areaLevel: '2',
        parentCode: '03',
        children: [
            {
                areaCode: '030501',
                areaName: '直辖县级行政区划',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050101',
                        areaName: '定州市',
                        areaLevel: '4',
                        parentCode: '030501',
                    },
                    {
                        areaCode: '03050102',
                        areaName: '辛集市',
                        areaLevel: '4',
                        parentCode: '030501',
                    },
                ],
            },
            {
                areaCode: '030502',
                areaName: '保定市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050201',
                        areaName: '安国市',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050202',
                        areaName: '安新县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050203',
                        areaName: '博野县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050204',
                        areaName: '定兴县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050205',
                        areaName: '阜平县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050206',
                        areaName: '高碑店市',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050207',
                        areaName: '高阳县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050208',
                        areaName: '竞秀区',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050209',
                        areaName: '涞水县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050210',
                        areaName: '涞源县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050211',
                        areaName: '莲池区',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050212',
                        areaName: '蠡县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050213',
                        areaName: '满城区',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050214',
                        areaName: '清苑区',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050215',
                        areaName: '曲阳县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050216',
                        areaName: '容城县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050217',
                        areaName: '顺平县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050218',
                        areaName: '唐县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050219',
                        areaName: '望都县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050220',
                        areaName: '雄县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050221',
                        areaName: '徐水区',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050222',
                        areaName: '易县',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                    {
                        areaCode: '03050223',
                        areaName: '涿州市',
                        areaLevel: '4',
                        parentCode: '030502',
                    },
                ],
            },
            {
                areaCode: '030503',
                areaName: '沧州市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050301',
                        areaName: '泊头市',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050302',
                        areaName: '沧县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050303',
                        areaName: '东光县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050304',
                        areaName: '海兴县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050305',
                        areaName: '河间市',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050306',
                        areaName: '孟村回族自治县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050307',
                        areaName: '南皮县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050308',
                        areaName: '青县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050309',
                        areaName: '任丘市',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050310',
                        areaName: '肃宁县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050311',
                        areaName: '吴桥县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050312',
                        areaName: '献县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050313',
                        areaName: '新华区',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050314',
                        areaName: '盐山县',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050315',
                        areaName: '运河区',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                    {
                        areaCode: '03050316',
                        areaName: '黄骅市',
                        areaLevel: '4',
                        parentCode: '030503',
                    },
                ],
            },
            {
                areaCode: '030504',
                areaName: '承德市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050401',
                        areaName: '承德县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050402',
                        areaName: '丰宁满族自治县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050403',
                        areaName: '宽城满族自治县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050404',
                        areaName: '隆化县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050405',
                        areaName: '滦平县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050406',
                        areaName: '平泉县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050407',
                        areaName: '双滦区',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050408',
                        areaName: '双桥区',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050409',
                        areaName: '围场满族蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050410',
                        areaName: '兴隆县',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                    {
                        areaCode: '03050411',
                        areaName: '鹰手营子矿区',
                        areaLevel: '4',
                        parentCode: '030504',
                    },
                ],
            },
            {
                areaCode: '030505',
                areaName: '邯郸市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050501',
                        areaName: '成安县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050502',
                        areaName: '磁县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050503',
                        areaName: '丛台区',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050504',
                        areaName: '大名县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050505',
                        areaName: '肥乡县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050506',
                        areaName: '峰峰矿区',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050507',
                        areaName: '复兴区',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050508',
                        areaName: '广平县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050509',
                        areaName: '馆陶县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050510',
                        areaName: '邯郸县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050511',
                        areaName: '邯山区',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050512',
                        areaName: '鸡泽县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050513',
                        areaName: '临漳县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050514',
                        areaName: '邱县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050515',
                        areaName: '曲周县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050516',
                        areaName: '涉县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050517',
                        areaName: '魏县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050518',
                        areaName: '武安市',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                    {
                        areaCode: '03050519',
                        areaName: '永年县',
                        areaLevel: '4',
                        parentCode: '030505',
                    },
                ],
            },
            {
                areaCode: '030506',
                areaName: '衡水市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050601',
                        areaName: '安平县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050602',
                        areaName: '阜城县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050603',
                        areaName: '故城县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050604',
                        areaName: '景县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050605',
                        areaName: '冀州市',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050606',
                        areaName: '饶阳县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050607',
                        areaName: '深州市',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050608',
                        areaName: '桃城区',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050609',
                        areaName: '武强县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050610',
                        areaName: '武邑县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                    {
                        areaCode: '03050611',
                        areaName: '枣强县',
                        areaLevel: '4',
                        parentCode: '030506',
                    },
                ],
            },
            {
                areaCode: '030507',
                areaName: '廊坊市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050701',
                        areaName: '安次区',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050702',
                        areaName: '霸州市',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050703',
                        areaName: '大厂回族自治县',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050704',
                        areaName: '大城县',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050705',
                        areaName: '广阳区',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050706',
                        areaName: '固安县',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050707',
                        areaName: '三河市',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050708',
                        areaName: '文安县',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050709',
                        areaName: '香河县',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                    {
                        areaCode: '03050710',
                        areaName: '永清县',
                        areaLevel: '4',
                        parentCode: '030507',
                    },
                ],
            },
            {
                areaCode: '030508',
                areaName: '秦皇岛市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050801',
                        areaName: '北戴河区',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                    {
                        areaCode: '03050802',
                        areaName: '昌黎县',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                    {
                        areaCode: '03050803',
                        areaName: '抚宁区',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                    {
                        areaCode: '03050804',
                        areaName: '海港区',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                    {
                        areaCode: '03050805',
                        areaName: '卢龙县',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                    {
                        areaCode: '03050806',
                        areaName: '青龙满族自治县',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                    {
                        areaCode: '03050807',
                        areaName: '山海关区',
                        areaLevel: '4',
                        parentCode: '030508',
                    },
                ],
            },
            {
                areaCode: '030509',
                areaName: '石家庄市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03050901',
                        areaName: '长安区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050902',
                        areaName: '藁城区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050903',
                        areaName: '高邑县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050904',
                        areaName: '井陉矿区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050905',
                        areaName: '井陉县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050906',
                        areaName: '晋州市',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050907',
                        areaName: '灵寿县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050908',
                        areaName: '栾城区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050909',
                        areaName: '鹿泉区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050910',
                        areaName: '平山县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050911',
                        areaName: '桥西区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050912',
                        areaName: '深泽县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050913',
                        areaName: '无极县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050914',
                        areaName: '行唐县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050915',
                        areaName: '新华区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050916',
                        areaName: '新乐市',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050917',
                        areaName: '元氏县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050918',
                        areaName: '裕华区',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050919',
                        areaName: '赞皇县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050920',
                        areaName: '赵县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                    {
                        areaCode: '03050921',
                        areaName: '正定县',
                        areaLevel: '4',
                        parentCode: '030509',
                    },
                ],
            },
            {
                areaCode: '030510',
                areaName: '唐山市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03051001',
                        areaName: '曹妃甸区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051002',
                        areaName: '丰南区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051003',
                        areaName: '丰润区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051004',
                        areaName: '古冶区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051005',
                        areaName: '开平区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051006',
                        areaName: '乐亭县',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051007',
                        areaName: '滦南县',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051008',
                        areaName: '滦县',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051009',
                        areaName: '路北区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051010',
                        areaName: '路南区',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051011',
                        areaName: '迁安市',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051012',
                        areaName: '迁西县',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051013',
                        areaName: '玉田县',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                    {
                        areaCode: '03051014',
                        areaName: '遵化市',
                        areaLevel: '4',
                        parentCode: '030510',
                    },
                ],
            },
            {
                areaCode: '030511',
                areaName: '邢台市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03051101',
                        areaName: '柏乡县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051102',
                        areaName: '广宗县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051103',
                        areaName: '巨鹿县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051104',
                        areaName: '临城县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051105',
                        areaName: '临西县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051106',
                        areaName: '隆尧县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051107',
                        areaName: '南宫市',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051108',
                        areaName: '南和县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051109',
                        areaName: '内丘县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051110',
                        areaName: '宁晋县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051111',
                        areaName: '平乡县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051112',
                        areaName: '桥东区',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051113',
                        areaName: '桥西区',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051114',
                        areaName: '清河县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051115',
                        areaName: '任县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051116',
                        areaName: '沙河市',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051117',
                        areaName: '威县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051118',
                        areaName: '邢台县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                    {
                        areaCode: '03051119',
                        areaName: '新河县',
                        areaLevel: '4',
                        parentCode: '030511',
                    },
                ],
            },
            {
                areaCode: '030512',
                areaName: '张家口市',
                areaLevel: '3',
                parentCode: '0305',
                children: [
                    {
                        areaCode: '03051201',
                        areaName: '赤城县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051202',
                        areaName: '崇礼县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051203',
                        areaName: '沽源县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051204',
                        areaName: '怀安县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051205',
                        areaName: '怀来县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051206',
                        areaName: '康保县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051207',
                        areaName: '桥东区',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051208',
                        areaName: '桥西区',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051209',
                        areaName: '尚义县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051210',
                        areaName: '万全县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051211',
                        areaName: '蔚县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051212',
                        areaName: '下花园区',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051213',
                        areaName: '宣化区',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051214',
                        areaName: '宣化县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051215',
                        areaName: '阳原县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051216',
                        areaName: '张北县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                    {
                        areaCode: '03051217',
                        areaName: '涿鹿县',
                        areaLevel: '4',
                        parentCode: '030512',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0306',
        areaName: '内蒙古自治区',
        areaLevel: '2',
        parentCode: '03',
        children: [
            {
                areaCode: '030601',
                areaName: '阿拉善盟',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060101',
                        areaName: '阿拉善右旗',
                        areaLevel: '4',
                        parentCode: '030601',
                    },
                    {
                        areaCode: '03060102',
                        areaName: '阿拉善左旗',
                        areaLevel: '4',
                        parentCode: '030601',
                    },
                    {
                        areaCode: '03060103',
                        areaName: '额济纳旗',
                        areaLevel: '4',
                        parentCode: '030601',
                    },
                ],
            },
            {
                areaCode: '030602',
                areaName: '包头市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060201',
                        areaName: '白云鄂博矿区',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060202',
                        areaName: '达尔罕茂明安联合旗',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060203',
                        areaName: '东河区',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060204',
                        areaName: '固阳县',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060205',
                        areaName: '九原区',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060206',
                        areaName: '昆都仑区',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060207',
                        areaName: '青山区',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060208',
                        areaName: '石拐区',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                    {
                        areaCode: '03060209',
                        areaName: '土默特右旗',
                        areaLevel: '4',
                        parentCode: '030602',
                    },
                ],
            },
            {
                areaCode: '030603',
                areaName: '巴彦淖尔市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060301',
                        areaName: '磴口县',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                    {
                        areaCode: '03060302',
                        areaName: '杭锦后旗',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                    {
                        areaCode: '03060303',
                        areaName: '临河区',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                    {
                        areaCode: '03060304',
                        areaName: '乌拉特后旗',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                    {
                        areaCode: '03060305',
                        areaName: '乌拉特前旗',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                    {
                        areaCode: '03060306',
                        areaName: '乌拉特中旗',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                    {
                        areaCode: '03060307',
                        areaName: '五原县',
                        areaLevel: '4',
                        parentCode: '030603',
                    },
                ],
            },
            {
                areaCode: '030604',
                areaName: '赤峰市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060401',
                        areaName: '阿鲁科尔沁旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060402',
                        areaName: '敖汉旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060403',
                        areaName: '巴林右旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060404',
                        areaName: '巴林左旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060405',
                        areaName: '红山区',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060406',
                        areaName: '喀喇沁旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060407',
                        areaName: '克什克腾旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060408',
                        areaName: '林西县',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060409',
                        areaName: '宁城县',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060410',
                        areaName: '松山区',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060411',
                        areaName: '翁牛特旗',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                    {
                        areaCode: '03060412',
                        areaName: '元宝山区',
                        areaLevel: '4',
                        parentCode: '030604',
                    },
                ],
            },
            {
                areaCode: '030605',
                areaName: '鄂尔多斯市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060501',
                        areaName: '达拉特旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060502',
                        areaName: '东胜区',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060503',
                        areaName: '鄂托克旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060504',
                        areaName: '鄂托克前旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060505',
                        areaName: '杭锦旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060506',
                        areaName: '乌审旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060507',
                        areaName: '伊金霍洛旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                    {
                        areaCode: '03060508',
                        areaName: '准格尔旗',
                        areaLevel: '4',
                        parentCode: '030605',
                    },
                ],
            },
            {
                areaCode: '030606',
                areaName: '呼和浩特市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060601',
                        areaName: '和林格尔县',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060602',
                        areaName: '回民区',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060603',
                        areaName: '清水河县',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060604',
                        areaName: '赛罕区',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060605',
                        areaName: '土默特左旗',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060606',
                        areaName: '托克托县',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060607',
                        areaName: '武川县',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060608',
                        areaName: '新城区',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                    {
                        areaCode: '03060609',
                        areaName: '玉泉区',
                        areaLevel: '4',
                        parentCode: '030606',
                    },
                ],
            },
            {
                areaCode: '030607',
                areaName: '呼伦贝尔市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060701',
                        areaName: '阿荣旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060702',
                        areaName: '陈巴尔虎旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060703',
                        areaName: '额尔古纳市',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060704',
                        areaName: '鄂伦春自治旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060705',
                        areaName: '鄂温克族自治旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060706',
                        areaName: '根河市',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060707',
                        areaName: '海拉尔区',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060708',
                        areaName: '满洲里市',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060709',
                        areaName: '莫力达瓦达斡尔族自治旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060710',
                        areaName: '新巴尔虎右旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060711',
                        areaName: '新巴尔虎左旗',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060712',
                        areaName: '牙克石市',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060713',
                        areaName: '扎赉诺尔区',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                    {
                        areaCode: '03060714',
                        areaName: '扎兰屯市',
                        areaLevel: '4',
                        parentCode: '030607',
                    },
                ],
            },
            {
                areaCode: '030608',
                areaName: '通辽市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060801',
                        areaName: '霍林郭勒市',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060802',
                        areaName: '开鲁县',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060803',
                        areaName: '科尔沁区',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060804',
                        areaName: '科尔沁左翼后旗',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060805',
                        areaName: '科尔沁左翼中旗',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060806',
                        areaName: '库伦旗',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060807',
                        areaName: '奈曼旗',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                    {
                        areaCode: '03060808',
                        areaName: '扎鲁特旗',
                        areaLevel: '4',
                        parentCode: '030608',
                    },
                ],
            },
            {
                areaCode: '030609',
                areaName: '乌海市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03060901',
                        areaName: '海勃湾区',
                        areaLevel: '4',
                        parentCode: '030609',
                    },
                    {
                        areaCode: '03060902',
                        areaName: '海南区',
                        areaLevel: '4',
                        parentCode: '030609',
                    },
                    {
                        areaCode: '03060903',
                        areaName: '乌达区',
                        areaLevel: '4',
                        parentCode: '030609',
                    },
                ],
            },
            {
                areaCode: '030610',
                areaName: '乌兰察布市',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03061001',
                        areaName: '察哈尔右翼后旗',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061002',
                        areaName: '察哈尔右翼前旗',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061003',
                        areaName: '察哈尔右翼中旗',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061004',
                        areaName: '丰镇市',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061005',
                        areaName: '化德县',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061006',
                        areaName: '集宁区',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061007',
                        areaName: '凉城县',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061008',
                        areaName: '商都县',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061009',
                        areaName: '四子王旗',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061010',
                        areaName: '兴和县',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                    {
                        areaCode: '03061011',
                        areaName: '卓资县',
                        areaLevel: '4',
                        parentCode: '030610',
                    },
                ],
            },
            {
                areaCode: '030611',
                areaName: '锡林郭勒盟',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03061101',
                        areaName: '阿巴嘎旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061102',
                        areaName: '二连浩特市',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061103',
                        areaName: '多伦县',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061104',
                        areaName: '东乌珠穆沁旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061105',
                        areaName: '苏尼特右旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061106',
                        areaName: '苏尼特左旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061107',
                        areaName: '太仆寺旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061108',
                        areaName: '镶黄旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061109',
                        areaName: '锡林浩特市',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061110',
                        areaName: '西乌珠穆沁旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061111',
                        areaName: '正蓝旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                    {
                        areaCode: '03061112',
                        areaName: '正镶白旗',
                        areaLevel: '4',
                        parentCode: '030611',
                    },
                ],
            },
            {
                areaCode: '030612',
                areaName: '兴安盟',
                areaLevel: '3',
                parentCode: '0306',
                children: [
                    {
                        areaCode: '03061201',
                        areaName: '阿尔山市',
                        areaLevel: '4',
                        parentCode: '030612',
                    },
                    {
                        areaCode: '03061202',
                        areaName: '科尔沁右翼前旗',
                        areaLevel: '4',
                        parentCode: '030612',
                    },
                    {
                        areaCode: '03061203',
                        areaName: '科尔沁右翼中旗',
                        areaLevel: '4',
                        parentCode: '030612',
                    },
                    {
                        areaCode: '03061204',
                        areaName: '突泉县',
                        areaLevel: '4',
                        parentCode: '030612',
                    },
                    {
                        areaCode: '03061205',
                        areaName: '乌兰浩特市',
                        areaLevel: '4',
                        parentCode: '030612',
                    },
                    {
                        areaCode: '03061206',
                        areaName: '扎赉特旗',
                        areaLevel: '4',
                        parentCode: '030612',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0401',
        areaName: '河南省',
        areaLevel: '2',
        parentCode: '04',
        children: [
            {
                areaCode: '040101',
                areaName: '直辖县级行政区划',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010101',
                        areaName: '济源市',
                        areaLevel: '4',
                        parentCode: '040101',
                    },
                ],
            },
            {
                areaCode: '040102',
                areaName: '安阳市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010201',
                        areaName: '安阳县',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010202',
                        areaName: '北关区',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010203',
                        areaName: '滑县',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010204',
                        areaName: '林州市',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010205',
                        areaName: '龙安区',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010206',
                        areaName: '内黄县',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010207',
                        areaName: '汤阴县',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010208',
                        areaName: '文峰区',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                    {
                        areaCode: '04010209',
                        areaName: '殷都区',
                        areaLevel: '4',
                        parentCode: '040102',
                    },
                ],
            },
            {
                areaCode: '040103',
                areaName: '鹤壁市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010301',
                        areaName: '鹤山区',
                        areaLevel: '4',
                        parentCode: '040103',
                    },
                    {
                        areaCode: '04010302',
                        areaName: '浚县',
                        areaLevel: '4',
                        parentCode: '040103',
                    },
                    {
                        areaCode: '04010303',
                        areaName: '淇滨区',
                        areaLevel: '4',
                        parentCode: '040103',
                    },
                    {
                        areaCode: '04010304',
                        areaName: '淇县',
                        areaLevel: '4',
                        parentCode: '040103',
                    },
                    {
                        areaCode: '04010305',
                        areaName: '山城区',
                        areaLevel: '4',
                        parentCode: '040103',
                    },
                ],
            },
            {
                areaCode: '040104',
                areaName: '焦作市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010401',
                        areaName: '博爱县',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010402',
                        areaName: '解放区',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010403',
                        areaName: '马村区',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010404',
                        areaName: '孟州市',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010405',
                        areaName: '沁阳市',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010406',
                        areaName: '山阳区',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010407',
                        areaName: '温县',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010408',
                        areaName: '武陟县',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010409',
                        areaName: '修武县',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                    {
                        areaCode: '04010410',
                        areaName: '中站区',
                        areaLevel: '4',
                        parentCode: '040104',
                    },
                ],
            },
            {
                areaCode: '040105',
                areaName: '开封市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010501',
                        areaName: '鼓楼区',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010502',
                        areaName: '金明区',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010503',
                        areaName: '兰考县',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010504',
                        areaName: '龙亭区',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010505',
                        areaName: '杞县',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010506',
                        areaName: '顺河回族区',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010507',
                        areaName: '通许县',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010508',
                        areaName: '尉氏县',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010509',
                        areaName: '祥符区',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                    {
                        areaCode: '04010510',
                        areaName: '禹王台区',
                        areaLevel: '4',
                        parentCode: '040105',
                    },
                ],
            },
            {
                areaCode: '040106',
                areaName: '漯河市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010601',
                        areaName: '临颍县',
                        areaLevel: '4',
                        parentCode: '040106',
                    },
                    {
                        areaCode: '04010602',
                        areaName: '舞阳县',
                        areaLevel: '4',
                        parentCode: '040106',
                    },
                    {
                        areaCode: '04010603',
                        areaName: '郾城区',
                        areaLevel: '4',
                        parentCode: '040106',
                    },
                    {
                        areaCode: '04010604',
                        areaName: '源汇区',
                        areaLevel: '4',
                        parentCode: '040106',
                    },
                    {
                        areaCode: '04010605',
                        areaName: '召陵区',
                        areaLevel: '4',
                        parentCode: '040106',
                    },
                ],
            },
            {
                areaCode: '040107',
                areaName: '洛阳市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010701',
                        areaName: '瀍河回族区',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010702',
                        areaName: '涧西区',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010703',
                        areaName: '吉利区',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010704',
                        areaName: '老城区',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010705',
                        areaName: '栾川县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010706',
                        areaName: '洛龙区',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010707',
                        areaName: '洛宁县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010708',
                        areaName: '孟津县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010709',
                        areaName: '汝阳县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010710',
                        areaName: '嵩县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010711',
                        areaName: '西工区',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010712',
                        areaName: '新安县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010713',
                        areaName: '偃师市',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010714',
                        areaName: '伊川县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                    {
                        areaCode: '04010715',
                        areaName: '宜阳县',
                        areaLevel: '4',
                        parentCode: '040107',
                    },
                ],
            },
            {
                areaCode: '040108',
                areaName: '南阳市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010801',
                        areaName: '邓州市',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010802',
                        areaName: '方城县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010803',
                        areaName: '南召县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010804',
                        areaName: '内乡县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010805',
                        areaName: '社旗县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010806',
                        areaName: '唐河县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010807',
                        areaName: '桐柏县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010808',
                        areaName: '宛城区',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010809',
                        areaName: '卧龙区',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010810',
                        areaName: '淅川县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010811',
                        areaName: '新野县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010812',
                        areaName: '西峡县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                    {
                        areaCode: '04010813',
                        areaName: '镇平县',
                        areaLevel: '4',
                        parentCode: '040108',
                    },
                ],
            },
            {
                areaCode: '040109',
                areaName: '平顶山市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04010901',
                        areaName: '宝丰县',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010902',
                        areaName: '郏县',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010903',
                        areaName: '鲁山县',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010904',
                        areaName: '汝州市',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010905',
                        areaName: '石龙区',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010906',
                        areaName: '卫东区',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010907',
                        areaName: '舞钢市',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010908',
                        areaName: '新华区',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010909',
                        areaName: '叶县',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010910',
                        areaName: '湛河区',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                    {
                        areaCode: '04010911',
                        areaName: '新城区',
                        areaLevel: '4',
                        parentCode: '040109',
                    },
                ],
            },
            {
                areaCode: '040110',
                areaName: '濮阳市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011001',
                        areaName: '范县',
                        areaLevel: '4',
                        parentCode: '040110',
                    },
                    {
                        areaCode: '04011002',
                        areaName: '华龙区',
                        areaLevel: '4',
                        parentCode: '040110',
                    },
                    {
                        areaCode: '04011003',
                        areaName: '南乐县',
                        areaLevel: '4',
                        parentCode: '040110',
                    },
                    {
                        areaCode: '04011004',
                        areaName: '濮阳县',
                        areaLevel: '4',
                        parentCode: '040110',
                    },
                    {
                        areaCode: '04011005',
                        areaName: '清丰县',
                        areaLevel: '4',
                        parentCode: '040110',
                    },
                    {
                        areaCode: '04011006',
                        areaName: '台前县',
                        areaLevel: '4',
                        parentCode: '040110',
                    },
                ],
            },
            {
                areaCode: '040111',
                areaName: '三门峡市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011101',
                        areaName: '湖滨区',
                        areaLevel: '4',
                        parentCode: '040111',
                    },
                    {
                        areaCode: '04011102',
                        areaName: '灵宝市',
                        areaLevel: '4',
                        parentCode: '040111',
                    },
                    {
                        areaCode: '04011103',
                        areaName: '卢氏县',
                        areaLevel: '4',
                        parentCode: '040111',
                    },
                    {
                        areaCode: '04011104',
                        areaName: '渑池县',
                        areaLevel: '4',
                        parentCode: '040111',
                    },
                    {
                        areaCode: '04011105',
                        areaName: '陕县',
                        areaLevel: '4',
                        parentCode: '040111',
                    },
                    {
                        areaCode: '04011106',
                        areaName: '义马市',
                        areaLevel: '4',
                        parentCode: '040111',
                    },
                ],
            },
            {
                areaCode: '040112',
                areaName: '商丘市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011201',
                        areaName: '梁园区',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011202',
                        areaName: '民权县',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011203',
                        areaName: '宁陵县',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011204',
                        areaName: '睢县',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011205',
                        areaName: '睢阳区',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011206',
                        areaName: '夏邑县',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011207',
                        areaName: '永城市',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011208',
                        areaName: '虞城县',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                    {
                        areaCode: '04011209',
                        areaName: '柘城县',
                        areaLevel: '4',
                        parentCode: '040112',
                    },
                ],
            },
            {
                areaCode: '040113',
                areaName: '新乡市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011301',
                        areaName: '长垣县',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011302',
                        areaName: '封丘县',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011303',
                        areaName: '凤泉区',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011304',
                        areaName: '红旗区',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011305',
                        areaName: '辉县市',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011306',
                        areaName: '获嘉县',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011307',
                        areaName: '牧野区',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011308',
                        areaName: '卫滨区',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011309',
                        areaName: '卫辉市',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011310',
                        areaName: '新乡县',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011311',
                        areaName: '延津县',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011312',
                        areaName: '原阳县',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                    {
                        areaCode: '04011313',
                        areaName: '平原示范区',
                        areaLevel: '4',
                        parentCode: '040113',
                    },
                ],
            },
            {
                areaCode: '040114',
                areaName: '信阳市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011401',
                        areaName: '光山县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011402',
                        areaName: '固始县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011403',
                        areaName: '淮滨县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011404',
                        areaName: '潢川县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011405',
                        areaName: '罗山县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011406',
                        areaName: '平桥区',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011407',
                        areaName: '商城县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011408',
                        areaName: '浉河区',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011409',
                        areaName: '新县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                    {
                        areaCode: '04011410',
                        areaName: '息县',
                        areaLevel: '4',
                        parentCode: '040114',
                    },
                ],
            },
            {
                areaCode: '040115',
                areaName: '许昌市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011501',
                        areaName: '长葛市',
                        areaLevel: '4',
                        parentCode: '040115',
                    },
                    {
                        areaCode: '04011502',
                        areaName: '魏都区',
                        areaLevel: '4',
                        parentCode: '040115',
                    },
                    {
                        areaCode: '04011503',
                        areaName: '襄城县',
                        areaLevel: '4',
                        parentCode: '040115',
                    },
                    {
                        areaCode: '04011504',
                        areaName: '许昌县',
                        areaLevel: '4',
                        parentCode: '040115',
                    },
                    {
                        areaCode: '04011505',
                        areaName: '鄢陵县',
                        areaLevel: '4',
                        parentCode: '040115',
                    },
                    {
                        areaCode: '04011506',
                        areaName: '禹州市',
                        areaLevel: '4',
                        parentCode: '040115',
                    },
                ],
            },
            {
                areaCode: '040116',
                areaName: '郑州市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011601',
                        areaName: '登封市',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011602',
                        areaName: '二七区',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011603',
                        areaName: '巩义市',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011604',
                        areaName: '管城回族区',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011605',
                        areaName: '惠济区',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011606',
                        areaName: '金水区',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011607',
                        areaName: '上街区',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011608',
                        areaName: '荥阳市',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011609',
                        areaName: '新密市',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011610',
                        areaName: '新郑市',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011611',
                        areaName: '中牟县',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                    {
                        areaCode: '04011612',
                        areaName: '中原区',
                        areaLevel: '4',
                        parentCode: '040116',
                    },
                ],
            },
            {
                areaCode: '040117',
                areaName: '周口市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011701',
                        areaName: '川汇区',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011702',
                        areaName: '郸城县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011703',
                        areaName: '扶沟县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011704',
                        areaName: '淮阳县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011705',
                        areaName: '鹿邑县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011706',
                        areaName: '商水县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011707',
                        areaName: '沈丘县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011708',
                        areaName: '太康县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011709',
                        areaName: '项城市',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                    {
                        areaCode: '04011710',
                        areaName: '西华县',
                        areaLevel: '4',
                        parentCode: '040117',
                    },
                ],
            },
            {
                areaCode: '040118',
                areaName: '驻马店市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011801',
                        areaName: '泌阳县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011802',
                        areaName: '平舆县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011803',
                        areaName: '确山县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011804',
                        areaName: '汝南县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011805',
                        areaName: '上蔡县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011806',
                        areaName: '遂平县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011807',
                        areaName: '新蔡县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011808',
                        areaName: '西平县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011809',
                        areaName: '驿城区',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                    {
                        areaCode: '04011810',
                        areaName: '正阳县',
                        areaLevel: '4',
                        parentCode: '040118',
                    },
                ],
            },
            {
                areaCode: '040119',
                areaName: '济源市',
                areaLevel: '3',
                parentCode: '0401',
                children: [
                    {
                        areaCode: '04011901',
                        areaName: '高新区',
                        areaLevel: '4',
                        parentCode: '040119',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0402',
        areaName: '湖北省',
        areaLevel: '2',
        parentCode: '04',
        children: [
            {
                areaCode: '040201',
                areaName: '省直辖县级行政区划',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020101',
                        areaName: '潜江市',
                        areaLevel: '4',
                        parentCode: '040201',
                    },
                    {
                        areaCode: '04020102',
                        areaName: '神农架林区',
                        areaLevel: '4',
                        parentCode: '040201',
                    },
                    {
                        areaCode: '04020103',
                        areaName: '天门市',
                        areaLevel: '4',
                        parentCode: '040201',
                    },
                    {
                        areaCode: '04020104',
                        areaName: '仙桃市',
                        areaLevel: '4',
                        parentCode: '040201',
                    },
                ],
            },
            {
                areaCode: '040202',
                areaName: '恩施土家族苗族自治州',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020201',
                        areaName: '巴东县',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020202',
                        areaName: '恩施市',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020203',
                        areaName: '鹤峰县',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020204',
                        areaName: '建始县',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020205',
                        areaName: '来凤县',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020206',
                        areaName: '利川市',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020207',
                        areaName: '咸丰县',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                    {
                        areaCode: '04020208',
                        areaName: '宣恩县',
                        areaLevel: '4',
                        parentCode: '040202',
                    },
                ],
            },
            {
                areaCode: '040203',
                areaName: '鄂州市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020301',
                        areaName: '鄂城区',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020302',
                        areaName: '华容区',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020303',
                        areaName: '梁子湖区',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020304',
                        areaName: '黄冈市',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020305',
                        areaName: '红安县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020306',
                        areaName: '黄梅县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020307',
                        areaName: '黄州区',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020308',
                        areaName: '罗田县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020309',
                        areaName: '麻城市',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020310',
                        areaName: '蕲春县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020311',
                        areaName: '团风县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020312',
                        areaName: '武穴市',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020313',
                        areaName: '浠水县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                    {
                        areaCode: '04020314',
                        areaName: '英山县',
                        areaLevel: '4',
                        parentCode: '040203',
                    },
                ],
            },
            {
                areaCode: '040204',
                areaName: '黄石市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020401',
                        areaName: '大冶市',
                        areaLevel: '4',
                        parentCode: '040204',
                    },
                    {
                        areaCode: '04020402',
                        areaName: '黄石港区',
                        areaLevel: '4',
                        parentCode: '040204',
                    },
                    {
                        areaCode: '04020403',
                        areaName: '铁山区',
                        areaLevel: '4',
                        parentCode: '040204',
                    },
                    {
                        areaCode: '04020404',
                        areaName: '下陆区',
                        areaLevel: '4',
                        parentCode: '040204',
                    },
                    {
                        areaCode: '04020405',
                        areaName: '西塞山区',
                        areaLevel: '4',
                        parentCode: '040204',
                    },
                    {
                        areaCode: '04020406',
                        areaName: '阳新县',
                        areaLevel: '4',
                        parentCode: '040204',
                    },
                ],
            },
            {
                areaCode: '040205',
                areaName: '荆门市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020501',
                        areaName: '东宝区',
                        areaLevel: '4',
                        parentCode: '040205',
                    },
                    {
                        areaCode: '04020502',
                        areaName: '掇刀区',
                        areaLevel: '4',
                        parentCode: '040205',
                    },
                    {
                        areaCode: '04020503',
                        areaName: '京山县',
                        areaLevel: '4',
                        parentCode: '040205',
                    },
                    {
                        areaCode: '04020504',
                        areaName: '沙洋县',
                        areaLevel: '4',
                        parentCode: '040205',
                    },
                    {
                        areaCode: '04020505',
                        areaName: '钟祥市',
                        areaLevel: '4',
                        parentCode: '040205',
                    },
                ],
            },
            {
                areaCode: '040206',
                areaName: '荆州市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020601',
                        areaName: '公安县',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020602',
                        areaName: '洪湖市',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020603',
                        areaName: '江陵县',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020604',
                        areaName: '监利县',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020605',
                        areaName: '荆州区',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020606',
                        areaName: '沙市区',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020607',
                        areaName: '石首市',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                    {
                        areaCode: '04020608',
                        areaName: '松滋市',
                        areaLevel: '4',
                        parentCode: '040206',
                    },
                ],
            },
            {
                areaCode: '040207',
                areaName: '十堰市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020701',
                        areaName: '丹江口市',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020702',
                        areaName: '房县',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020703',
                        areaName: '茅箭区',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020704',
                        areaName: '郧西县',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020705',
                        areaName: '郧阳区',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020706',
                        areaName: '张湾区',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020707',
                        areaName: '竹山县',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                    {
                        areaCode: '04020708',
                        areaName: '竹溪县',
                        areaLevel: '4',
                        parentCode: '040207',
                    },
                ],
            },
            {
                areaCode: '040208',
                areaName: '随州市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020801',
                        areaName: '广水市',
                        areaLevel: '4',
                        parentCode: '040208',
                    },
                    {
                        areaCode: '04020802',
                        areaName: '随县',
                        areaLevel: '4',
                        parentCode: '040208',
                    },
                    {
                        areaCode: '04020803',
                        areaName: '曾都区',
                        areaLevel: '4',
                        parentCode: '040208',
                    },
                ],
            },
            {
                areaCode: '040209',
                areaName: '武汉市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04020901',
                        areaName: '蔡甸区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020902',
                        areaName: '硚口区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020903',
                        areaName: '东西湖区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020904',
                        areaName: '汉南区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020905',
                        areaName: '汉阳区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020906',
                        areaName: '洪山区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020907',
                        areaName: '黄陂区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020908',
                        areaName: '江岸区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020909',
                        areaName: '江汉区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020910',
                        areaName: '江夏区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020911',
                        areaName: '青山区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020912',
                        areaName: '武昌区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                    {
                        areaCode: '04020913',
                        areaName: '新洲区',
                        areaLevel: '4',
                        parentCode: '040209',
                    },
                ],
            },
            {
                areaCode: '040210',
                areaName: '襄阳市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04021001',
                        areaName: '保康县',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021002',
                        areaName: '樊城区',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021003',
                        areaName: '谷城县',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021004',
                        areaName: '老河口市',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021005',
                        areaName: '南漳县',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021006',
                        areaName: '襄城区',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021007',
                        areaName: '襄州区',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021008',
                        areaName: '宜城市',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                    {
                        areaCode: '04021009',
                        areaName: '枣阳市',
                        areaLevel: '4',
                        parentCode: '040210',
                    },
                ],
            },
            {
                areaCode: '040211',
                areaName: '咸宁市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04021101',
                        areaName: '赤壁市',
                        areaLevel: '4',
                        parentCode: '040211',
                    },
                    {
                        areaCode: '04021102',
                        areaName: '崇阳县',
                        areaLevel: '4',
                        parentCode: '040211',
                    },
                    {
                        areaCode: '04021103',
                        areaName: '嘉鱼县',
                        areaLevel: '4',
                        parentCode: '040211',
                    },
                    {
                        areaCode: '04021104',
                        areaName: '通城县',
                        areaLevel: '4',
                        parentCode: '040211',
                    },
                    {
                        areaCode: '04021105',
                        areaName: '通山县',
                        areaLevel: '4',
                        parentCode: '040211',
                    },
                    {
                        areaCode: '04021106',
                        areaName: '咸安区',
                        areaLevel: '4',
                        parentCode: '040211',
                    },
                ],
            },
            {
                areaCode: '040212',
                areaName: '孝感市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04021201',
                        areaName: '安陆市',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                    {
                        areaCode: '04021202',
                        areaName: '大悟县',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                    {
                        areaCode: '04021203',
                        areaName: '汉川市',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                    {
                        areaCode: '04021204',
                        areaName: '孝昌县',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                    {
                        areaCode: '04021205',
                        areaName: '孝南区',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                    {
                        areaCode: '04021206',
                        areaName: '应城市',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                    {
                        areaCode: '04021207',
                        areaName: '云梦县',
                        areaLevel: '4',
                        parentCode: '040212',
                    },
                ],
            },
            {
                areaCode: '040213',
                areaName: '宜昌市',
                areaLevel: '3',
                parentCode: '0402',
                children: [
                    {
                        areaCode: '04021301',
                        areaName: '长阳土家族自治县',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021302',
                        areaName: '当阳市',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021303',
                        areaName: '点军区',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021304',
                        areaName: '五峰土家族自治县',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021305',
                        areaName: '伍家岗区',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021306',
                        areaName: '猇亭区',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021307',
                        areaName: '西陵区',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021308',
                        areaName: '兴山县',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021309',
                        areaName: '宜都市',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021310',
                        areaName: '夷陵区',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021311',
                        areaName: '远安县',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021312',
                        areaName: '枝江市',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                    {
                        areaCode: '04021313',
                        areaName: '秭归县',
                        areaLevel: '4',
                        parentCode: '040213',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0403',
        areaName: '江西省',
        areaLevel: '2',
        parentCode: '04',
        children: [
            {
                areaCode: '040301',
                areaName: '抚州市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030101',
                        areaName: '崇仁县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030102',
                        areaName: '东乡县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030103',
                        areaName: '广昌县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030104',
                        areaName: '金溪县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030105',
                        areaName: '乐安县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030106',
                        areaName: '黎川县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030107',
                        areaName: '临川区',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030108',
                        areaName: '南城县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030109',
                        areaName: '南丰县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030110',
                        areaName: '宜黄县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                    {
                        areaCode: '04030111',
                        areaName: '资溪县',
                        areaLevel: '4',
                        parentCode: '040301',
                    },
                ],
            },
            {
                areaCode: '040302',
                areaName: '赣州市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030201',
                        areaName: '安远县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030202',
                        areaName: '崇义县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030203',
                        areaName: '大余县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030204',
                        areaName: '定南县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030205',
                        areaName: '赣县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030206',
                        areaName: '会昌县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030207',
                        areaName: '龙南县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030208',
                        areaName: '南康区',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030209',
                        areaName: '宁都县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030210',
                        areaName: '全南县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030211',
                        areaName: '瑞金市',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030212',
                        areaName: '上犹县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030213',
                        areaName: '石城县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030214',
                        areaName: '信丰县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030215',
                        areaName: '兴国县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030216',
                        areaName: '寻乌县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030217',
                        areaName: '于都县',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                    {
                        areaCode: '04030218',
                        areaName: '章贡区',
                        areaLevel: '4',
                        parentCode: '040302',
                    },
                ],
            },
            {
                areaCode: '040303',
                areaName: '吉安市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030301',
                        areaName: '安福县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030302',
                        areaName: '吉安县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030303',
                        areaName: '井冈山市',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030304',
                        areaName: '吉水县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030305',
                        areaName: '吉州区',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030306',
                        areaName: '青原区',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030307',
                        areaName: '遂川县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030308',
                        areaName: '泰和县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030309',
                        areaName: '万安县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030310',
                        areaName: '峡江县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030311',
                        areaName: '新干县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030312',
                        areaName: '永丰县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                    {
                        areaCode: '04030313',
                        areaName: '永新县',
                        areaLevel: '4',
                        parentCode: '040303',
                    },
                ],
            },
            {
                areaCode: '040304',
                areaName: '景德镇市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030401',
                        areaName: '昌江区',
                        areaLevel: '4',
                        parentCode: '040304',
                    },
                    {
                        areaCode: '04030402',
                        areaName: '浮梁县',
                        areaLevel: '4',
                        parentCode: '040304',
                    },
                    {
                        areaCode: '04030403',
                        areaName: '乐平市',
                        areaLevel: '4',
                        parentCode: '040304',
                    },
                    {
                        areaCode: '04030404',
                        areaName: '珠山区',
                        areaLevel: '4',
                        parentCode: '040304',
                    },
                ],
            },
            {
                areaCode: '040305',
                areaName: '九江市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030501',
                        areaName: '德安县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030502',
                        areaName: '都昌县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030503',
                        areaName: '共青城市',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030504',
                        areaName: '湖口县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030505',
                        areaName: '九江县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030506',
                        areaName: '庐山区',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030507',
                        areaName: '彭泽县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030508',
                        areaName: '瑞昌市',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030509',
                        areaName: '武宁县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030510',
                        areaName: '星子县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030511',
                        areaName: '修水县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030512',
                        areaName: '浔阳区',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030513',
                        areaName: '永修县',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030514',
                        areaName: '柴桑区',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                    {
                        areaCode: '04030515',
                        areaName: '城西港区',
                        areaLevel: '4',
                        parentCode: '040305',
                    },
                ],
            },
            {
                areaCode: '040306',
                areaName: '南昌市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030601',
                        areaName: '安义县',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030602',
                        areaName: '东湖区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030603',
                        areaName: '进贤县',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030604',
                        areaName: '南昌县',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030605',
                        areaName: '青山湖区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030606',
                        areaName: '青云谱区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030607',
                        areaName: '湾里区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030608',
                        areaName: '西湖区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030609',
                        areaName: '新建区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                    {
                        areaCode: '04030610',
                        areaName: '红谷滩区',
                        areaLevel: '4',
                        parentCode: '040306',
                    },
                ],
            },
            {
                areaCode: '040307',
                areaName: '萍乡市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030701',
                        areaName: '安源区',
                        areaLevel: '4',
                        parentCode: '040307',
                    },
                    {
                        areaCode: '04030702',
                        areaName: '莲花县',
                        areaLevel: '4',
                        parentCode: '040307',
                    },
                    {
                        areaCode: '04030703',
                        areaName: '芦溪县',
                        areaLevel: '4',
                        parentCode: '040307',
                    },
                    {
                        areaCode: '04030704',
                        areaName: '上栗县',
                        areaLevel: '4',
                        parentCode: '040307',
                    },
                    {
                        areaCode: '04030705',
                        areaName: '湘东区',
                        areaLevel: '4',
                        parentCode: '040307',
                    },
                ],
            },
            {
                areaCode: '040308',
                areaName: '上饶市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030801',
                        areaName: '德兴市',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030802',
                        areaName: '广丰区',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030803',
                        areaName: '横峰县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030804',
                        areaName: '鄱阳县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030805',
                        areaName: '铅山县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030806',
                        areaName: '上饶县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030807',
                        areaName: '万年县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030808',
                        areaName: '婺源县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030809',
                        areaName: '信州区',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030810',
                        areaName: '弋阳县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030811',
                        areaName: '余干县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                    {
                        areaCode: '04030812',
                        areaName: '玉山县',
                        areaLevel: '4',
                        parentCode: '040308',
                    },
                ],
            },
            {
                areaCode: '040309',
                areaName: '新余市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04030901',
                        areaName: '分宜县',
                        areaLevel: '4',
                        parentCode: '040309',
                    },
                    {
                        areaCode: '04030902',
                        areaName: '渝水区',
                        areaLevel: '4',
                        parentCode: '040309',
                    },
                ],
            },
            {
                areaCode: '040310',
                areaName: '宜春市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04031001',
                        areaName: '丰城市',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031002',
                        areaName: '奉新县',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031003',
                        areaName: '高安市',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031004',
                        areaName: '靖安县',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031005',
                        areaName: '上高县',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031006',
                        areaName: '铜鼓县',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031007',
                        areaName: '万载县',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031008',
                        areaName: '宜丰县',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031009',
                        areaName: '袁州区',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                    {
                        areaCode: '04031010',
                        areaName: '樟树市',
                        areaLevel: '4',
                        parentCode: '040310',
                    },
                ],
            },
            {
                areaCode: '040311',
                areaName: '鹰潭市',
                areaLevel: '3',
                parentCode: '0403',
                children: [
                    {
                        areaCode: '04031101',
                        areaName: '贵溪市',
                        areaLevel: '4',
                        parentCode: '040311',
                    },
                    {
                        areaCode: '04031102',
                        areaName: '月湖区',
                        areaLevel: '4',
                        parentCode: '040311',
                    },
                    {
                        areaCode: '04031103',
                        areaName: '余江县',
                        areaLevel: '4',
                        parentCode: '040311',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0404',
        areaName: '湖南省',
        areaLevel: '2',
        parentCode: '04',
        children: [
            {
                areaCode: '040401',
                areaName: '常德市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040101',
                        areaName: '安乡县',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040102',
                        areaName: '鼎城区',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040103',
                        areaName: '汉寿县',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040104',
                        areaName: '津市市',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040105',
                        areaName: '临澧县',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040106',
                        areaName: '澧县',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040107',
                        areaName: '石门县',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040108',
                        areaName: '桃源县',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                    {
                        areaCode: '04040109',
                        areaName: '武陵区',
                        areaLevel: '4',
                        parentCode: '040401',
                    },
                ],
            },
            {
                areaCode: '040402',
                areaName: '长沙市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040201',
                        areaName: '长沙县',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040202',
                        areaName: '芙蓉区',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040203',
                        areaName: '开福区',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040204',
                        areaName: '浏阳市',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040205',
                        areaName: '宁乡县',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040206',
                        areaName: '天心区',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040207',
                        areaName: '望城区',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040208',
                        areaName: '岳麓区',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                    {
                        areaCode: '04040209',
                        areaName: '雨花区',
                        areaLevel: '4',
                        parentCode: '040402',
                    },
                ],
            },
            {
                areaCode: '040403',
                areaName: '郴州市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040301',
                        areaName: '安仁县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040302',
                        areaName: '北湖区',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040303',
                        areaName: '桂东县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040304',
                        areaName: '桂阳县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040305',
                        areaName: '嘉禾县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040306',
                        areaName: '临武县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040307',
                        areaName: '汝城县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040308',
                        areaName: '苏仙区',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040309',
                        areaName: '宜章县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040310',
                        areaName: '永兴县',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                    {
                        areaCode: '04040311',
                        areaName: '资兴市',
                        areaLevel: '4',
                        parentCode: '040403',
                    },
                ],
            },
            {
                areaCode: '040404',
                areaName: '衡阳市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040401',
                        areaName: '常宁市',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040402',
                        areaName: '衡东县',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040403',
                        areaName: '衡南县',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040404',
                        areaName: '衡山县',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040405',
                        areaName: '衡阳县',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040406',
                        areaName: '耒阳市',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040407',
                        areaName: '南岳区',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040408',
                        areaName: '祁东县',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040409',
                        areaName: '石鼓区',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040410',
                        areaName: '雁峰区',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040411',
                        areaName: '蒸湘区',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                    {
                        areaCode: '04040412',
                        areaName: '珠晖区',
                        areaLevel: '4',
                        parentCode: '040404',
                    },
                ],
            },
            {
                areaCode: '040405',
                areaName: '怀化市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040501',
                        areaName: '辰溪县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040502',
                        areaName: '鹤城区',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040503',
                        areaName: '洪江市',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040504',
                        areaName: '会同县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040505',
                        areaName: '靖州苗族侗族自治县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040506',
                        areaName: '麻阳苗族自治县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040507',
                        areaName: '通道侗族自治县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040508',
                        areaName: '新晃侗族自治县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040509',
                        areaName: '溆浦县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040510',
                        areaName: '沅陵县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040511',
                        areaName: '芷江侗族自治县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                    {
                        areaCode: '04040512',
                        areaName: '中方县',
                        areaLevel: '4',
                        parentCode: '040405',
                    },
                ],
            },
            {
                areaCode: '040406',
                areaName: '娄底市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040601',
                        areaName: '冷水江市',
                        areaLevel: '4',
                        parentCode: '040406',
                    },
                    {
                        areaCode: '04040602',
                        areaName: '涟源市',
                        areaLevel: '4',
                        parentCode: '040406',
                    },
                    {
                        areaCode: '04040603',
                        areaName: '娄星区',
                        areaLevel: '4',
                        parentCode: '040406',
                    },
                    {
                        areaCode: '04040604',
                        areaName: '双峰县',
                        areaLevel: '4',
                        parentCode: '040406',
                    },
                    {
                        areaCode: '04040605',
                        areaName: '新化县',
                        areaLevel: '4',
                        parentCode: '040406',
                    },
                ],
            },
            {
                areaCode: '040407',
                areaName: '邵阳市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040701',
                        areaName: '北塔区',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040702',
                        areaName: '城步苗族自治县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040703',
                        areaName: '大祥区',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040704',
                        areaName: '洞口县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040705',
                        areaName: '隆回县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040706',
                        areaName: '邵东县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040707',
                        areaName: '邵阳县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040708',
                        areaName: '双清区',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040709',
                        areaName: '绥宁县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040710',
                        areaName: '武冈市',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040711',
                        areaName: '新宁县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                    {
                        areaCode: '04040712',
                        areaName: '新邵县',
                        areaLevel: '4',
                        parentCode: '040407',
                    },
                ],
            },
            {
                areaCode: '040408',
                areaName: '湘潭市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040801',
                        areaName: '韶山市',
                        areaLevel: '4',
                        parentCode: '040408',
                    },
                    {
                        areaCode: '04040802',
                        areaName: '湘潭县',
                        areaLevel: '4',
                        parentCode: '040408',
                    },
                    {
                        areaCode: '04040803',
                        areaName: '湘乡市',
                        areaLevel: '4',
                        parentCode: '040408',
                    },
                    {
                        areaCode: '04040804',
                        areaName: '岳塘区',
                        areaLevel: '4',
                        parentCode: '040408',
                    },
                    {
                        areaCode: '04040805',
                        areaName: '雨湖区',
                        areaLevel: '4',
                        parentCode: '040408',
                    },
                ],
            },
            {
                areaCode: '040409',
                areaName: '湘西土家族苗族自治州',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04040901',
                        areaName: '保靖县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040902',
                        areaName: '凤凰县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040903',
                        areaName: '古丈县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040904',
                        areaName: '花垣县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040905',
                        areaName: '吉首市',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040906',
                        areaName: '龙山县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040907',
                        areaName: '泸溪县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                    {
                        areaCode: '04040908',
                        areaName: '永顺县',
                        areaLevel: '4',
                        parentCode: '040409',
                    },
                ],
            },
            {
                areaCode: '040410',
                areaName: '益阳市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04041001',
                        areaName: '安化县',
                        areaLevel: '4',
                        parentCode: '040410',
                    },
                    {
                        areaCode: '04041002',
                        areaName: '赫山区',
                        areaLevel: '4',
                        parentCode: '040410',
                    },
                    {
                        areaCode: '04041003',
                        areaName: '南县',
                        areaLevel: '4',
                        parentCode: '040410',
                    },
                    {
                        areaCode: '04041004',
                        areaName: '桃江县',
                        areaLevel: '4',
                        parentCode: '040410',
                    },
                    {
                        areaCode: '04041005',
                        areaName: '沅江市',
                        areaLevel: '4',
                        parentCode: '040410',
                    },
                    {
                        areaCode: '04041006',
                        areaName: '资阳区',
                        areaLevel: '4',
                        parentCode: '040410',
                    },
                ],
            },
            {
                areaCode: '040411',
                areaName: '永州市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04041101',
                        areaName: '道县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041102',
                        areaName: '东安县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041103',
                        areaName: '江华瑶族自治县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041104',
                        areaName: '江永县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041105',
                        areaName: '蓝山县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041106',
                        areaName: '冷水滩区',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041107',
                        areaName: '零陵区',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041108',
                        areaName: '宁远县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041109',
                        areaName: '祁阳县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041110',
                        areaName: '双牌县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                    {
                        areaCode: '04041111',
                        areaName: '新田县',
                        areaLevel: '4',
                        parentCode: '040411',
                    },
                ],
            },
            {
                areaCode: '040412',
                areaName: '岳阳市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04041201',
                        areaName: '华容县',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041202',
                        areaName: '君山区',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041203',
                        areaName: '临湘市',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041204',
                        areaName: '汨罗市',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041205',
                        areaName: '平江县',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041206',
                        areaName: '湘阴县',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041207',
                        areaName: '岳阳楼区',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041208',
                        areaName: '岳阳县',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                    {
                        areaCode: '04041209',
                        areaName: '云溪区',
                        areaLevel: '4',
                        parentCode: '040412',
                    },
                ],
            },
            {
                areaCode: '040413',
                areaName: '张家界市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04041301',
                        areaName: '慈利县',
                        areaLevel: '4',
                        parentCode: '040413',
                    },
                    {
                        areaCode: '04041302',
                        areaName: '桑植县',
                        areaLevel: '4',
                        parentCode: '040413',
                    },
                    {
                        areaCode: '04041303',
                        areaName: '武陵源区',
                        areaLevel: '4',
                        parentCode: '040413',
                    },
                    {
                        areaCode: '04041304',
                        areaName: '永定区',
                        areaLevel: '4',
                        parentCode: '040413',
                    },
                ],
            },
            {
                areaCode: '040414',
                areaName: '株洲市',
                areaLevel: '3',
                parentCode: '0404',
                children: [
                    {
                        areaCode: '04041401',
                        areaName: '茶陵县',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041402',
                        areaName: '荷塘区',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041403',
                        areaName: '醴陵市',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041404',
                        areaName: '芦淞区',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041405',
                        areaName: '石峰区',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041406',
                        areaName: '天元区',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041407',
                        areaName: '炎陵县',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041408',
                        areaName: '攸县',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                    {
                        areaCode: '04041409',
                        areaName: '株洲县',
                        areaLevel: '4',
                        parentCode: '040414',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0501',
        areaName: '广东省',
        areaLevel: '2',
        parentCode: '05',
        children: [
            {
                areaCode: '050101',
                areaName: '潮州市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010101',
                        areaName: '潮安区',
                        areaLevel: '4',
                        parentCode: '050101',
                    },
                    {
                        areaCode: '05010102',
                        areaName: '饶平县',
                        areaLevel: '4',
                        parentCode: '050101',
                    },
                    {
                        areaCode: '05010103',
                        areaName: '湘桥区',
                        areaLevel: '4',
                        parentCode: '050101',
                    },
                ],
            },
            {
                areaCode: '050102',
                areaName: '东莞市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010201',
                        areaName: '茶山镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010202',
                        areaName: '常平镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010203',
                        areaName: '大朗镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010204',
                        areaName: '大岭山镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010205',
                        areaName: '道滘镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010206',
                        areaName: '东城街道',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010207',
                        areaName: '东坑镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010208',
                        areaName: '凤岗镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010209',
                        areaName: '高埗镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010210',
                        areaName: '莞城街道',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010211',
                        areaName: '横沥镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010212',
                        areaName: '洪梅镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010213',
                        areaName: '厚街镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010214',
                        areaName: '虎门镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010215',
                        areaName: '黄江镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010216',
                        areaName: '寮步镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010217',
                        areaName: '麻涌镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010218',
                        areaName: '南城街道',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010219',
                        areaName: '企石镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010220',
                        areaName: '桥头镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010221',
                        areaName: '清溪镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010222',
                        areaName: '沙田镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010223',
                        areaName: '石碣镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010224',
                        areaName: '石龙镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010225',
                        areaName: '石排镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010226',
                        areaName: '松山湖',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010227',
                        areaName: '塘厦镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010228',
                        areaName: '万江区',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010229',
                        areaName: '望牛墩镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010230',
                        areaName: '谢岗镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010231',
                        areaName: '樟木头镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010232',
                        areaName: '长安镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                    {
                        areaCode: '05010233',
                        areaName: '中堂镇',
                        areaLevel: '4',
                        parentCode: '050102',
                    },
                ],
            },
            {
                areaCode: '050103',
                areaName: '佛山市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010301',
                        areaName: '禅城区',
                        areaLevel: '4',
                        parentCode: '050103',
                    },
                    {
                        areaCode: '05010302',
                        areaName: '高明区',
                        areaLevel: '4',
                        parentCode: '050103',
                    },
                    {
                        areaCode: '05010303',
                        areaName: '南海区',
                        areaLevel: '4',
                        parentCode: '050103',
                    },
                    {
                        areaCode: '05010304',
                        areaName: '三水区',
                        areaLevel: '4',
                        parentCode: '050103',
                    },
                    {
                        areaCode: '05010305',
                        areaName: '顺德区',
                        areaLevel: '4',
                        parentCode: '050103',
                    },
                ],
            },
            {
                areaCode: '050104',
                areaName: '广州市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010401',
                        areaName: '白云区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010402',
                        areaName: '从化区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010403',
                        areaName: '海珠区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010404',
                        areaName: '花都区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010405',
                        areaName: '黄埔区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010406',
                        areaName: '荔湾区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010407',
                        areaName: '南沙区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010408',
                        areaName: '番禺区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010409',
                        areaName: '天河区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010410',
                        areaName: '越秀区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                    {
                        areaCode: '05010411',
                        areaName: '增城区',
                        areaLevel: '4',
                        parentCode: '050104',
                    },
                ],
            },
            {
                areaCode: '050105',
                areaName: '河源市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010501',
                        areaName: '东源县',
                        areaLevel: '4',
                        parentCode: '050105',
                    },
                    {
                        areaCode: '05010502',
                        areaName: '和平县',
                        areaLevel: '4',
                        parentCode: '050105',
                    },
                    {
                        areaCode: '05010503',
                        areaName: '连平县',
                        areaLevel: '4',
                        parentCode: '050105',
                    },
                    {
                        areaCode: '05010504',
                        areaName: '龙川县',
                        areaLevel: '4',
                        parentCode: '050105',
                    },
                    {
                        areaCode: '05010505',
                        areaName: '源城区',
                        areaLevel: '4',
                        parentCode: '050105',
                    },
                    {
                        areaCode: '05010506',
                        areaName: '紫金县',
                        areaLevel: '4',
                        parentCode: '050105',
                    },
                ],
            },
            {
                areaCode: '050106',
                areaName: '惠州市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010601',
                        areaName: '博罗县',
                        areaLevel: '4',
                        parentCode: '050106',
                    },
                    {
                        areaCode: '05010602',
                        areaName: '惠城区',
                        areaLevel: '4',
                        parentCode: '050106',
                    },
                    {
                        areaCode: '05010603',
                        areaName: '惠东县',
                        areaLevel: '4',
                        parentCode: '050106',
                    },
                    {
                        areaCode: '05010604',
                        areaName: '惠阳区',
                        areaLevel: '4',
                        parentCode: '050106',
                    },
                    {
                        areaCode: '05010605',
                        areaName: '龙门县',
                        areaLevel: '4',
                        parentCode: '050106',
                    },
                ],
            },
            {
                areaCode: '050107',
                areaName: '江门市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010701',
                        areaName: '恩平市',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                    {
                        areaCode: '05010702',
                        areaName: '鹤山市',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                    {
                        areaCode: '05010703',
                        areaName: '江海区',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                    {
                        areaCode: '05010704',
                        areaName: '开平市',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                    {
                        areaCode: '05010705',
                        areaName: '蓬江区',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                    {
                        areaCode: '05010706',
                        areaName: '台山市',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                    {
                        areaCode: '05010707',
                        areaName: '新会区',
                        areaLevel: '4',
                        parentCode: '050107',
                    },
                ],
            },
            {
                areaCode: '050108',
                areaName: '揭阳市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010801',
                        areaName: '惠来县',
                        areaLevel: '4',
                        parentCode: '050108',
                    },
                    {
                        areaCode: '05010802',
                        areaName: '揭东区',
                        areaLevel: '4',
                        parentCode: '050108',
                    },
                    {
                        areaCode: '05010803',
                        areaName: '揭西县',
                        areaLevel: '4',
                        parentCode: '050108',
                    },
                    {
                        areaCode: '05010804',
                        areaName: '普宁市',
                        areaLevel: '4',
                        parentCode: '050108',
                    },
                    {
                        areaCode: '05010805',
                        areaName: '榕城区',
                        areaLevel: '4',
                        parentCode: '050108',
                    },
                ],
            },
            {
                areaCode: '050109',
                areaName: '茂名市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05010901',
                        areaName: '电白区',
                        areaLevel: '4',
                        parentCode: '050109',
                    },
                    {
                        areaCode: '05010902',
                        areaName: '高州市',
                        areaLevel: '4',
                        parentCode: '050109',
                    },
                    {
                        areaCode: '05010903',
                        areaName: '化州市',
                        areaLevel: '4',
                        parentCode: '050109',
                    },
                    {
                        areaCode: '05010904',
                        areaName: '茂南区',
                        areaLevel: '4',
                        parentCode: '050109',
                    },
                    {
                        areaCode: '05010905',
                        areaName: '信宜市',
                        areaLevel: '4',
                        parentCode: '050109',
                    },
                ],
            },
            {
                areaCode: '050110',
                areaName: '梅州市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011001',
                        areaName: '大埔县',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011002',
                        areaName: '丰顺县',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011003',
                        areaName: '蕉岭县',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011004',
                        areaName: '梅江区',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011005',
                        areaName: '梅县区',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011006',
                        areaName: '平远县',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011007',
                        areaName: '五华县',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                    {
                        areaCode: '05011008',
                        areaName: '兴宁市',
                        areaLevel: '4',
                        parentCode: '050110',
                    },
                ],
            },
            {
                areaCode: '050111',
                areaName: '清远市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011101',
                        areaName: '佛冈县',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011102',
                        areaName: '连南瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011103',
                        areaName: '连山壮族瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011104',
                        areaName: '连州市',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011105',
                        areaName: '清城区',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011106',
                        areaName: '清新区',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011107',
                        areaName: '阳山县',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                    {
                        areaCode: '05011108',
                        areaName: '英德市',
                        areaLevel: '4',
                        parentCode: '050111',
                    },
                ],
            },
            {
                areaCode: '050112',
                areaName: '汕头市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011201',
                        areaName: '潮南区',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                    {
                        areaCode: '05011202',
                        areaName: '潮阳区',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                    {
                        areaCode: '05011203',
                        areaName: '澄海区',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                    {
                        areaCode: '05011204',
                        areaName: '濠江区',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                    {
                        areaCode: '05011205',
                        areaName: '金平区',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                    {
                        areaCode: '05011206',
                        areaName: '龙湖区',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                    {
                        areaCode: '05011207',
                        areaName: '南澳县',
                        areaLevel: '4',
                        parentCode: '050112',
                    },
                ],
            },
            {
                areaCode: '050113',
                areaName: '汕尾市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011301',
                        areaName: '城区',
                        areaLevel: '4',
                        parentCode: '050113',
                    },
                    {
                        areaCode: '05011302',
                        areaName: '海丰县',
                        areaLevel: '4',
                        parentCode: '050113',
                    },
                    {
                        areaCode: '05011303',
                        areaName: '陆丰市',
                        areaLevel: '4',
                        parentCode: '050113',
                    },
                    {
                        areaCode: '05011304',
                        areaName: '陆河县',
                        areaLevel: '4',
                        parentCode: '050113',
                    },
                ],
            },
            {
                areaCode: '050114',
                areaName: '韶关市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011401',
                        areaName: '乐昌市',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011402',
                        areaName: '南雄市',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011403',
                        areaName: '曲江区',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011404',
                        areaName: '仁化县',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011405',
                        areaName: '乳源瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011406',
                        areaName: '始兴县',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011407',
                        areaName: '翁源县',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011408',
                        areaName: '武江区',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011409',
                        areaName: '新丰县',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                    {
                        areaCode: '05011410',
                        areaName: '浈江区',
                        areaLevel: '4',
                        parentCode: '050114',
                    },
                ],
            },
            {
                areaCode: '050115',
                areaName: '深圳市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011501',
                        areaName: '宝安区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011502',
                        areaName: '福田区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011503',
                        areaName: '龙岗区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011504',
                        areaName: '罗湖区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011505',
                        areaName: '南山区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011506',
                        areaName: '盐田区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011507',
                        areaName: '龙华区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011508',
                        areaName: '坪山区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                    {
                        areaCode: '05011509',
                        areaName: '光明区',
                        areaLevel: '4',
                        parentCode: '050115',
                    },
                ],
            },
            {
                areaCode: '050116',
                areaName: '阳江市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011601',
                        areaName: '江城区',
                        areaLevel: '4',
                        parentCode: '050116',
                    },
                    {
                        areaCode: '05011602',
                        areaName: '阳春市',
                        areaLevel: '4',
                        parentCode: '050116',
                    },
                    {
                        areaCode: '05011603',
                        areaName: '阳东区',
                        areaLevel: '4',
                        parentCode: '050116',
                    },
                    {
                        areaCode: '05011604',
                        areaName: '阳西县',
                        areaLevel: '4',
                        parentCode: '050116',
                    },
                ],
            },
            {
                areaCode: '050117',
                areaName: '云浮市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011701',
                        areaName: '罗定市',
                        areaLevel: '4',
                        parentCode: '050117',
                    },
                    {
                        areaCode: '05011702',
                        areaName: '新兴县',
                        areaLevel: '4',
                        parentCode: '050117',
                    },
                    {
                        areaCode: '05011703',
                        areaName: '云安区',
                        areaLevel: '4',
                        parentCode: '050117',
                    },
                    {
                        areaCode: '05011704',
                        areaName: '郁南县',
                        areaLevel: '4',
                        parentCode: '050117',
                    },
                    {
                        areaCode: '05011705',
                        areaName: '云城区',
                        areaLevel: '4',
                        parentCode: '050117',
                    },
                ],
            },
            {
                areaCode: '050118',
                areaName: '湛江市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011801',
                        areaName: '赤坎区',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011802',
                        areaName: '雷州市',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011803',
                        areaName: '廉江市',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011804',
                        areaName: '麻章区',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011805',
                        areaName: '坡头区',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011806',
                        areaName: '遂溪县',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011807',
                        areaName: '吴川市',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011808',
                        areaName: '霞山区',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                    {
                        areaCode: '05011809',
                        areaName: '徐闻县',
                        areaLevel: '4',
                        parentCode: '050118',
                    },
                ],
            },
            {
                areaCode: '050119',
                areaName: '肇庆市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05011901',
                        areaName: '德庆县',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011902',
                        areaName: '鼎湖区',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011903',
                        areaName: '端州区',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011904',
                        areaName: '封开县',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011905',
                        areaName: '高要区',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011906',
                        areaName: '广宁县',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011907',
                        areaName: '怀集县',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                    {
                        areaCode: '05011908',
                        areaName: '四会市',
                        areaLevel: '4',
                        parentCode: '050119',
                    },
                ],
            },
            {
                areaCode: '050120',
                areaName: '中山市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05012001',
                        areaName: '石岐街道',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012002',
                        areaName: '黄圃镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012003',
                        areaName: '东区街道',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012004',
                        areaName: '南头镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012005',
                        areaName: '西区街道',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012006',
                        areaName: '东凤镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012007',
                        areaName: '南区街道',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012008',
                        areaName: '阜沙镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012009',
                        areaName: '五桂山街道',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012010',
                        areaName: '小榄镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012011',
                        areaName: '中山火炬高技术产业开发区',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012012',
                        areaName: '东升镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012013',
                        areaName: '古镇镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012014',
                        areaName: '坦洲镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012015',
                        areaName: '神湾镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012016',
                        areaName: '板芙镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012017',
                        areaName: '三乡镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012018',
                        areaName: '沙溪镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012019',
                        areaName: '大涌镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012020',
                        areaName: '港口镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012021',
                        areaName: '南朗镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012022',
                        areaName: '民众镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012023',
                        areaName: '三角镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                    {
                        areaCode: '05012024',
                        areaName: '横栏镇',
                        areaLevel: '4',
                        parentCode: '050120',
                    },
                ],
            },
            {
                areaCode: '050121',
                areaName: '珠海市',
                areaLevel: '3',
                parentCode: '0501',
                children: [
                    {
                        areaCode: '05012101',
                        areaName: '斗门区',
                        areaLevel: '4',
                        parentCode: '050121',
                    },
                    {
                        areaCode: '05012102',
                        areaName: '金湾区',
                        areaLevel: '4',
                        parentCode: '050121',
                    },
                    {
                        areaCode: '05012103',
                        areaName: '香洲区',
                        areaLevel: '4',
                        parentCode: '050121',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0502',
        areaName: '广西壮族自治区',
        areaLevel: '2',
        parentCode: '05',
        children: [
            {
                areaCode: '050201',
                areaName: '百色市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020101',
                        areaName: '德保县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020102',
                        areaName: '靖西市',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020103',
                        areaName: '乐业县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020104',
                        areaName: '凌云县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020105',
                        areaName: '隆林各族自治县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020106',
                        areaName: '那坡县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020107',
                        areaName: '平果县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020108',
                        areaName: '田东县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020109',
                        areaName: '田林县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020110',
                        areaName: '田阳县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020111',
                        areaName: '西林县',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                    {
                        areaCode: '05020112',
                        areaName: '右江区',
                        areaLevel: '4',
                        parentCode: '050201',
                    },
                ],
            },
            {
                areaCode: '050202',
                areaName: '北海市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020201',
                        areaName: '海城区',
                        areaLevel: '4',
                        parentCode: '050202',
                    },
                    {
                        areaCode: '05020202',
                        areaName: '合浦县',
                        areaLevel: '4',
                        parentCode: '050202',
                    },
                    {
                        areaCode: '05020203',
                        areaName: '铁山港区',
                        areaLevel: '4',
                        parentCode: '050202',
                    },
                    {
                        areaCode: '05020204',
                        areaName: '银海区',
                        areaLevel: '4',
                        parentCode: '050202',
                    },
                ],
            },
            {
                areaCode: '050203',
                areaName: '崇左市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020301',
                        areaName: '大新县',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                    {
                        areaCode: '05020302',
                        areaName: '扶绥县',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                    {
                        areaCode: '05020303',
                        areaName: '江州区',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                    {
                        areaCode: '05020304',
                        areaName: '龙州县',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                    {
                        areaCode: '05020305',
                        areaName: '宁明县',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                    {
                        areaCode: '05020306',
                        areaName: '凭祥市',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                    {
                        areaCode: '05020307',
                        areaName: '天等县',
                        areaLevel: '4',
                        parentCode: '050203',
                    },
                ],
            },
            {
                areaCode: '050204',
                areaName: '防城港市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020401',
                        areaName: '东兴市',
                        areaLevel: '4',
                        parentCode: '050204',
                    },
                    {
                        areaCode: '05020402',
                        areaName: '防城区',
                        areaLevel: '4',
                        parentCode: '050204',
                    },
                    {
                        areaCode: '05020403',
                        areaName: '港口区',
                        areaLevel: '4',
                        parentCode: '050204',
                    },
                    {
                        areaCode: '05020404',
                        areaName: '上思县',
                        areaLevel: '4',
                        parentCode: '050204',
                    },
                ],
            },
            {
                areaCode: '050205',
                areaName: '贵港市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020501',
                        areaName: '港北区',
                        areaLevel: '4',
                        parentCode: '050205',
                    },
                    {
                        areaCode: '05020502',
                        areaName: '港南区',
                        areaLevel: '4',
                        parentCode: '050205',
                    },
                    {
                        areaCode: '05020503',
                        areaName: '桂平市',
                        areaLevel: '4',
                        parentCode: '050205',
                    },
                    {
                        areaCode: '05020504',
                        areaName: '平南县',
                        areaLevel: '4',
                        parentCode: '050205',
                    },
                    {
                        areaCode: '05020505',
                        areaName: '覃塘区',
                        areaLevel: '4',
                        parentCode: '050205',
                    },
                ],
            },
            {
                areaCode: '050206',
                areaName: '桂林市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020601',
                        areaName: '叠彩区',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020602',
                        areaName: '恭城瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020603',
                        areaName: '灌阳县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020604',
                        areaName: '灵川县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020605',
                        areaName: '临桂区',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020606',
                        areaName: '荔浦县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020607',
                        areaName: '龙胜各族自治县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020608',
                        areaName: '平乐县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020609',
                        areaName: '七星区',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020610',
                        areaName: '全州县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020611',
                        areaName: '象山区',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020612',
                        areaName: '兴安县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020613',
                        areaName: '秀峰区',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020614',
                        areaName: '阳朔县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020615',
                        areaName: '雁山区',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020616',
                        areaName: '永福县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                    {
                        areaCode: '05020617',
                        areaName: '资源县',
                        areaLevel: '4',
                        parentCode: '050206',
                    },
                ],
            },
            {
                areaCode: '050207',
                areaName: '河池市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020701',
                        areaName: '巴马瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020702',
                        areaName: '大化瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020703',
                        areaName: '都安瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020704',
                        areaName: '东兰县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020705',
                        areaName: '凤山县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020706',
                        areaName: '环江毛南族自治县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020707',
                        areaName: '金城江区',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020708',
                        areaName: '罗城仫佬族自治县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020709',
                        areaName: '南丹县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020710',
                        areaName: '天峨县',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                    {
                        areaCode: '05020711',
                        areaName: '宜州市',
                        areaLevel: '4',
                        parentCode: '050207',
                    },
                ],
            },
            {
                areaCode: '050208',
                areaName: '贺州市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020801',
                        areaName: '八步区',
                        areaLevel: '4',
                        parentCode: '050208',
                    },
                    {
                        areaCode: '05020802',
                        areaName: '富川瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050208',
                    },
                    {
                        areaCode: '05020803',
                        areaName: '昭平县',
                        areaLevel: '4',
                        parentCode: '050208',
                    },
                    {
                        areaCode: '05020804',
                        areaName: '钟山县',
                        areaLevel: '4',
                        parentCode: '050208',
                    },
                ],
            },
            {
                areaCode: '050209',
                areaName: '来宾市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05020901',
                        areaName: '合山市',
                        areaLevel: '4',
                        parentCode: '050209',
                    },
                    {
                        areaCode: '05020902',
                        areaName: '金秀瑶族自治县',
                        areaLevel: '4',
                        parentCode: '050209',
                    },
                    {
                        areaCode: '05020903',
                        areaName: '武宣县',
                        areaLevel: '4',
                        parentCode: '050209',
                    },
                    {
                        areaCode: '05020904',
                        areaName: '象州县',
                        areaLevel: '4',
                        parentCode: '050209',
                    },
                    {
                        areaCode: '05020905',
                        areaName: '忻城县',
                        areaLevel: '4',
                        parentCode: '050209',
                    },
                    {
                        areaCode: '05020906',
                        areaName: '兴宾区',
                        areaLevel: '4',
                        parentCode: '050209',
                    },
                ],
            },
            {
                areaCode: '050210',
                areaName: '柳州市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05021001',
                        areaName: '城中区',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021002',
                        areaName: '柳北区',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021003',
                        areaName: '柳城县',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021004',
                        areaName: '柳江县',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021005',
                        areaName: '柳南区',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021006',
                        areaName: '鹿寨县',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021007',
                        areaName: '融安县',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021008',
                        areaName: '融水苗族自治县',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021009',
                        areaName: '三江侗族自治县',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                    {
                        areaCode: '05021010',
                        areaName: '鱼峰区',
                        areaLevel: '4',
                        parentCode: '050210',
                    },
                ],
            },
            {
                areaCode: '050211',
                areaName: '南宁市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05021101',
                        areaName: '宾阳县',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021102',
                        areaName: '横县',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021103',
                        areaName: '江南区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021104',
                        areaName: '良庆区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021105',
                        areaName: '隆安县',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021106',
                        areaName: '马山县',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021107',
                        areaName: '青秀区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021108',
                        areaName: '上林县',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021109',
                        areaName: '武鸣区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021110',
                        areaName: '兴宁区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021111',
                        areaName: '西乡塘区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                    {
                        areaCode: '05021112',
                        areaName: '邕宁区',
                        areaLevel: '4',
                        parentCode: '050211',
                    },
                ],
            },
            {
                areaCode: '050212',
                areaName: '钦州市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05021201',
                        areaName: '灵山县',
                        areaLevel: '4',
                        parentCode: '050212',
                    },
                    {
                        areaCode: '05021202',
                        areaName: '浦北县',
                        areaLevel: '4',
                        parentCode: '050212',
                    },
                    {
                        areaCode: '05021203',
                        areaName: '钦北区',
                        areaLevel: '4',
                        parentCode: '050212',
                    },
                    {
                        areaCode: '05021204',
                        areaName: '钦南区',
                        areaLevel: '4',
                        parentCode: '050212',
                    },
                ],
            },
            {
                areaCode: '050213',
                areaName: '梧州市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05021301',
                        areaName: '苍梧县',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                    {
                        areaCode: '05021302',
                        areaName: '岑溪市',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                    {
                        areaCode: '05021303',
                        areaName: '长洲区',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                    {
                        areaCode: '05021304',
                        areaName: '龙圩区',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                    {
                        areaCode: '05021305',
                        areaName: '蒙山县',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                    {
                        areaCode: '05021306',
                        areaName: '藤县',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                    {
                        areaCode: '05021307',
                        areaName: '万秀区',
                        areaLevel: '4',
                        parentCode: '050213',
                    },
                ],
            },
            {
                areaCode: '050214',
                areaName: '玉林市',
                areaLevel: '3',
                parentCode: '0502',
                children: [
                    {
                        areaCode: '05021401',
                        areaName: '北流市',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                    {
                        areaCode: '05021402',
                        areaName: '博白县',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                    {
                        areaCode: '05021403',
                        areaName: '福绵区',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                    {
                        areaCode: '05021404',
                        areaName: '陆川县',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                    {
                        areaCode: '05021405',
                        areaName: '容县',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                    {
                        areaCode: '05021406',
                        areaName: '兴业县',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                    {
                        areaCode: '05021407',
                        areaName: '玉州区',
                        areaLevel: '4',
                        parentCode: '050214',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0503',
        areaName: '海南省',
        areaLevel: '2',
        parentCode: '05',
        children: [
            {
                areaCode: '050301',
                areaName: '直辖县级行政区划',
                areaLevel: '3',
                parentCode: '0503',
                children: [
                    {
                        areaCode: '05030101',
                        areaName: '白沙黎族自治县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030102',
                        areaName: '保亭黎族苗族自治县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030103',
                        areaName: '昌江黎族自治县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030104',
                        areaName: '澄迈县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030105',
                        areaName: '儋州市',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030106',
                        areaName: '定安县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030107',
                        areaName: '东方市',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030108',
                        areaName: '乐东黎族自治县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030109',
                        areaName: '临高县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030110',
                        areaName: '陵水黎族自治县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030111',
                        areaName: '琼海市',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030112',
                        areaName: '琼中黎族苗族自治县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030113',
                        areaName: '屯昌县',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030114',
                        areaName: '万宁市',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030115',
                        areaName: '文昌市',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                    {
                        areaCode: '05030116',
                        areaName: '五指山市',
                        areaLevel: '4',
                        parentCode: '050301',
                    },
                ],
            },
            {
                areaCode: '050302',
                areaName: '海口市',
                areaLevel: '3',
                parentCode: '0503',
                children: [
                    {
                        areaCode: '05030201',
                        areaName: '龙华区',
                        areaLevel: '4',
                        parentCode: '050302',
                    },
                    {
                        areaCode: '05030202',
                        areaName: '美兰区',
                        areaLevel: '4',
                        parentCode: '050302',
                    },
                    {
                        areaCode: '05030203',
                        areaName: '琼山区',
                        areaLevel: '4',
                        parentCode: '050302',
                    },
                    {
                        areaCode: '05030204',
                        areaName: '秀英区',
                        areaLevel: '4',
                        parentCode: '050302',
                    },
                ],
            },
            {
                areaCode: '050303',
                areaName: '三沙市',
                areaLevel: '3',
                parentCode: '0503',
                children: [
                    {
                        areaCode: '05030301',
                        areaName: '南沙群岛',
                        areaLevel: '4',
                        parentCode: '050303',
                    },
                    {
                        areaCode: '05030302',
                        areaName: '西沙群岛',
                        areaLevel: '4',
                        parentCode: '050303',
                    },
                    {
                        areaCode: '05030303',
                        areaName: '中沙群岛的岛礁及其海域',
                        areaLevel: '4',
                        parentCode: '050303',
                    },
                ],
            },
            {
                areaCode: '050304',
                areaName: '三亚市',
                areaLevel: '3',
                parentCode: '0503',
                children: [
                    {
                        areaCode: '05030401',
                        areaName: '海棠区',
                        areaLevel: '4',
                        parentCode: '050304',
                    },
                    {
                        areaCode: '05030402',
                        areaName: '吉阳区',
                        areaLevel: '4',
                        parentCode: '050304',
                    },
                    {
                        areaCode: '05030403',
                        areaName: '天涯区',
                        areaLevel: '4',
                        parentCode: '050304',
                    },
                    {
                        areaCode: '05030404',
                        areaName: '崖州区',
                        areaLevel: '4',
                        parentCode: '050304',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0504',
        areaName: '福建省',
        areaLevel: '2',
        parentCode: '05',
        children: [
            {
                areaCode: '050401',
                areaName: '福州市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040101',
                        areaName: '仓山区',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040102',
                        areaName: '长乐市',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040103',
                        areaName: '福清市',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040104',
                        areaName: '鼓楼区',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040105',
                        areaName: '晋安区',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040106',
                        areaName: '连江县',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040107',
                        areaName: '罗源县',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040108',
                        areaName: '马尾区',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040109',
                        areaName: '闽侯县',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040110',
                        areaName: '闽清县',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040111',
                        areaName: '平潭县',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040112',
                        areaName: '台江区',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                    {
                        areaCode: '05040113',
                        areaName: '永泰县',
                        areaLevel: '4',
                        parentCode: '050401',
                    },
                ],
            },
            {
                areaCode: '050402',
                areaName: '龙岩市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040201',
                        areaName: '长汀县',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                    {
                        areaCode: '05040202',
                        areaName: '连城县',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                    {
                        areaCode: '05040203',
                        areaName: '上杭县',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                    {
                        areaCode: '05040204',
                        areaName: '武平县',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                    {
                        areaCode: '05040205',
                        areaName: '新罗区',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                    {
                        areaCode: '05040206',
                        areaName: '永定区',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                    {
                        areaCode: '05040207',
                        areaName: '漳平市',
                        areaLevel: '4',
                        parentCode: '050402',
                    },
                ],
            },
            {
                areaCode: '050403',
                areaName: '南平市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040301',
                        areaName: '光泽县',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040302',
                        areaName: '建瓯市',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040303',
                        areaName: '建阳区',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040304',
                        areaName: '浦城县',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040305',
                        areaName: '邵武市',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040306',
                        areaName: '顺昌县',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040307',
                        areaName: '松溪县',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040308',
                        areaName: '武夷山市',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040309',
                        areaName: '延平区',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                    {
                        areaCode: '05040310',
                        areaName: '政和县',
                        areaLevel: '4',
                        parentCode: '050403',
                    },
                ],
            },
            {
                areaCode: '050404',
                areaName: '宁德市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040401',
                        areaName: '福安市',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040402',
                        areaName: '福鼎市',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040403',
                        areaName: '古田县',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040404',
                        areaName: '蕉城区',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040405',
                        areaName: '屏南县',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040406',
                        areaName: '寿宁县',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040407',
                        areaName: '霞浦县',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040408',
                        areaName: '柘荣县',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                    {
                        areaCode: '05040409',
                        areaName: '周宁县',
                        areaLevel: '4',
                        parentCode: '050404',
                    },
                ],
            },
            {
                areaCode: '050405',
                areaName: '莆田市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040501',
                        areaName: '城厢区',
                        areaLevel: '4',
                        parentCode: '050405',
                    },
                    {
                        areaCode: '05040502',
                        areaName: '涵江区',
                        areaLevel: '4',
                        parentCode: '050405',
                    },
                    {
                        areaCode: '05040503',
                        areaName: '荔城区',
                        areaLevel: '4',
                        parentCode: '050405',
                    },
                    {
                        areaCode: '05040504',
                        areaName: '仙游县',
                        areaLevel: '4',
                        parentCode: '050405',
                    },
                    {
                        areaCode: '05040505',
                        areaName: '秀屿区',
                        areaLevel: '4',
                        parentCode: '050405',
                    },
                ],
            },
            {
                areaCode: '050406',
                areaName: '泉州市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040601',
                        areaName: '安溪县',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040602',
                        areaName: '德化县',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040603',
                        areaName: '丰泽区',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040604',
                        areaName: '惠安县',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040605',
                        areaName: '晋江市',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040606',
                        areaName: '金门县',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040607',
                        areaName: '鲤城区',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040608',
                        areaName: '洛江区',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040609',
                        areaName: '南安市',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040610',
                        areaName: '泉港区',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040611',
                        areaName: '石狮市',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                    {
                        areaCode: '05040612',
                        areaName: '永春县',
                        areaLevel: '4',
                        parentCode: '050406',
                    },
                ],
            },
            {
                areaCode: '050407',
                areaName: '三明市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040701',
                        areaName: '大田县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040702',
                        areaName: '将乐县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040703',
                        areaName: '建宁县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040704',
                        areaName: '梅列区',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040705',
                        areaName: '明溪县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040706',
                        areaName: '宁化县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040707',
                        areaName: '清流县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040708',
                        areaName: '三元区',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040709',
                        areaName: '沙县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040710',
                        areaName: '泰宁县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040711',
                        areaName: '永安市',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                    {
                        areaCode: '05040712',
                        areaName: '尤溪县',
                        areaLevel: '4',
                        parentCode: '050407',
                    },
                ],
            },
            {
                areaCode: '050408',
                areaName: '厦门市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040801',
                        areaName: '海沧区',
                        areaLevel: '4',
                        parentCode: '050408',
                    },
                    {
                        areaCode: '05040802',
                        areaName: '湖里区',
                        areaLevel: '4',
                        parentCode: '050408',
                    },
                    {
                        areaCode: '05040803',
                        areaName: '集美区',
                        areaLevel: '4',
                        parentCode: '050408',
                    },
                    {
                        areaCode: '05040804',
                        areaName: '思明区',
                        areaLevel: '4',
                        parentCode: '050408',
                    },
                    {
                        areaCode: '05040805',
                        areaName: '同安区',
                        areaLevel: '4',
                        parentCode: '050408',
                    },
                    {
                        areaCode: '05040806',
                        areaName: '翔安区',
                        areaLevel: '4',
                        parentCode: '050408',
                    },
                ],
            },
            {
                areaCode: '050409',
                areaName: '漳州市',
                areaLevel: '3',
                parentCode: '0504',
                children: [
                    {
                        areaCode: '05040901',
                        areaName: '长泰县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040902',
                        areaName: '东山县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040903',
                        areaName: '华安县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040904',
                        areaName: '龙海市',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040905',
                        areaName: '龙文区',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040906',
                        areaName: '南靖县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040907',
                        areaName: '平和县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040908',
                        areaName: '芗城区',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040909',
                        areaName: '云霄县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040910',
                        areaName: '漳浦县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                    {
                        areaCode: '05040911',
                        areaName: '诏安县',
                        areaLevel: '4',
                        parentCode: '050409',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0601',
        areaName: '重庆市',
        areaLevel: '2',
        parentCode: '06',
        children: [
            {
                areaCode: '060101',
                areaName: '重庆市',
                areaLevel: '3',
                parentCode: '0601',
                children: [
                    {
                        areaCode: '06010101',
                        areaName: '巴南区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010102',
                        areaName: '北碚区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010103',
                        areaName: '璧山区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010104',
                        areaName: '长寿区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010105',
                        areaName: '大渡口区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010106',
                        areaName: '大足区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010107',
                        areaName: '涪陵区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010108',
                        areaName: '合川区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010109',
                        areaName: '江北区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010110',
                        areaName: '江津区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010111',
                        areaName: '九龙坡区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010112',
                        areaName: '南岸区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010113',
                        areaName: '南川区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010114',
                        areaName: '黔江区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010115',
                        areaName: '綦江区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010116',
                        areaName: '荣昌区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010117',
                        areaName: '沙坪坝区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010118',
                        areaName: '铜梁区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010119',
                        areaName: '潼南区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010120',
                        areaName: '万州区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010121',
                        areaName: '永川区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010122',
                        areaName: '渝北区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010123',
                        areaName: '渝中区',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010124',
                        areaName: '城口县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010125',
                        areaName: '垫江县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010126',
                        areaName: '丰都县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010127',
                        areaName: '奉节县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010128',
                        areaName: '开县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010129',
                        areaName: '梁平县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010130',
                        areaName: '彭水苗族土家族自治县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010131',
                        areaName: '石柱土家族自治县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010132',
                        areaName: '巫山县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010133',
                        areaName: '巫溪县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010134',
                        areaName: '武隆县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010135',
                        areaName: '秀山土家族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010136',
                        areaName: '酉阳土家族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010137',
                        areaName: '云阳县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                    {
                        areaCode: '06010138',
                        areaName: '忠县',
                        areaLevel: '4',
                        parentCode: '060101',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0602',
        areaName: '四川省',
        areaLevel: '2',
        parentCode: '06',
        children: [
            {
                areaCode: '060201',
                areaName: '阿坝藏族羌族自治州',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020101',
                        areaName: '阿坝县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020102',
                        areaName: '黑水县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020103',
                        areaName: '红原县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020104',
                        areaName: '金川县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020105',
                        areaName: '九寨沟县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020106',
                        areaName: '理县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020107',
                        areaName: '马尔康县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020108',
                        areaName: '茂县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020109',
                        areaName: '壤塘县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020110',
                        areaName: '若尔盖县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020111',
                        areaName: '松潘县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020112',
                        areaName: '汶川县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                    {
                        areaCode: '06020113',
                        areaName: '小金县',
                        areaLevel: '4',
                        parentCode: '060201',
                    },
                ],
            },
            {
                areaCode: '060202',
                areaName: '巴中市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020201',
                        areaName: '巴州区',
                        areaLevel: '4',
                        parentCode: '060202',
                    },
                    {
                        areaCode: '06020202',
                        areaName: '恩阳区',
                        areaLevel: '4',
                        parentCode: '060202',
                    },
                    {
                        areaCode: '06020203',
                        areaName: '南江县',
                        areaLevel: '4',
                        parentCode: '060202',
                    },
                    {
                        areaCode: '06020204',
                        areaName: '平昌县',
                        areaLevel: '4',
                        parentCode: '060202',
                    },
                    {
                        areaCode: '06020205',
                        areaName: '通江县',
                        areaLevel: '4',
                        parentCode: '060202',
                    },
                ],
            },
            {
                areaCode: '060203',
                areaName: '成都市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020301',
                        areaName: '成华区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020302',
                        areaName: '崇州市',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020303',
                        areaName: '大邑县',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020304',
                        areaName: '都江堰市',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020305',
                        areaName: '锦江区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020306',
                        areaName: '金牛区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020307',
                        areaName: '金堂县',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020308',
                        areaName: '龙泉驿区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020309',
                        areaName: '彭州市',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020310',
                        areaName: '郫都县',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020311',
                        areaName: '蒲江县',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020312',
                        areaName: '青白江区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020313',
                        areaName: '青羊区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020314',
                        areaName: '邛崃市',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020315',
                        areaName: '双流区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020316',
                        areaName: '温江区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020317',
                        areaName: '武侯区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020318',
                        areaName: '新都区',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                    {
                        areaCode: '06020319',
                        areaName: '新津县',
                        areaLevel: '4',
                        parentCode: '060203',
                    },
                ],
            },
            {
                areaCode: '060204',
                areaName: '达州市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020401',
                        areaName: '达川区',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                    {
                        areaCode: '06020402',
                        areaName: '大竹县',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                    {
                        areaCode: '06020403',
                        areaName: '开江县',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                    {
                        areaCode: '06020404',
                        areaName: '渠县',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                    {
                        areaCode: '06020405',
                        areaName: '通川区',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                    {
                        areaCode: '06020406',
                        areaName: '万源市',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                    {
                        areaCode: '06020407',
                        areaName: '宣汉县',
                        areaLevel: '4',
                        parentCode: '060204',
                    },
                ],
            },
            {
                areaCode: '060205',
                areaName: '德阳市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020501',
                        areaName: '广汉市',
                        areaLevel: '4',
                        parentCode: '060205',
                    },
                    {
                        areaCode: '06020502',
                        areaName: '旌阳区',
                        areaLevel: '4',
                        parentCode: '060205',
                    },
                    {
                        areaCode: '06020503',
                        areaName: '罗江县',
                        areaLevel: '4',
                        parentCode: '060205',
                    },
                    {
                        areaCode: '06020504',
                        areaName: '绵竹市',
                        areaLevel: '4',
                        parentCode: '060205',
                    },
                    {
                        areaCode: '06020505',
                        areaName: '什邡市',
                        areaLevel: '4',
                        parentCode: '060205',
                    },
                    {
                        areaCode: '06020506',
                        areaName: '中江县',
                        areaLevel: '4',
                        parentCode: '060205',
                    },
                ],
            },
            {
                areaCode: '060206',
                areaName: '甘孜藏族自治州',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020601',
                        areaName: '白玉县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020602',
                        areaName: '巴塘县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020603',
                        areaName: '丹巴县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020604',
                        areaName: '稻城县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020605',
                        areaName: '道孚县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020606',
                        areaName: '德格县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020607',
                        areaName: '得荣县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020608',
                        areaName: '甘孜县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020609',
                        areaName: '九龙县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020610',
                        areaName: '康定市',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020611',
                        areaName: '理塘县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020612',
                        areaName: '泸定县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020613',
                        areaName: '炉霍县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020614',
                        areaName: '色达县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020615',
                        areaName: '石渠县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020616',
                        areaName: '乡城县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020617',
                        areaName: '新龙县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                    {
                        areaCode: '06020618',
                        areaName: '雅江县',
                        areaLevel: '4',
                        parentCode: '060206',
                    },
                ],
            },
            {
                areaCode: '060207',
                areaName: '广安市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020701',
                        areaName: '广安区',
                        areaLevel: '4',
                        parentCode: '060207',
                    },
                    {
                        areaCode: '06020702',
                        areaName: '华蓥市',
                        areaLevel: '4',
                        parentCode: '060207',
                    },
                    {
                        areaCode: '06020703',
                        areaName: '邻水县',
                        areaLevel: '4',
                        parentCode: '060207',
                    },
                    {
                        areaCode: '06020704',
                        areaName: '前锋区',
                        areaLevel: '4',
                        parentCode: '060207',
                    },
                    {
                        areaCode: '06020705',
                        areaName: '武胜县',
                        areaLevel: '4',
                        parentCode: '060207',
                    },
                    {
                        areaCode: '06020706',
                        areaName: '岳池县',
                        areaLevel: '4',
                        parentCode: '060207',
                    },
                ],
            },
            {
                areaCode: '060208',
                areaName: '广元市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020801',
                        areaName: '苍溪县',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                    {
                        areaCode: '06020802',
                        areaName: '朝天区',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                    {
                        areaCode: '06020803',
                        areaName: '剑阁县',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                    {
                        areaCode: '06020804',
                        areaName: '利州区',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                    {
                        areaCode: '06020805',
                        areaName: '青川县',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                    {
                        areaCode: '06020806',
                        areaName: '旺苍县',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                    {
                        areaCode: '06020807',
                        areaName: '昭化区',
                        areaLevel: '4',
                        parentCode: '060208',
                    },
                ],
            },
            {
                areaCode: '060209',
                areaName: '乐山市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06020901',
                        areaName: '峨边彝族自治县',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020902',
                        areaName: '峨眉山市',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020903',
                        areaName: '夹江县',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020904',
                        areaName: '井研县',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020905',
                        areaName: '金口河区',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020906',
                        areaName: '马边彝族自治县',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020907',
                        areaName: '沐川县',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020908',
                        areaName: '犍为县',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020909',
                        areaName: '沙湾区',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020910',
                        areaName: '市中区',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                    {
                        areaCode: '06020911',
                        areaName: '五通桥区',
                        areaLevel: '4',
                        parentCode: '060209',
                    },
                ],
            },
            {
                areaCode: '060210',
                areaName: '凉山彝族自治州',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021001',
                        areaName: '布拖县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021002',
                        areaName: '德昌县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021003',
                        areaName: '甘洛县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021004',
                        areaName: '会东县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021005',
                        areaName: '会理县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021006',
                        areaName: '金阳县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021007',
                        areaName: '雷波县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021008',
                        areaName: '美姑县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021009',
                        areaName: '冕宁县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021010',
                        areaName: '木里藏族自治县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021011',
                        areaName: '宁南县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021012',
                        areaName: '普格县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021013',
                        areaName: '西昌市',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021014',
                        areaName: '喜德县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021015',
                        areaName: '盐源县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021016',
                        areaName: '越西县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                    {
                        areaCode: '06021017',
                        areaName: '昭觉县',
                        areaLevel: '4',
                        parentCode: '060210',
                    },
                ],
            },
            {
                areaCode: '060211',
                areaName: '泸州市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021101',
                        areaName: '古蔺县',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                    {
                        areaCode: '06021102',
                        areaName: '合江县',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                    {
                        areaCode: '06021103',
                        areaName: '江阳区',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                    {
                        areaCode: '06021104',
                        areaName: '龙马潭区',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                    {
                        areaCode: '06021105',
                        areaName: '泸县',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                    {
                        areaCode: '06021106',
                        areaName: '纳溪区',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                    {
                        areaCode: '06021107',
                        areaName: '叙永县',
                        areaLevel: '4',
                        parentCode: '060211',
                    },
                ],
            },
            {
                areaCode: '060212',
                areaName: '眉山市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021201',
                        areaName: '丹棱县',
                        areaLevel: '4',
                        parentCode: '060212',
                    },
                    {
                        areaCode: '06021202',
                        areaName: '东坡区',
                        areaLevel: '4',
                        parentCode: '060212',
                    },
                    {
                        areaCode: '06021203',
                        areaName: '洪雅县',
                        areaLevel: '4',
                        parentCode: '060212',
                    },
                    {
                        areaCode: '06021204',
                        areaName: '彭山区',
                        areaLevel: '4',
                        parentCode: '060212',
                    },
                    {
                        areaCode: '06021205',
                        areaName: '青神县',
                        areaLevel: '4',
                        parentCode: '060212',
                    },
                    {
                        areaCode: '06021206',
                        areaName: '仁寿县',
                        areaLevel: '4',
                        parentCode: '060212',
                    },
                ],
            },
            {
                areaCode: '060213',
                areaName: '绵阳市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021301',
                        areaName: '安县',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021302',
                        areaName: '北川羌族自治县',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021303',
                        areaName: '涪城区',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021304',
                        areaName: '江油市',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021305',
                        areaName: '平武县',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021306',
                        areaName: '三台县',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021307',
                        areaName: '盐亭县',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021308',
                        areaName: '游仙区',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                    {
                        areaCode: '06021309',
                        areaName: '梓潼县',
                        areaLevel: '4',
                        parentCode: '060213',
                    },
                ],
            },
            {
                areaCode: '060214',
                areaName: '南充市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021401',
                        areaName: '高坪区',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021402',
                        areaName: '嘉陵区',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021403',
                        areaName: '阆中市',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021404',
                        areaName: '南部县',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021405',
                        areaName: '蓬安县',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021406',
                        areaName: '顺庆区',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021407',
                        areaName: '西充县',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021408',
                        areaName: '仪陇县',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                    {
                        areaCode: '06021409',
                        areaName: '营山县',
                        areaLevel: '4',
                        parentCode: '060214',
                    },
                ],
            },
            {
                areaCode: '060215',
                areaName: '内江市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021501',
                        areaName: '东兴区',
                        areaLevel: '4',
                        parentCode: '060215',
                    },
                    {
                        areaCode: '06021502',
                        areaName: '隆昌县',
                        areaLevel: '4',
                        parentCode: '060215',
                    },
                    {
                        areaCode: '06021503',
                        areaName: '市中区',
                        areaLevel: '4',
                        parentCode: '060215',
                    },
                    {
                        areaCode: '06021504',
                        areaName: '威远县',
                        areaLevel: '4',
                        parentCode: '060215',
                    },
                    {
                        areaCode: '06021505',
                        areaName: '资中县',
                        areaLevel: '4',
                        parentCode: '060215',
                    },
                ],
            },
            {
                areaCode: '060216',
                areaName: '攀枝花市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021601',
                        areaName: '东区',
                        areaLevel: '4',
                        parentCode: '060216',
                    },
                    {
                        areaCode: '06021602',
                        areaName: '米易县',
                        areaLevel: '4',
                        parentCode: '060216',
                    },
                    {
                        areaCode: '06021603',
                        areaName: '仁和区',
                        areaLevel: '4',
                        parentCode: '060216',
                    },
                    {
                        areaCode: '06021604',
                        areaName: '西区',
                        areaLevel: '4',
                        parentCode: '060216',
                    },
                    {
                        areaCode: '06021605',
                        areaName: '盐边县',
                        areaLevel: '4',
                        parentCode: '060216',
                    },
                ],
            },
            {
                areaCode: '060217',
                areaName: '遂宁市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021701',
                        areaName: '安居区',
                        areaLevel: '4',
                        parentCode: '060217',
                    },
                    {
                        areaCode: '06021702',
                        areaName: '船山区',
                        areaLevel: '4',
                        parentCode: '060217',
                    },
                    {
                        areaCode: '06021703',
                        areaName: '大英县',
                        areaLevel: '4',
                        parentCode: '060217',
                    },
                    {
                        areaCode: '06021704',
                        areaName: '蓬溪县',
                        areaLevel: '4',
                        parentCode: '060217',
                    },
                    {
                        areaCode: '06021705',
                        areaName: '射洪县',
                        areaLevel: '4',
                        parentCode: '060217',
                    },
                ],
            },
            {
                areaCode: '060218',
                areaName: '雅安市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021801',
                        areaName: '宝兴县',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021802',
                        areaName: '汉源县',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021803',
                        areaName: '芦山县',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021804',
                        areaName: '名山区',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021805',
                        areaName: '石棉县',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021806',
                        areaName: '天全县',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021807',
                        areaName: '荥经县',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                    {
                        areaCode: '06021808',
                        areaName: '雨城区',
                        areaLevel: '4',
                        parentCode: '060218',
                    },
                ],
            },
            {
                areaCode: '060219',
                areaName: '宜宾市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06021901',
                        areaName: '长宁县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021902',
                        areaName: '翠屏区',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021903',
                        areaName: '高县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021904',
                        areaName: '珙县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021905',
                        areaName: '江安县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021906',
                        areaName: '筠连县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021907',
                        areaName: '南溪区',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021908',
                        areaName: '屏山县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021909',
                        areaName: '兴文县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                    {
                        areaCode: '06021910',
                        areaName: '宜宾县',
                        areaLevel: '4',
                        parentCode: '060219',
                    },
                ],
            },
            {
                areaCode: '060220',
                areaName: '自贡市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06022001',
                        areaName: '大安区',
                        areaLevel: '4',
                        parentCode: '060220',
                    },
                    {
                        areaCode: '06022002',
                        areaName: '富顺县',
                        areaLevel: '4',
                        parentCode: '060220',
                    },
                    {
                        areaCode: '06022003',
                        areaName: '贡井区',
                        areaLevel: '4',
                        parentCode: '060220',
                    },
                    {
                        areaCode: '06022004',
                        areaName: '荣县',
                        areaLevel: '4',
                        parentCode: '060220',
                    },
                    {
                        areaCode: '06022005',
                        areaName: '沿滩区',
                        areaLevel: '4',
                        parentCode: '060220',
                    },
                    {
                        areaCode: '06022006',
                        areaName: '自流井区',
                        areaLevel: '4',
                        parentCode: '060220',
                    },
                ],
            },
            {
                areaCode: '060221',
                areaName: '资阳市',
                areaLevel: '3',
                parentCode: '0602',
                children: [
                    {
                        areaCode: '06022101',
                        areaName: '安岳县',
                        areaLevel: '4',
                        parentCode: '060221',
                    },
                    {
                        areaCode: '06022102',
                        areaName: '简阳市',
                        areaLevel: '4',
                        parentCode: '060221',
                    },
                    {
                        areaCode: '06022103',
                        areaName: '乐至县',
                        areaLevel: '4',
                        parentCode: '060221',
                    },
                    {
                        areaCode: '06022104',
                        areaName: '雁江区',
                        areaLevel: '4',
                        parentCode: '060221',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0603',
        areaName: '贵州省',
        areaLevel: '2',
        parentCode: '06',
        children: [
            {
                areaCode: '060301',
                areaName: '安顺市',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030101',
                        areaName: '关岭布依族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060301',
                    },
                    {
                        areaCode: '06030102',
                        areaName: '平坝区',
                        areaLevel: '4',
                        parentCode: '060301',
                    },
                    {
                        areaCode: '06030103',
                        areaName: '普定县',
                        areaLevel: '4',
                        parentCode: '060301',
                    },
                    {
                        areaCode: '06030104',
                        areaName: '西秀区',
                        areaLevel: '4',
                        parentCode: '060301',
                    },
                    {
                        areaCode: '06030105',
                        areaName: '镇宁布依族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060301',
                    },
                    {
                        areaCode: '06030106',
                        areaName: '紫云苗族布依族自治县',
                        areaLevel: '4',
                        parentCode: '060301',
                    },
                ],
            },
            {
                areaCode: '060302',
                areaName: '毕节市',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030201',
                        areaName: '大方县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030202',
                        areaName: '赫章县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030203',
                        areaName: '金沙县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030204',
                        areaName: '纳雍县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030205',
                        areaName: '黔西县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030206',
                        areaName: '七星关区',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030207',
                        areaName: '威宁彝族回族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                    {
                        areaCode: '06030208',
                        areaName: '织金县',
                        areaLevel: '4',
                        parentCode: '060302',
                    },
                ],
            },
            {
                areaCode: '060303',
                areaName: '贵阳市',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030301',
                        areaName: '白云区',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030302',
                        areaName: '观山湖区',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030303',
                        areaName: '花溪区',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030304',
                        areaName: '开阳县',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030305',
                        areaName: '南明区',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030306',
                        areaName: '清镇市',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030307',
                        areaName: '乌当区',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030308',
                        areaName: '息烽县',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030309',
                        areaName: '修文县',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                    {
                        areaCode: '06030310',
                        areaName: '云岩区',
                        areaLevel: '4',
                        parentCode: '060303',
                    },
                ],
            },
            {
                areaCode: '060304',
                areaName: '六盘水市',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030401',
                        areaName: '六枝特区',
                        areaLevel: '4',
                        parentCode: '060304',
                    },
                    {
                        areaCode: '06030402',
                        areaName: '盘县',
                        areaLevel: '4',
                        parentCode: '060304',
                    },
                    {
                        areaCode: '06030403',
                        areaName: '水城县',
                        areaLevel: '4',
                        parentCode: '060304',
                    },
                    {
                        areaCode: '06030404',
                        areaName: '钟山区',
                        areaLevel: '4',
                        parentCode: '060304',
                    },
                ],
            },
            {
                areaCode: '060305',
                areaName: '黔东南苗族侗族自治州',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030501',
                        areaName: '岑巩县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030502',
                        areaName: '从江县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030503',
                        areaName: '丹寨县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030504',
                        areaName: '黄平县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030505',
                        areaName: '剑河县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030506',
                        areaName: '锦屏县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030507',
                        areaName: '凯里市',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030508',
                        areaName: '雷山县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030509',
                        areaName: '黎平县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030510',
                        areaName: '麻江县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030511',
                        areaName: '榕江县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030512',
                        areaName: '三穗县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030513',
                        areaName: '施秉县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030514',
                        areaName: '台江县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030515',
                        areaName: '天柱县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                    {
                        areaCode: '06030516',
                        areaName: '镇远县',
                        areaLevel: '4',
                        parentCode: '060305',
                    },
                ],
            },
            {
                areaCode: '060306',
                areaName: '黔南布依族苗族自治州',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030601',
                        areaName: '长顺县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030602',
                        areaName: '独山县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030603',
                        areaName: '都匀市',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030604',
                        areaName: '福泉市',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030605',
                        areaName: '贵定县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030606',
                        areaName: '惠水县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030607',
                        areaName: '荔波县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030608',
                        areaName: '龙里县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030609',
                        areaName: '罗甸县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030610',
                        areaName: '平塘县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030611',
                        areaName: '三都水族自治县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                    {
                        areaCode: '06030612',
                        areaName: '瓮安县',
                        areaLevel: '4',
                        parentCode: '060306',
                    },
                ],
            },
            {
                areaCode: '060307',
                areaName: '黔西南布依族苗族自治州',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030701',
                        areaName: '安龙县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030702',
                        areaName: '册亨县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030703',
                        areaName: '普安县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030704',
                        areaName: '晴隆县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030705',
                        areaName: '望谟县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030706',
                        areaName: '兴仁县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030707',
                        areaName: '兴义市',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                    {
                        areaCode: '06030708',
                        areaName: '贞丰县',
                        areaLevel: '4',
                        parentCode: '060307',
                    },
                ],
            },
            {
                areaCode: '060308',
                areaName: '铜仁市',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030801',
                        areaName: '碧江区',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030802',
                        areaName: '德江县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030803',
                        areaName: '江口县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030804',
                        areaName: '石阡县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030805',
                        areaName: '思南县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030806',
                        areaName: '松桃苗族自治县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030807',
                        areaName: '万山区',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030808',
                        areaName: '沿河土家族自治县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030809',
                        areaName: '印江土家族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                    {
                        areaCode: '06030810',
                        areaName: '玉屏侗族自治县',
                        areaLevel: '4',
                        parentCode: '060308',
                    },
                ],
            },
            {
                areaCode: '060309',
                areaName: '遵义市',
                areaLevel: '3',
                parentCode: '0603',
                children: [
                    {
                        areaCode: '06030901',
                        areaName: '赤水市',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030902',
                        areaName: '道真仡佬族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030903',
                        areaName: '凤冈县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030904',
                        areaName: '红花岗区',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030905',
                        areaName: '汇川区',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030906',
                        areaName: '湄潭县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030907',
                        areaName: '仁怀市',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030908',
                        areaName: '绥阳县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030909',
                        areaName: '桐梓县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030910',
                        areaName: '务川仡佬族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030911',
                        areaName: '习水县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030912',
                        areaName: '余庆县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030913',
                        areaName: '正安县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                    {
                        areaCode: '06030914',
                        areaName: '遵义县',
                        areaLevel: '4',
                        parentCode: '060309',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0604',
        areaName: '云南省',
        areaLevel: '2',
        parentCode: '06',
        children: [
            {
                areaCode: '060401',
                areaName: '保山市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040101',
                        areaName: '昌宁县',
                        areaLevel: '4',
                        parentCode: '060401',
                    },
                    {
                        areaCode: '06040102',
                        areaName: '龙陵县',
                        areaLevel: '4',
                        parentCode: '060401',
                    },
                    {
                        areaCode: '06040103',
                        areaName: '隆阳区',
                        areaLevel: '4',
                        parentCode: '060401',
                    },
                    {
                        areaCode: '06040104',
                        areaName: '施甸县',
                        areaLevel: '4',
                        parentCode: '060401',
                    },
                    {
                        areaCode: '06040105',
                        areaName: '腾冲市',
                        areaLevel: '4',
                        parentCode: '060401',
                    },
                ],
            },
            {
                areaCode: '060402',
                areaName: '楚雄彝族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040201',
                        areaName: '楚雄市',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040202',
                        areaName: '大姚县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040203',
                        areaName: '禄丰县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040204',
                        areaName: '牟定县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040205',
                        areaName: '南华县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040206',
                        areaName: '双柏县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040207',
                        areaName: '武定县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040208',
                        areaName: '姚安县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040209',
                        areaName: '永仁县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                    {
                        areaCode: '06040210',
                        areaName: '元谋县',
                        areaLevel: '4',
                        parentCode: '060402',
                    },
                ],
            },
            {
                areaCode: '060403',
                areaName: '大理白族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040301',
                        areaName: '宾川县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040302',
                        areaName: '大理市',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040303',
                        areaName: '洱源县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040304',
                        areaName: '鹤庆县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040305',
                        areaName: '剑川县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040306',
                        areaName: '弥渡县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040307',
                        areaName: '南涧彝族自治县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040308',
                        areaName: '巍山彝族回族自治县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040309',
                        areaName: '祥云县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040310',
                        areaName: '漾濞彝族自治县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040311',
                        areaName: '永平县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                    {
                        areaCode: '06040312',
                        areaName: '云龙县',
                        areaLevel: '4',
                        parentCode: '060403',
                    },
                ],
            },
            {
                areaCode: '060404',
                areaName: '德宏傣族景颇族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040401',
                        areaName: '梁河县',
                        areaLevel: '4',
                        parentCode: '060404',
                    },
                    {
                        areaCode: '06040402',
                        areaName: '陇川县',
                        areaLevel: '4',
                        parentCode: '060404',
                    },
                    {
                        areaCode: '06040403',
                        areaName: '芒市',
                        areaLevel: '4',
                        parentCode: '060404',
                    },
                    {
                        areaCode: '06040404',
                        areaName: '瑞丽市',
                        areaLevel: '4',
                        parentCode: '060404',
                    },
                    {
                        areaCode: '06040405',
                        areaName: '盈江县',
                        areaLevel: '4',
                        parentCode: '060404',
                    },
                ],
            },
            {
                areaCode: '060405',
                areaName: '迪庆藏族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040501',
                        areaName: '德钦县',
                        areaLevel: '4',
                        parentCode: '060405',
                    },
                    {
                        areaCode: '06040502',
                        areaName: '维西傈僳族自治县',
                        areaLevel: '4',
                        parentCode: '060405',
                    },
                    {
                        areaCode: '06040503',
                        areaName: '香格里拉市',
                        areaLevel: '4',
                        parentCode: '060405',
                    },
                ],
            },
            {
                areaCode: '060406',
                areaName: '红河哈尼族彝族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040601',
                        areaName: '个旧市',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040602',
                        areaName: '河口瑶族自治县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040603',
                        areaName: '红河县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040604',
                        areaName: '建水县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040605',
                        areaName: '金平苗族瑶族傣族自治县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040606',
                        areaName: '开远市',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040607',
                        areaName: '泸西县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040608',
                        areaName: '绿春县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040609',
                        areaName: '蒙自市',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040610',
                        areaName: '弥勒市',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040611',
                        areaName: '屏边苗族自治县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040612',
                        areaName: '石屏县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                    {
                        areaCode: '06040613',
                        areaName: '元阳县',
                        areaLevel: '4',
                        parentCode: '060406',
                    },
                ],
            },
            {
                areaCode: '060407',
                areaName: '昆明市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040701',
                        areaName: '安宁市',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040702',
                        areaName: '呈贡区',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040703',
                        areaName: '东川区',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040704',
                        areaName: '富民县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040705',
                        areaName: '官渡区',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040706',
                        areaName: '晋宁县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040707',
                        areaName: '禄劝彝族苗族自治县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040708',
                        areaName: '盘龙区',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040709',
                        areaName: '石林彝族自治县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040710',
                        areaName: '嵩明县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040711',
                        areaName: '五华区',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040712',
                        areaName: '西山区',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040713',
                        areaName: '寻甸回族彝族自治县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                    {
                        areaCode: '06040714',
                        areaName: '宜良县',
                        areaLevel: '4',
                        parentCode: '060407',
                    },
                ],
            },
            {
                areaCode: '060408',
                areaName: '丽江市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040801',
                        areaName: '古城区',
                        areaLevel: '4',
                        parentCode: '060408',
                    },
                    {
                        areaCode: '06040802',
                        areaName: '华坪县',
                        areaLevel: '4',
                        parentCode: '060408',
                    },
                    {
                        areaCode: '06040803',
                        areaName: '宁蒗彝族自治县',
                        areaLevel: '4',
                        parentCode: '060408',
                    },
                    {
                        areaCode: '06040804',
                        areaName: '永胜县',
                        areaLevel: '4',
                        parentCode: '060408',
                    },
                    {
                        areaCode: '06040805',
                        areaName: '玉龙纳西族自治县',
                        areaLevel: '4',
                        parentCode: '060408',
                    },
                ],
            },
            {
                areaCode: '060409',
                areaName: '临沧市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06040901',
                        areaName: '沧源佤族自治县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040902',
                        areaName: '凤庆县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040903',
                        areaName: '耿马傣族佤族自治县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040904',
                        areaName: '临翔区',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040905',
                        areaName: '双江拉祜族佤族布朗族傣族自治县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040906',
                        areaName: '永德县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040907',
                        areaName: '云县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                    {
                        areaCode: '06040908',
                        areaName: '镇康县',
                        areaLevel: '4',
                        parentCode: '060409',
                    },
                ],
            },
            {
                areaCode: '060410',
                areaName: '怒江傈僳族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041001',
                        areaName: '福贡县',
                        areaLevel: '4',
                        parentCode: '060410',
                    },
                    {
                        areaCode: '06041002',
                        areaName: '贡山独龙族怒族自治县',
                        areaLevel: '4',
                        parentCode: '060410',
                    },
                    {
                        areaCode: '06041003',
                        areaName: '兰坪白族普米族自治县',
                        areaLevel: '4',
                        parentCode: '060410',
                    },
                    {
                        areaCode: '06041004',
                        areaName: '泸水县',
                        areaLevel: '4',
                        parentCode: '060410',
                    },
                ],
            },
            {
                areaCode: '060411',
                areaName: '普洱市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041101',
                        areaName: '江城哈尼族彝族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041102',
                        areaName: '景东彝族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041103',
                        areaName: '景谷傣族彝族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041104',
                        areaName: '澜沧拉祜族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041105',
                        areaName: '孟连傣族拉祜族佤族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041106',
                        areaName: '墨江哈尼族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041107',
                        areaName: '宁洱哈尼族彝族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041108',
                        areaName: '思茅区',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041109',
                        areaName: '西盟佤族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                    {
                        areaCode: '06041110',
                        areaName: '镇沅彝族哈尼族拉祜族自治县',
                        areaLevel: '4',
                        parentCode: '060411',
                    },
                ],
            },
            {
                areaCode: '060412',
                areaName: '曲靖市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041201',
                        areaName: '富源县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041202',
                        areaName: '会泽县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041203',
                        areaName: '陆良县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041204',
                        areaName: '罗平县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041205',
                        areaName: '马龙县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041206',
                        areaName: '麒麟区',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041207',
                        areaName: '师宗县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041208',
                        areaName: '宣威市',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                    {
                        areaCode: '06041209',
                        areaName: '沾益县',
                        areaLevel: '4',
                        parentCode: '060412',
                    },
                ],
            },
            {
                areaCode: '060413',
                areaName: '文山壮族苗族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041301',
                        areaName: '富宁县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041302',
                        areaName: '广南县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041303',
                        areaName: '马关县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041304',
                        areaName: '麻栗坡县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041305',
                        areaName: '丘北县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041306',
                        areaName: '文山市',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041307',
                        areaName: '西畴县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                    {
                        areaCode: '06041308',
                        areaName: '砚山县',
                        areaLevel: '4',
                        parentCode: '060413',
                    },
                ],
            },
            {
                areaCode: '060414',
                areaName: '西双版纳傣族自治州',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041401',
                        areaName: '景洪市',
                        areaLevel: '4',
                        parentCode: '060414',
                    },
                    {
                        areaCode: '06041402',
                        areaName: '勐海县',
                        areaLevel: '4',
                        parentCode: '060414',
                    },
                    {
                        areaCode: '06041403',
                        areaName: '勐腊县',
                        areaLevel: '4',
                        parentCode: '060414',
                    },
                ],
            },
            {
                areaCode: '060415',
                areaName: '玉溪市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041501',
                        areaName: '澄江县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041502',
                        areaName: '峨山彝族自治县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041503',
                        areaName: '红塔区',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041504',
                        areaName: '华宁县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041505',
                        areaName: '江川县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041506',
                        areaName: '通海县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041507',
                        areaName: '新平彝族傣族自治县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041508',
                        areaName: '易门县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                    {
                        areaCode: '06041509',
                        areaName: '元江哈尼族彝族傣族自治县',
                        areaLevel: '4',
                        parentCode: '060415',
                    },
                ],
            },
            {
                areaCode: '060416',
                areaName: '昭通市',
                areaLevel: '3',
                parentCode: '0604',
                children: [
                    {
                        areaCode: '06041601',
                        areaName: '大关县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041602',
                        areaName: '鲁甸县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041603',
                        areaName: '巧家县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041604',
                        areaName: '水富县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041605',
                        areaName: '绥江县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041606',
                        areaName: '威信县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041607',
                        areaName: '盐津县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041608',
                        areaName: '彝良县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041609',
                        areaName: '永善县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041610',
                        areaName: '昭阳区',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                    {
                        areaCode: '06041611',
                        areaName: '镇雄县',
                        areaLevel: '4',
                        parentCode: '060416',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0605',
        areaName: '西藏自治区',
        areaLevel: '2',
        parentCode: '06',
        children: [
            {
                areaCode: '060501',
                areaName: '阿里地区',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050101',
                        areaName: '措勤县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                    {
                        areaCode: '06050102',
                        areaName: '噶尔县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                    {
                        areaCode: '06050103',
                        areaName: '改则县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                    {
                        areaCode: '06050104',
                        areaName: '革吉县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                    {
                        areaCode: '06050105',
                        areaName: '普兰县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                    {
                        areaCode: '06050106',
                        areaName: '日土县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                    {
                        areaCode: '06050107',
                        areaName: '札达县',
                        areaLevel: '4',
                        parentCode: '060501',
                    },
                ],
            },
            {
                areaCode: '060502',
                areaName: '昌都市',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050201',
                        areaName: '八宿县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050202',
                        areaName: '边坝县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050203',
                        areaName: '察雅县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050204',
                        areaName: '丁青县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050205',
                        areaName: '贡觉县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050206',
                        areaName: '江达县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050207',
                        areaName: '卡若区',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050208',
                        areaName: '类乌齐县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050209',
                        areaName: '洛隆县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050210',
                        areaName: '芒康县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                    {
                        areaCode: '06050211',
                        areaName: '左贡县',
                        areaLevel: '4',
                        parentCode: '060502',
                    },
                ],
            },
            {
                areaCode: '060503',
                areaName: '拉萨市',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050301',
                        areaName: '城关区',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050302',
                        areaName: '当雄县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050303',
                        areaName: '达孜县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050304',
                        areaName: '堆龙德庆县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050305',
                        areaName: '林周县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050306',
                        areaName: '墨竹工卡县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050307',
                        areaName: '尼木县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                    {
                        areaCode: '06050308',
                        areaName: '曲水县',
                        areaLevel: '4',
                        parentCode: '060503',
                    },
                ],
            },
            {
                areaCode: '060504',
                areaName: '林芝市',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050401',
                        areaName: '巴宜区',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                    {
                        areaCode: '06050402',
                        areaName: '波密县',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                    {
                        areaCode: '06050403',
                        areaName: '察隅县',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                    {
                        areaCode: '06050404',
                        areaName: '工布江达县',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                    {
                        areaCode: '06050405',
                        areaName: '朗县',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                    {
                        areaCode: '06050406',
                        areaName: '米林县',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                    {
                        areaCode: '06050407',
                        areaName: '墨脱县',
                        areaLevel: '4',
                        parentCode: '060504',
                    },
                ],
            },
            {
                areaCode: '060505',
                areaName: '那曲地区',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050501',
                        areaName: '安多县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050502',
                        areaName: '班戈县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050503',
                        areaName: '巴青县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050504',
                        areaName: '比如县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050505',
                        areaName: '嘉黎县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050506',
                        areaName: '那曲县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050507',
                        areaName: '聂荣县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050508',
                        areaName: '尼玛县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050509',
                        areaName: '申扎县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050510',
                        areaName: '双湖县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                    {
                        areaCode: '06050511',
                        areaName: '索县',
                        areaLevel: '4',
                        parentCode: '060505',
                    },
                ],
            },
            {
                areaCode: '060506',
                areaName: '日喀则市',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050601',
                        areaName: '昂仁县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050602',
                        areaName: '白朗县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050603',
                        areaName: '定结县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050604',
                        areaName: '定日县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050605',
                        areaName: '岗巴县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050606',
                        areaName: '江孜县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050607',
                        areaName: '吉隆县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050608',
                        areaName: '康马县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050609',
                        areaName: '拉孜县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050610',
                        areaName: '南木林县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050611',
                        areaName: '聂拉木县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050612',
                        areaName: '仁布县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050613',
                        areaName: '萨嘎县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050614',
                        areaName: '萨迦县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050615',
                        areaName: '桑珠孜区',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050616',
                        areaName: '谢通门县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050617',
                        areaName: '亚东县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                    {
                        areaCode: '06050618',
                        areaName: '仲巴县',
                        areaLevel: '4',
                        parentCode: '060506',
                    },
                ],
            },
            {
                areaCode: '060507',
                areaName: '山南地区',
                areaLevel: '3',
                parentCode: '0605',
                children: [
                    {
                        areaCode: '06050701',
                        areaName: '措美县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050702',
                        areaName: '错那县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050703',
                        areaName: '贡嘎县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050704',
                        areaName: '加查县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050705',
                        areaName: '浪卡子县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050706',
                        areaName: '隆子县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050707',
                        areaName: '洛扎县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050708',
                        areaName: '乃东县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050709',
                        areaName: '琼结县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050710',
                        areaName: '曲松县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050711',
                        areaName: '桑日县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                    {
                        areaCode: '06050712',
                        areaName: '扎囊县',
                        areaLevel: '4',
                        parentCode: '060507',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0701',
        areaName: '陕西省',
        areaLevel: '2',
        parentCode: '07',
        children: [
            {
                areaCode: '070101',
                areaName: '安康市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010101',
                        areaName: '白河县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010102',
                        areaName: '汉滨区',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010103',
                        areaName: '汉阴县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010104',
                        areaName: '岚皋县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010105',
                        areaName: '宁陕县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010106',
                        areaName: '平利县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010107',
                        areaName: '石泉县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010108',
                        areaName: '旬阳县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010109',
                        areaName: '镇坪县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                    {
                        areaCode: '07010110',
                        areaName: '紫阳县',
                        areaLevel: '4',
                        parentCode: '070101',
                    },
                ],
            },
            {
                areaCode: '070102',
                areaName: '宝鸡市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010201',
                        areaName: '陈仓区',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010202',
                        areaName: '凤县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010203',
                        areaName: '凤翔县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010204',
                        areaName: '扶风县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010205',
                        areaName: '金台区',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010206',
                        areaName: '麟游县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010207',
                        areaName: '陇县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010208',
                        areaName: '眉县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010209',
                        areaName: '千阳县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010210',
                        areaName: '岐山县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010211',
                        areaName: '太白县',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                    {
                        areaCode: '07010212',
                        areaName: '渭滨区',
                        areaLevel: '4',
                        parentCode: '070102',
                    },
                ],
            },
            {
                areaCode: '070103',
                areaName: '汉中市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010301',
                        areaName: '城固县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010302',
                        areaName: '佛坪县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010303',
                        areaName: '汉台区',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010304',
                        areaName: '留坝县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010305',
                        areaName: '略阳县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010306',
                        areaName: '勉县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010307',
                        areaName: '南郑县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010308',
                        areaName: '宁强县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010309',
                        areaName: '西乡县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010310',
                        areaName: '洋县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                    {
                        areaCode: '07010311',
                        areaName: '镇巴县',
                        areaLevel: '4',
                        parentCode: '070103',
                    },
                ],
            },
            {
                areaCode: '070104',
                areaName: '商洛市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010401',
                        areaName: '丹凤县',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                    {
                        areaCode: '07010402',
                        areaName: '洛南县',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                    {
                        areaCode: '07010403',
                        areaName: '商南县',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                    {
                        areaCode: '07010404',
                        areaName: '商州区',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                    {
                        areaCode: '07010405',
                        areaName: '山阳县',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                    {
                        areaCode: '07010406',
                        areaName: '柞水县',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                    {
                        areaCode: '07010407',
                        areaName: '镇安县',
                        areaLevel: '4',
                        parentCode: '070104',
                    },
                ],
            },
            {
                areaCode: '070105',
                areaName: '铜川市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010501',
                        areaName: '王益区',
                        areaLevel: '4',
                        parentCode: '070105',
                    },
                    {
                        areaCode: '07010502',
                        areaName: '耀州区',
                        areaLevel: '4',
                        parentCode: '070105',
                    },
                    {
                        areaCode: '07010503',
                        areaName: '宜君县',
                        areaLevel: '4',
                        parentCode: '070105',
                    },
                    {
                        areaCode: '07010504',
                        areaName: '印台区',
                        areaLevel: '4',
                        parentCode: '070105',
                    },
                ],
            },
            {
                areaCode: '070106',
                areaName: '渭南市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010601',
                        areaName: '白水县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010602',
                        areaName: '澄城县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010603',
                        areaName: '大荔县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010604',
                        areaName: '富平县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010605',
                        areaName: '韩城市',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010606',
                        areaName: '合阳县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010607',
                        areaName: '华县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010608',
                        areaName: '华阴市',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010609',
                        areaName: '临渭区',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010610',
                        areaName: '蒲城县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                    {
                        areaCode: '07010611',
                        areaName: '潼关县',
                        areaLevel: '4',
                        parentCode: '070106',
                    },
                ],
            },
            {
                areaCode: '070107',
                areaName: '西安市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010701',
                        areaName: '灞桥区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010702',
                        areaName: '碑林区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010703',
                        areaName: '长安区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010704',
                        areaName: '高陵区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010705',
                        areaName: '户县',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010706',
                        areaName: '蓝田县',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010707',
                        areaName: '莲湖区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010708',
                        areaName: '临潼区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010709',
                        areaName: '未央区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010710',
                        areaName: '新城区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010711',
                        areaName: '阎良区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010712',
                        areaName: '雁塔区',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                    {
                        areaCode: '07010713',
                        areaName: '周至县',
                        areaLevel: '4',
                        parentCode: '070107',
                    },
                ],
            },
            {
                areaCode: '070108',
                areaName: '咸阳市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010801',
                        areaName: '彬县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010802',
                        areaName: '长武县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010803',
                        areaName: '淳化县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010804',
                        areaName: '泾阳县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010805',
                        areaName: '礼泉县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010806',
                        areaName: '乾县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010807',
                        areaName: '秦都区',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010808',
                        areaName: '三原县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010809',
                        areaName: '渭城区',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010810',
                        areaName: '武功县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010811',
                        areaName: '兴平市',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010812',
                        areaName: '旬邑县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010813',
                        areaName: '杨陵区',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                    {
                        areaCode: '07010814',
                        areaName: '永寿县',
                        areaLevel: '4',
                        parentCode: '070108',
                    },
                ],
            },
            {
                areaCode: '070109',
                areaName: '延安市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07010901',
                        areaName: '安塞县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010902',
                        areaName: '宝塔区',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010903',
                        areaName: '富县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010904',
                        areaName: '甘泉县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010905',
                        areaName: '黄陵县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010906',
                        areaName: '黄龙县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010907',
                        areaName: '洛川县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010908',
                        areaName: '吴起县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010909',
                        areaName: '延长县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010910',
                        areaName: '延川县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010911',
                        areaName: '宜川县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010912',
                        areaName: '志丹县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                    {
                        areaCode: '07010913',
                        areaName: '子长县',
                        areaLevel: '4',
                        parentCode: '070109',
                    },
                ],
            },
            {
                areaCode: '070110',
                areaName: '榆林市',
                areaLevel: '3',
                parentCode: '0701',
                children: [
                    {
                        areaCode: '07011001',
                        areaName: '定边县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011002',
                        areaName: '府谷县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011003',
                        areaName: '横山县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011004',
                        areaName: '佳县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011005',
                        areaName: '靖边县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011006',
                        areaName: '米脂县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011007',
                        areaName: '清涧县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011008',
                        areaName: '神木县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011009',
                        areaName: '绥德县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011010',
                        areaName: '吴堡县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011011',
                        areaName: '榆阳区',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                    {
                        areaCode: '07011012',
                        areaName: '子洲县',
                        areaLevel: '4',
                        parentCode: '070110',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0702',
        areaName: '甘肃省',
        areaLevel: '2',
        parentCode: '07',
        children: [
            {
                areaCode: '070201',
                areaName: '白银市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020101',
                        areaName: '白银区',
                        areaLevel: '4',
                        parentCode: '070201',
                    },
                    {
                        areaCode: '07020102',
                        areaName: '会宁县',
                        areaLevel: '4',
                        parentCode: '070201',
                    },
                    {
                        areaCode: '07020103',
                        areaName: '景泰县',
                        areaLevel: '4',
                        parentCode: '070201',
                    },
                    {
                        areaCode: '07020104',
                        areaName: '靖远县',
                        areaLevel: '4',
                        parentCode: '070201',
                    },
                    {
                        areaCode: '07020105',
                        areaName: '平川区',
                        areaLevel: '4',
                        parentCode: '070201',
                    },
                ],
            },
            {
                areaCode: '070202',
                areaName: '定西市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020201',
                        areaName: '安定区',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                    {
                        areaCode: '07020202',
                        areaName: '临洮县',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                    {
                        areaCode: '07020203',
                        areaName: '陇西县',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                    {
                        areaCode: '07020204',
                        areaName: '岷县',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                    {
                        areaCode: '07020205',
                        areaName: '通渭县',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                    {
                        areaCode: '07020206',
                        areaName: '渭源县',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                    {
                        areaCode: '07020207',
                        areaName: '漳县',
                        areaLevel: '4',
                        parentCode: '070202',
                    },
                ],
            },
            {
                areaCode: '070203',
                areaName: '甘南藏族自治州',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020301',
                        areaName: '迭部县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020302',
                        areaName: '合作市',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020303',
                        areaName: '临潭县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020304',
                        areaName: '碌曲县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020305',
                        areaName: '玛曲县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020306',
                        areaName: '夏河县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020307',
                        areaName: '舟曲县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                    {
                        areaCode: '07020308',
                        areaName: '卓尼县',
                        areaLevel: '4',
                        parentCode: '070203',
                    },
                ],
            },
            {
                areaCode: '070204',
                areaName: '嘉峪关市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020401',
                        areaName: '雄关区',
                        areaLevel: '4',
                        parentCode: '070204',
                    },
                    {
                        areaCode: '07020402',
                        areaName: '长城区',
                        areaLevel: '4',
                        parentCode: '070204',
                    },
                    {
                        areaCode: '07020403',
                        areaName: '镜铁区',
                        areaLevel: '4',
                        parentCode: '070204',
                    },
                ],
            },
            {
                areaCode: '070205',
                areaName: '金昌市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020501',
                        areaName: '金川区',
                        areaLevel: '4',
                        parentCode: '070205',
                    },
                    {
                        areaCode: '07020502',
                        areaName: '永昌县',
                        areaLevel: '4',
                        parentCode: '070205',
                    },
                ],
            },
            {
                areaCode: '070206',
                areaName: '酒泉市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020601',
                        areaName: '阿克塞哈萨克族自治县',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                    {
                        areaCode: '07020602',
                        areaName: '敦煌市',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                    {
                        areaCode: '07020603',
                        areaName: '瓜州县',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                    {
                        areaCode: '07020604',
                        areaName: '金塔县',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                    {
                        areaCode: '07020605',
                        areaName: '肃北蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                    {
                        areaCode: '07020606',
                        areaName: '肃州区',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                    {
                        areaCode: '07020607',
                        areaName: '玉门市',
                        areaLevel: '4',
                        parentCode: '070206',
                    },
                ],
            },
            {
                areaCode: '070207',
                areaName: '兰州市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020701',
                        areaName: '安宁区',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020702',
                        areaName: '城关区',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020703',
                        areaName: '皋兰县',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020704',
                        areaName: '红古区',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020705',
                        areaName: '七里河区',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020706',
                        areaName: '西固区',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020707',
                        areaName: '永登县',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                    {
                        areaCode: '07020708',
                        areaName: '榆中县',
                        areaLevel: '4',
                        parentCode: '070207',
                    },
                ],
            },
            {
                areaCode: '070208',
                areaName: '临夏回族自治州',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020801',
                        areaName: '东乡族自治县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020802',
                        areaName: '广河县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020803',
                        areaName: '和政县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020804',
                        areaName: '积石山保安族东乡族撒拉族自治县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020805',
                        areaName: '康乐县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020806',
                        areaName: '临夏市',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020807',
                        areaName: '临夏县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                    {
                        areaCode: '07020808',
                        areaName: '永靖县',
                        areaLevel: '4',
                        parentCode: '070208',
                    },
                ],
            },
            {
                areaCode: '070209',
                areaName: '陇南市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07020901',
                        areaName: '成县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020902',
                        areaName: '宕昌县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020903',
                        areaName: '徽县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020904',
                        areaName: '康县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020905',
                        areaName: '两当县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020906',
                        areaName: '礼县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020907',
                        areaName: '文县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020908',
                        areaName: '武都区',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                    {
                        areaCode: '07020909',
                        areaName: '西和县',
                        areaLevel: '4',
                        parentCode: '070209',
                    },
                ],
            },
            {
                areaCode: '070210',
                areaName: '平凉市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07021001',
                        areaName: '崇信县',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                    {
                        areaCode: '07021002',
                        areaName: '华亭县',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                    {
                        areaCode: '07021003',
                        areaName: '泾川县',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                    {
                        areaCode: '07021004',
                        areaName: '静宁县',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                    {
                        areaCode: '07021005',
                        areaName: '崆峒区',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                    {
                        areaCode: '07021006',
                        areaName: '灵台县',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                    {
                        areaCode: '07021007',
                        areaName: '庄浪县',
                        areaLevel: '4',
                        parentCode: '070210',
                    },
                ],
            },
            {
                areaCode: '070211',
                areaName: '庆阳市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07021101',
                        areaName: '合水县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021102',
                        areaName: '华池县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021103',
                        areaName: '环县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021104',
                        areaName: '宁县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021105',
                        areaName: '庆城县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021106',
                        areaName: '西峰区',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021107',
                        areaName: '正宁县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                    {
                        areaCode: '07021108',
                        areaName: '镇原县',
                        areaLevel: '4',
                        parentCode: '070211',
                    },
                ],
            },
            {
                areaCode: '070212',
                areaName: '天水市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07021201',
                        areaName: '甘谷县',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                    {
                        areaCode: '07021202',
                        areaName: '麦积区',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                    {
                        areaCode: '07021203',
                        areaName: '秦安县',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                    {
                        areaCode: '07021204',
                        areaName: '清水县',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                    {
                        areaCode: '07021205',
                        areaName: '秦州区',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                    {
                        areaCode: '07021206',
                        areaName: '武山县',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                    {
                        areaCode: '07021207',
                        areaName: '张家川回族自治县',
                        areaLevel: '4',
                        parentCode: '070212',
                    },
                ],
            },
            {
                areaCode: '070213',
                areaName: '武威市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07021301',
                        areaName: '古浪县',
                        areaLevel: '4',
                        parentCode: '070213',
                    },
                    {
                        areaCode: '07021302',
                        areaName: '凉州区',
                        areaLevel: '4',
                        parentCode: '070213',
                    },
                    {
                        areaCode: '07021303',
                        areaName: '民勤县',
                        areaLevel: '4',
                        parentCode: '070213',
                    },
                    {
                        areaCode: '07021304',
                        areaName: '天祝藏族自治县',
                        areaLevel: '4',
                        parentCode: '070213',
                    },
                ],
            },
            {
                areaCode: '070214',
                areaName: '张掖市',
                areaLevel: '3',
                parentCode: '0702',
                children: [
                    {
                        areaCode: '07021401',
                        areaName: '甘州区',
                        areaLevel: '4',
                        parentCode: '070214',
                    },
                    {
                        areaCode: '07021402',
                        areaName: '高台县',
                        areaLevel: '4',
                        parentCode: '070214',
                    },
                    {
                        areaCode: '07021403',
                        areaName: '临泽县',
                        areaLevel: '4',
                        parentCode: '070214',
                    },
                    {
                        areaCode: '07021404',
                        areaName: '民乐县',
                        areaLevel: '4',
                        parentCode: '070214',
                    },
                    {
                        areaCode: '07021405',
                        areaName: '山丹县',
                        areaLevel: '4',
                        parentCode: '070214',
                    },
                    {
                        areaCode: '07021406',
                        areaName: '肃南裕固族自治县',
                        areaLevel: '4',
                        parentCode: '070214',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0703',
        areaName: '青海省',
        areaLevel: '2',
        parentCode: '07',
        children: [
            {
                areaCode: '070301',
                areaName: '果洛藏族自治州',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030101',
                        areaName: '班玛县',
                        areaLevel: '4',
                        parentCode: '070301',
                    },
                    {
                        areaCode: '07030102',
                        areaName: '达日县',
                        areaLevel: '4',
                        parentCode: '070301',
                    },
                    {
                        areaCode: '07030103',
                        areaName: '甘德县',
                        areaLevel: '4',
                        parentCode: '070301',
                    },
                    {
                        areaCode: '07030104',
                        areaName: '久治县',
                        areaLevel: '4',
                        parentCode: '070301',
                    },
                    {
                        areaCode: '07030105',
                        areaName: '玛多县',
                        areaLevel: '4',
                        parentCode: '070301',
                    },
                    {
                        areaCode: '07030106',
                        areaName: '玛沁县',
                        areaLevel: '4',
                        parentCode: '070301',
                    },
                ],
            },
            {
                areaCode: '070302',
                areaName: '海北藏族自治州',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030201',
                        areaName: '刚察县',
                        areaLevel: '4',
                        parentCode: '070302',
                    },
                    {
                        areaCode: '07030202',
                        areaName: '海晏县',
                        areaLevel: '4',
                        parentCode: '070302',
                    },
                    {
                        areaCode: '07030203',
                        areaName: '门源回族自治县',
                        areaLevel: '4',
                        parentCode: '070302',
                    },
                    {
                        areaCode: '07030204',
                        areaName: '祁连县',
                        areaLevel: '4',
                        parentCode: '070302',
                    },
                ],
            },
            {
                areaCode: '070303',
                areaName: '海东市',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030301',
                        areaName: '化隆回族自治县',
                        areaLevel: '4',
                        parentCode: '070303',
                    },
                    {
                        areaCode: '07030302',
                        areaName: '互助土族自治县',
                        areaLevel: '4',
                        parentCode: '070303',
                    },
                    {
                        areaCode: '07030303',
                        areaName: '乐都区',
                        areaLevel: '4',
                        parentCode: '070303',
                    },
                    {
                        areaCode: '07030304',
                        areaName: '民和回族土族自治县',
                        areaLevel: '4',
                        parentCode: '070303',
                    },
                    {
                        areaCode: '07030305',
                        areaName: '平安区',
                        areaLevel: '4',
                        parentCode: '070303',
                    },
                    {
                        areaCode: '07030306',
                        areaName: '循化撒拉族自治县',
                        areaLevel: '4',
                        parentCode: '070303',
                    },
                ],
            },
            {
                areaCode: '070304',
                areaName: '海南藏族自治州',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030401',
                        areaName: '共和县',
                        areaLevel: '4',
                        parentCode: '070304',
                    },
                    {
                        areaCode: '07030402',
                        areaName: '贵德县',
                        areaLevel: '4',
                        parentCode: '070304',
                    },
                    {
                        areaCode: '07030403',
                        areaName: '贵南县',
                        areaLevel: '4',
                        parentCode: '070304',
                    },
                    {
                        areaCode: '07030404',
                        areaName: '同德县',
                        areaLevel: '4',
                        parentCode: '070304',
                    },
                    {
                        areaCode: '07030405',
                        areaName: '兴海县',
                        areaLevel: '4',
                        parentCode: '070304',
                    },
                ],
            },
            {
                areaCode: '070305',
                areaName: '海西蒙古族藏族自治州',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030501',
                        areaName: '德令哈市',
                        areaLevel: '4',
                        parentCode: '070305',
                    },
                    {
                        areaCode: '07030502',
                        areaName: '都兰县',
                        areaLevel: '4',
                        parentCode: '070305',
                    },
                    {
                        areaCode: '07030503',
                        areaName: '格尔木市',
                        areaLevel: '4',
                        parentCode: '070305',
                    },
                    {
                        areaCode: '07030504',
                        areaName: '天峻县',
                        areaLevel: '4',
                        parentCode: '070305',
                    },
                    {
                        areaCode: '07030505',
                        areaName: '乌兰县',
                        areaLevel: '4',
                        parentCode: '070305',
                    },
                ],
            },
            {
                areaCode: '070306',
                areaName: '黄南藏族自治州',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030601',
                        areaName: '河南蒙古族自治县',
                        areaLevel: '4',
                        parentCode: '070306',
                    },
                    {
                        areaCode: '07030602',
                        areaName: '尖扎县',
                        areaLevel: '4',
                        parentCode: '070306',
                    },
                    {
                        areaCode: '07030603',
                        areaName: '同仁县',
                        areaLevel: '4',
                        parentCode: '070306',
                    },
                    {
                        areaCode: '07030604',
                        areaName: '泽库县',
                        areaLevel: '4',
                        parentCode: '070306',
                    },
                ],
            },
            {
                areaCode: '070307',
                areaName: '西宁市',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030701',
                        areaName: '城北区',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                    {
                        areaCode: '07030702',
                        areaName: '城东区',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                    {
                        areaCode: '07030703',
                        areaName: '城西区',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                    {
                        areaCode: '07030704',
                        areaName: '城中区',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                    {
                        areaCode: '07030705',
                        areaName: '大通回族土族自治县',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                    {
                        areaCode: '07030706',
                        areaName: '湟源县',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                    {
                        areaCode: '07030707',
                        areaName: '湟中县',
                        areaLevel: '4',
                        parentCode: '070307',
                    },
                ],
            },
            {
                areaCode: '070308',
                areaName: '玉树藏族自治州',
                areaLevel: '3',
                parentCode: '0703',
                children: [
                    {
                        areaCode: '07030801',
                        areaName: '称多县',
                        areaLevel: '4',
                        parentCode: '070308',
                    },
                    {
                        areaCode: '07030802',
                        areaName: '囊谦县',
                        areaLevel: '4',
                        parentCode: '070308',
                    },
                    {
                        areaCode: '07030803',
                        areaName: '曲麻莱县',
                        areaLevel: '4',
                        parentCode: '070308',
                    },
                    {
                        areaCode: '07030804',
                        areaName: '玉树市',
                        areaLevel: '4',
                        parentCode: '070308',
                    },
                    {
                        areaCode: '07030805',
                        areaName: '杂多县',
                        areaLevel: '4',
                        parentCode: '070308',
                    },
                    {
                        areaCode: '07030806',
                        areaName: '治多县',
                        areaLevel: '4',
                        parentCode: '070308',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0704',
        areaName: '宁夏回族自治区',
        areaLevel: '2',
        parentCode: '07',
        children: [
            {
                areaCode: '070401',
                areaName: '固原市',
                areaLevel: '3',
                parentCode: '0704',
                children: [
                    {
                        areaCode: '07040101',
                        areaName: '泾源县',
                        areaLevel: '4',
                        parentCode: '070401',
                    },
                    {
                        areaCode: '07040102',
                        areaName: '隆德县',
                        areaLevel: '4',
                        parentCode: '070401',
                    },
                    {
                        areaCode: '07040103',
                        areaName: '彭阳县',
                        areaLevel: '4',
                        parentCode: '070401',
                    },
                    {
                        areaCode: '07040104',
                        areaName: '西吉县',
                        areaLevel: '4',
                        parentCode: '070401',
                    },
                    {
                        areaCode: '07040105',
                        areaName: '原州区',
                        areaLevel: '4',
                        parentCode: '070401',
                    },
                ],
            },
            {
                areaCode: '070402',
                areaName: '石嘴山市',
                areaLevel: '3',
                parentCode: '0704',
                children: [
                    {
                        areaCode: '07040201',
                        areaName: '大武口区',
                        areaLevel: '4',
                        parentCode: '070402',
                    },
                    {
                        areaCode: '07040202',
                        areaName: '惠农区',
                        areaLevel: '4',
                        parentCode: '070402',
                    },
                    {
                        areaCode: '07040203',
                        areaName: '平罗县',
                        areaLevel: '4',
                        parentCode: '070402',
                    },
                ],
            },
            {
                areaCode: '070403',
                areaName: '吴忠市',
                areaLevel: '3',
                parentCode: '0704',
                children: [
                    {
                        areaCode: '07040301',
                        areaName: '红寺堡区',
                        areaLevel: '4',
                        parentCode: '070403',
                    },
                    {
                        areaCode: '07040302',
                        areaName: '利通区',
                        areaLevel: '4',
                        parentCode: '070403',
                    },
                    {
                        areaCode: '07040303',
                        areaName: '青铜峡市',
                        areaLevel: '4',
                        parentCode: '070403',
                    },
                    {
                        areaCode: '07040304',
                        areaName: '同心县',
                        areaLevel: '4',
                        parentCode: '070403',
                    },
                    {
                        areaCode: '07040305',
                        areaName: '盐池县',
                        areaLevel: '4',
                        parentCode: '070403',
                    },
                ],
            },
            {
                areaCode: '070404',
                areaName: '银川市',
                areaLevel: '3',
                parentCode: '0704',
                children: [
                    {
                        areaCode: '07040401',
                        areaName: '贺兰县',
                        areaLevel: '4',
                        parentCode: '070404',
                    },
                    {
                        areaCode: '07040402',
                        areaName: '金凤区',
                        areaLevel: '4',
                        parentCode: '070404',
                    },
                    {
                        areaCode: '07040403',
                        areaName: '灵武市',
                        areaLevel: '4',
                        parentCode: '070404',
                    },
                    {
                        areaCode: '07040404',
                        areaName: '兴庆区',
                        areaLevel: '4',
                        parentCode: '070404',
                    },
                    {
                        areaCode: '07040405',
                        areaName: '西夏区',
                        areaLevel: '4',
                        parentCode: '070404',
                    },
                    {
                        areaCode: '07040406',
                        areaName: '永宁县',
                        areaLevel: '4',
                        parentCode: '070404',
                    },
                ],
            },
            {
                areaCode: '070405',
                areaName: '中卫市',
                areaLevel: '3',
                parentCode: '0704',
                children: [
                    {
                        areaCode: '07040501',
                        areaName: '海原县',
                        areaLevel: '4',
                        parentCode: '070405',
                    },
                    {
                        areaCode: '07040502',
                        areaName: '沙坡头区',
                        areaLevel: '4',
                        parentCode: '070405',
                    },
                    {
                        areaCode: '07040503',
                        areaName: '中宁县',
                        areaLevel: '4',
                        parentCode: '070405',
                    },
                ],
            },
        ],
    },
    {
        areaCode: '0705',
        areaName: '新疆维吾尔自治区',
        areaLevel: '2',
        parentCode: '07',
        children: [
            {
                areaCode: '070501',
                areaName: '阿克苏地区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050101',
                        areaName: '阿克苏市',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050102',
                        areaName: '阿瓦提县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050103',
                        areaName: '拜城县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050104',
                        areaName: '柯坪县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050105',
                        areaName: '库车县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050106',
                        areaName: '沙雅县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050107',
                        areaName: '温宿县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050108',
                        areaName: '乌什县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                    {
                        areaCode: '07050109',
                        areaName: '新和县',
                        areaLevel: '4',
                        parentCode: '070501',
                    },
                ],
            },
            {
                areaCode: '070502',
                areaName: '阿勒泰地区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050201',
                        areaName: '阿勒泰市',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                    {
                        areaCode: '07050202',
                        areaName: '布尔津县',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                    {
                        areaCode: '07050203',
                        areaName: '福海县',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                    {
                        areaCode: '07050204',
                        areaName: '富蕴县',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                    {
                        areaCode: '07050205',
                        areaName: '哈巴河县',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                    {
                        areaCode: '07050206',
                        areaName: '吉木乃县',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                    {
                        areaCode: '07050207',
                        areaName: '青河县',
                        areaLevel: '4',
                        parentCode: '070502',
                    },
                ],
            },
            {
                areaCode: '070503',
                areaName: '巴音郭楞蒙古自治州',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050301',
                        areaName: '博湖县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050302',
                        areaName: '和静县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050303',
                        areaName: '和硕县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050304',
                        areaName: '库尔勒市',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050305',
                        areaName: '轮台县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050306',
                        areaName: '且末县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050307',
                        areaName: '若羌县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050308',
                        areaName: '尉犁县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                    {
                        areaCode: '07050309',
                        areaName: '焉耆回族自治县',
                        areaLevel: '4',
                        parentCode: '070503',
                    },
                ],
            },
            {
                areaCode: '070504',
                areaName: '博尔塔拉蒙古自治州',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050401',
                        areaName: '阿拉山口市',
                        areaLevel: '4',
                        parentCode: '070504',
                    },
                    {
                        areaCode: '07050402',
                        areaName: '博乐市',
                        areaLevel: '4',
                        parentCode: '070504',
                    },
                    {
                        areaCode: '07050403',
                        areaName: '精河县',
                        areaLevel: '4',
                        parentCode: '070504',
                    },
                    {
                        areaCode: '07050404',
                        areaName: '温泉县',
                        areaLevel: '4',
                        parentCode: '070504',
                    },
                ],
            },
            {
                areaCode: '070505',
                areaName: '昌吉回族自治州',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050501',
                        areaName: '昌吉市',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                    {
                        areaCode: '07050502',
                        areaName: '阜康市',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                    {
                        areaCode: '07050503',
                        areaName: '呼图壁县',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                    {
                        areaCode: '07050504',
                        areaName: '吉木萨尔县',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                    {
                        areaCode: '07050505',
                        areaName: '玛纳斯县',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                    {
                        areaCode: '07050506',
                        areaName: '木垒哈萨克自治县',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                    {
                        areaCode: '07050507',
                        areaName: '奇台县',
                        areaLevel: '4',
                        parentCode: '070505',
                    },
                ],
            },
            {
                areaCode: '070506',
                areaName: '哈密地区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050601',
                        areaName: '巴里坤哈萨克自治县',
                        areaLevel: '4',
                        parentCode: '070506',
                    },
                    {
                        areaCode: '07050602',
                        areaName: '哈密市',
                        areaLevel: '4',
                        parentCode: '070506',
                    },
                    {
                        areaCode: '07050603',
                        areaName: '伊吾县',
                        areaLevel: '4',
                        parentCode: '070506',
                    },
                ],
            },
            {
                areaCode: '070507',
                areaName: '和田地区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050701',
                        areaName: '策勒县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050702',
                        areaName: '和田市',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050703',
                        areaName: '和田县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050704',
                        areaName: '洛浦县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050705',
                        areaName: '民丰县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050706',
                        areaName: '墨玉县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050707',
                        areaName: '皮山县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                    {
                        areaCode: '07050708',
                        areaName: '于田县',
                        areaLevel: '4',
                        parentCode: '070507',
                    },
                ],
            },
            {
                areaCode: '070508',
                areaName: '喀什地区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050801',
                        areaName: '巴楚县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050802',
                        areaName: '伽师县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050803',
                        areaName: '喀什市',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050804',
                        areaName: '麦盖提县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050805',
                        areaName: '莎车县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050806',
                        areaName: '疏附县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050807',
                        areaName: '疏勒县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050808',
                        areaName: '塔什库尔干塔吉克自治县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050809',
                        areaName: '叶城县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050810',
                        areaName: '英吉沙县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050811',
                        areaName: '岳普湖县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                    {
                        areaCode: '07050812',
                        areaName: '泽普县',
                        areaLevel: '4',
                        parentCode: '070508',
                    },
                ],
            },
            {
                areaCode: '070509',
                areaName: '克拉玛依市',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07050901',
                        areaName: '白碱滩区',
                        areaLevel: '4',
                        parentCode: '070509',
                    },
                    {
                        areaCode: '07050902',
                        areaName: '独山子区',
                        areaLevel: '4',
                        parentCode: '070509',
                    },
                    {
                        areaCode: '07050903',
                        areaName: '克拉玛依区',
                        areaLevel: '4',
                        parentCode: '070509',
                    },
                    {
                        areaCode: '07050904',
                        areaName: '乌尔禾区',
                        areaLevel: '4',
                        parentCode: '070509',
                    },
                ],
            },
            {
                areaCode: '070510',
                areaName: '克孜勒苏柯尔克孜自治州',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07051001',
                        areaName: '阿合奇县',
                        areaLevel: '4',
                        parentCode: '070510',
                    },
                    {
                        areaCode: '07051002',
                        areaName: '阿克陶县',
                        areaLevel: '4',
                        parentCode: '070510',
                    },
                    {
                        areaCode: '07051003',
                        areaName: '阿图什市',
                        areaLevel: '4',
                        parentCode: '070510',
                    },
                    {
                        areaCode: '07051004',
                        areaName: '乌恰县',
                        areaLevel: '4',
                        parentCode: '070510',
                    },
                ],
            },
            {
                areaCode: '070511',
                areaName: '塔城地区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07051101',
                        areaName: '额敏县',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                    {
                        areaCode: '07051102',
                        areaName: '和布克赛尔蒙古自治县',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                    {
                        areaCode: '07051103',
                        areaName: '沙湾县',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                    {
                        areaCode: '07051104',
                        areaName: '塔城市',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                    {
                        areaCode: '07051105',
                        areaName: '托里县',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                    {
                        areaCode: '07051106',
                        areaName: '乌苏市',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                    {
                        areaCode: '07051107',
                        areaName: '裕民县',
                        areaLevel: '4',
                        parentCode: '070511',
                    },
                ],
            },
            {
                areaCode: '070512',
                areaName: '吐鲁番市',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07051201',
                        areaName: '高昌区',
                        areaLevel: '4',
                        parentCode: '070512',
                    },
                    {
                        areaCode: '07051202',
                        areaName: '鄯善县',
                        areaLevel: '4',
                        parentCode: '070512',
                    },
                    {
                        areaCode: '07051203',
                        areaName: '托克逊县',
                        areaLevel: '4',
                        parentCode: '070512',
                    },
                ],
            },
            {
                areaCode: '070513',
                areaName: '乌鲁木齐市',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07051301',
                        areaName: '达坂城区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051302',
                        areaName: '米东区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051303',
                        areaName: '沙依巴克区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051304',
                        areaName: '水磨沟区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051305',
                        areaName: '天山区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051306',
                        areaName: '头屯河区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051307',
                        areaName: '乌鲁木齐县',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                    {
                        areaCode: '07051308',
                        areaName: '新市区',
                        areaLevel: '4',
                        parentCode: '070513',
                    },
                ],
            },
            {
                areaCode: '070514',
                areaName: '伊犁哈萨克自治州',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07051401',
                        areaName: '察布查尔锡伯自治县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051402',
                        areaName: '巩留县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051403',
                        areaName: '霍城县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051404',
                        areaName: '霍尔果斯市',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051405',
                        areaName: '奎屯市',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051406',
                        areaName: '尼勒克县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051407',
                        areaName: '特克斯县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051408',
                        areaName: '新源县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051409',
                        areaName: '伊宁市',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051410',
                        areaName: '伊宁县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                    {
                        areaCode: '07051411',
                        areaName: '昭苏县',
                        areaLevel: '4',
                        parentCode: '070514',
                    },
                ],
            },
            {
                areaCode: '070515',
                areaName: '自治区直辖县级行政区',
                areaLevel: '3',
                parentCode: '0705',
                children: [
                    {
                        areaCode: '07051501',
                        areaName: '阿拉尔市',
                        areaLevel: '4',
                        parentCode: '070515',
                    },
                    {
                        areaCode: '07051502',
                        areaName: '石河子市',
                        areaLevel: '4',
                        parentCode: '070515',
                    },
                    {
                        areaCode: '07051503',
                        areaName: '图木舒克市',
                        areaLevel: '4',
                        parentCode: '070515',
                    },
                    {
                        areaCode: '07051504',
                        areaName: '五家渠市',
                        areaLevel: '4',
                        parentCode: '070515',
                    },
                ],
            },
        ],
    },
];
